import React, { forwardRef, useImperativeHandle } from 'react';
import { useEffect, useState } from "react";
import "./UwPolicyRisk.scss";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, {
  CustomButtonSmall,
  CustomButtonSmallDarkBg,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import { calculateAgeFromMongoDate, fetchClientsBySearch, formatNumber, formatStringToNumberV2, generateUniqueCode, getKeyInArray, getLastXDigits, getPrefixSafe, handleOpenMap, logData, normalizeKenyaPhone, validateMotorVehicleRegn } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import AddIcon from "@mui/icons-material/Add";
import CalculateIcon from "@mui/icons-material/Calculate";
import { HiHome, HiOutlineViewList } from "react-icons/hi";
import QueueIcon from "@mui/icons-material/Queue";
import RefreshIcon from "@mui/icons-material/Refresh";
import GetAppIcon from "@mui/icons-material/GetApp";
import { FiSearch } from "react-icons/fi";
import { TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import EmailIcon from '@mui/icons-material/Email';
import TagIcon from '@mui/icons-material/Tag';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { TbCertificate } from "react-icons/tb";
import PdfPreview from '../../../components/pdfPreview/PdfPreview.jsx';
import { MdOutlineCheck, MdClear, MdEdit, MdAlternateEmail, MdPhone, MdNumbers, MdClose, MdAdd, MdSave, MdDelete, MdDownload, MdOutlineCancel } from "react-icons/md";
import { GiPresent } from "react-icons/gi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Tooltip,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import Big from "big.js";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { IoArrowRedo, IoCheckmarkDoneOutline, IoClose, IoLocationSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { BsSuitcaseLgFill } from "react-icons/bs";
import { TbUserEdit, TbUserPlus } from "react-icons/tb";
import { FaLaptopMedical } from "react-icons/fa";
import { FaPeopleLine } from "react-icons/fa6";
import { MdOutlineSmokeFree, MdGroupWork } from "react-icons/md";
import { GrStatusCriticalSmall } from "react-icons/gr";
import UwDbMovement from '../uwDbMovement/UwDbMovement.jsx';
import { useTranslation } from 'react-i18next';
import { CiImageOn } from 'react-icons/ci';
import GooglePlacesSelect from '../../../components/googlePlacesSelect/GooglePlacesSelect.jsx';
import { qilloIconMap } from "../../../utils/iconMapping";
import UwPolicyCond from '../uwPolicyCond/UwPolicyCond.jsx';
import UwPolicyExcess from '../uwPolicyExcess/UwPolicyExcess.jsx';
import { useRef } from 'react';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import ValidationMessages from '../../../components/validationMessages/ValidationMessages.jsx';
import { ScaleLoader } from 'react-spinners';
import EmailComponent from '../../../components/emailComponent/EmailComponent.jsx';
import WorkedOnBy from '../../../components/workedOnBy/WorkedOnBy.jsx';
import InitialsAvatar from '../../../components/InitialsAvatar/InitialsAvatar.jsx';
import UwPolicyCharges from '../uwPolicyCharges/UwPolicyCharges.jsx';
import ExpandableComponent from '../../../components/expandableComponent/ExpandableComponent.jsx';
import { RiMapPin5Fill } from 'react-icons/ri';

const UwPolicyRisk = forwardRef(({ quoteData, refreshQuote, profileLimitValues, setPolicyNo }, ref) => {
  const { currentTheme } = useSelector((state) => state.theme);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const { currentUser } = useSelector((state) => state.user);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [policyRisks, setPolicyRisks] = useState([]);

  const [calcultionTypes, setCalcultionTypes] = useState([
    { value: "Normal", label: "Normal" },
    { value: "Prorata", label: "Prorata" },
  ]);

  const parsedToDate = new Date(quoteData?.pl_to_date);
  const parsedFmDate = new Date(quoteData?.pl_fm_date);

  // Format the date as "yyyy-MM-dd"
  const formattedFmDate = `${parsedFmDate.getFullYear()}-${(
    parsedFmDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${parsedFmDate.getDate().toString().padStart(2, "0")}`;


  const formattedToDate = `${parsedToDate.getFullYear()}-${(
    parsedToDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${parsedToDate.getDate().toString().padStart(2, "0")}`;


  const [selectedPolicyRisk, setSelectedPolicyRisk] = useState(null);
  const [policyRiskCovers, setPolicyRiskCovers] = useState([]);
  const [selectedPolicyRiskCover, setSelectedPolicyRiskCover] = useState(null);
  const [policyRiskCoverSmi, setPolicyRiskCoverSmi] = useState([]);
  const [selectedPolicyRiskCoverSmi, setSelectedPolicyRiskCoverSmi] = useState(null);
  const [sysCodePage, setSysCodePage] = useState(0);
  const [rowsPerPageSysCode, setRowsPerPageSysCode] = useState(5);
  const [showAddSysCodes, setShowAddSysCodes] = useState(false);
  const [sysCodeSearchTerm, setSysCodeSearchTerm] = useState("");
  const [filteredSysCodesData, setFilteredSysCodesData] = useState([]);
  const [sysCodesData, setSysCodesData] = useState([]);

  const [ratesComparisonDialog, setRatesComparisonDialog] = useState(false);
  const [comparePage, setComparePage] = useState(0);
  const [rowsPerPageCompare, setRowsPerPageCompare] = useState(5);
  const [ratesComparison, setRatesComparison] = useState([]);
  const [selectedCommRate, setSelectedCommRate] = useState(null);
  const [vehicleValue, setVehicleValue] = useState("");
  const policyExcessRef = useRef(null);
  const policyCondRef = useRef(null);

  const [pdfPreviewDialogOpen, setPdfPreviewDialogOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [binaryDocid, setBinaryDocid] = useState(null);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);

  //edit insured for life module
  const [viewBeneficiaries, setViewBeneficiaries] = useState(false);
  const [editLifeEntity, setEditLifeEntity] = useState(false);
  const [editLifeEntityJoint, setEditLifeEntityJoint] = useState(false);

  const [entityAction, setEntityAction] = useState(null);
  const [riskEntity, setRiskEntity] = useState(null);
  const [riskEntityJoint, setRiskEntityJoint] = useState(null);
  const [riskBeneficiary, setRiskBeneficiary] = useState(null);

  const navigate = useNavigate();
  const [showView, setShowView] = useState("multiple");

  const [placesDialogOpen, setPlacesDialogOpen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
    param1: "",
    param2: "",
    param3: "",
    param4: "",
    param5: "",
  });
  const [showHelp, setShowHelp] = useState(null);
  const [showMovement, setShowMovement] = useState(false);


  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});

  const [basisOfClaim, setBasisOfClaim] = useState("");
  const [peril, setPeril] = useState("");

  const [cancelReasonDialog, setCancelReasonDialog] = useState(false);
  const [dmvicCancelReasons, setDmvicCancelReasons] = useState([]);
  const [selectedDmvicCancelReason, setSelectedDmvicCancelReason] = useState(null);

  const [prRiskNoteNo, setPrRiskNoteNo] = useState("");
  const [prRiskCode, setPrRiskCode] = useState("");
  const [prOrderNo, setPrOrderNo] = useState(1);
  const [prInterestEntCode, setPrInterestEntCode] = useState(null);
  const [prRiskAddress, setPrRiskAddress] = useState("");
  const [prRiskFunction, setPrRiskFunction] = useState(null);
  const [riskFunctions, setRiskFunctions] = useState([]);
  const [beneficiaryPerc, setBeneficiaryPerc] = useState(null);
  const [selectedRelationshipType, setSelectedRelationshipType] = useState(null);
  const [relationshipTypes, setRelationshipTypes] = useState([]);
  const [riCategories, setRiCategories] = useState([]);
  const [riAllocationTypes, setRiAllocationTypes] = useState([]);
  const [policySubClasses, setPolicySubClasses] = useState([]);
  const [selectedSubClass, setSelectedSubClass] = useState(null);
  const [prBondInfo, setPrBondInfo] = useState({
    bond_no: "",
    bond_type: "",
    bond_category: "",
    bond_purpose: "",
    bond_issue_date: null,
    bond_effective_date: null,
    bond_expiry_date: null,
    bond_alien_name: "",
    bond_alien_passport: "",
    bond_alien_dob: null,
    bond_alien_address: "",
    bond_alien_gender: "",
    bond_immigration_status: "",
    bond_alien_phone: "",
    bond_alien_email: "",
    bond_indemnitor: "",
    bond_indemnitor_rela: ""
  });
  const [bondTypes, setBondTypes] = useState([]);
  const [bondCategories, setBondCategories] = useState([]);
  const [bondPurposes, setBondPurposes] = useState([]);
  const [prRiskArea, setPrRiskArea] = useState(null);
  const [riskAreas, setRiskAreas] = useState([]);
  const [prRiskJurisdiction, setPrRiskJurisdiction] = useState(null);
  const [riskJurisdictions, setRiskJurisdictions] = useState([]);
  const [genders, setGenders] = useState([]);
  const [prOtherAttributes, setPrOtherAttributes] = useState([]);
  const [prFullName, setPrFullName] = useState("");
  const [prGender, setPrGender] = useState(null);
  const [prPersonDob, setPrPersonDob] = useState(null);
  const [primaryBeneficiaries, setPrimaryBeneficiaries] = useState(null);
  const [secondaryBeneficiaries, setSecondaryBeneficiaries] = useState([]);
  const [personAgeXx, setPersonAgeXx] = useState("");
  const [prPersonId, setPrPersonId] = useState("");
  const [prPersonEmail, setPrPersonEmail] = useState("");
  const [prPersonPhone, setPrPersonPhone] = useState("");
  const [prPersonOccupation, setPrPersonOccupation] = useState(null);

  const [eqZones, setEqZones] = useState([]);
  const [eqSubZones, setEqSubZones] = useState([]);
  const [floodZones, setFloodZones] = useState([]);
  const [floodSubZones, setFloodSubZones] = useState([]);

  const [shippingMode, setShippingMode] = useState(null);
  const initialMarineInfo = {
    cert_no: "",
    shipping_mode: "",
    origin_address: "",
    dest_address: "",
    origin_port: "",
    dest_port: "",
    vessel_no: "",
    flight_no: "",
    bill_of_lading_no: "",
    bill_of_lading_date: "",
    any_one_loss_limit: 0,
    single_transit_limit: 0,
    annual_carry_limit: 0,
    est_depature_date: "",
    act_depature_date: "",
    est_arrival_date: "",
    act_arrival_date: "",
    invoice_no: "",
    tranship_at: "",
    no_of_packages: "",
    marks_and_number: "",
    idf_number: "",
    supplier: "",
    clearing_agent: "",
    goods_desc: "",
  };
  const [prMarineInfo, setPrMarineInfo] = useState(initialMarineInfo);
  const [shippingModes, setShippingModes] = useState([]);
  const [ports, setPorts] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [prMemberNo, setPrMemberNo] = useState(null);
  const [prMemberFm, setPrMemberFm] = useState(null);
  const [prMemberTo, setPrMemberTo] = useState(null);
  const [prMemberStatus, setPrMemberStatus] = useState(null);
  const [prRiskDescription, setPrRiskDescription] = useState("");
  const [prClaimBasis, setPrClaimBasis] = useState([]);
  const [prPerils, setPrPerils] = useState([]);
  const [prRiskCategory, setPrRiskCategory] = useState(null);
  const [prInspected, setInspected] = useState("N");
  const [prStatus, setPrStatus] = useState("On Cover");
  const [prFmDate, setPrFmDate] = useState(formattedFmDate);
  const [prToDate, setPrToDate] = useState(formattedToDate);
  const [daysDifference, setDaysDifference] = useState(0);
  const [prVehicleRegn, setPrVehicleRegn] = useState("");
  const [prVehicleEngine, setPrVehicleEngine] = useState("");
  const [prVehicleChassis, setPrVehicleChassis] = useState("");
  const [prVehicleYom, setPrVehicleYom] = useState(0);
  const [prVehicleColor, setPrVehicleColor] = useState(null);
  const [vehicleColors, setVehicleColors] = useState([]);
  const [prLatitude, setPrLatitude] = useState(null);
  const [prLongitude, setPrLongitude] = useState(null);
  const [prPlaceName, setPrPlaceName] = useState(null);
  const [prRqCode, setPrRqCode] = useState(null);
  const [prJointRqCode, setPrJointRqCode] = useState(null);

  const [prEqZone, setPrEqZone] = useState(null);
  const [prEqSubZone, setPrEqSubZone] = useState(null);
  const [prFloodZone, setPrFloodZone] = useState(null);
  const [prFloodSubZone, setPrFloodSubZone] = useState(null);

  const [prVehicleModel, setPrVehicleModel] = useState(null);
  const [vehicleModels, setVehicleModels] = useState([]);
  const [certificateEmail, setCertificateEmail] = useState(null);
  const [prVehicleCc, setPrVehicleCc] = useState("");
  const [prVehiclePassangers, setPrVehiclePassangers] = useState(0);
  const [prVehicleTonnage, setPrVehicleTonnage] = useState(0);
  const [prVehicleUse, setPrVehicleUse] = useState(null);
  const [vehicleUse, setVehicleUse] = useState([]);
  const [prVehicleCert, setPrVehicleCert] = useState(null);
  const [vehicleCertTypes, setVehicleCertTypes] = useState([]);
  const [filteredCertTypes, setFilteredCertTypes] = useState([]);
  const [prVehicleType, setPrVehicleType] = useState(null);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [prVehicleBody, setPrVehicleBody] = useState(null);
  const [vehicleBodyTypes, setVehicleBodyTypes] = useState([]);

  const [prRemarks, setPrRemarks] = useState("");
  const [isIssueCertOpen, setIsIssueCertOpen] = useState(false);
  const [isProductScOpen, setIsProductScOpen] = useState(false);
  const [productScPage, setProductScPage] = useState(0);
  const [rowsPerPageProductSc, setRowsPerPageProductSc] = useState(5);
  const [productSubClasses, setProductSubClasses] = useState([]);
  const [selectedProductSubClass, setSelectedProductSubClass] = useState(null);
  const [searchProductSubClass, setSearchProductSubClass] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [memberStatus, setMemberStatus] = useState([]);
  const [selectedSmiForEdit, setSelectedSmiForEdit] = useState(null);
  const [medicalReports, setMedicalReports] = useState([]);
  const [showCoverForEditing, setShowCoverForEditing] = useState(false);
  const [selectedSubClassCover, setSelectedSubClassCover] = useState({});
  const [subClassCovers, setSubClassCovers] = useState([]);

  const handlePlaceSelect = (place) => {
    try {
      if (!place) {
        setSelectedPlace(null);
        setPrLatitude(null);
        setPrLongitude(null);
        setPrPlaceName(null);
      } else {
        setSelectedPlace(place);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Function to get limit_yn value by limit_code
  const getLimitValue = (limitCode) => {
    try {
      const limit = profileLimitValues.find(l => l.limit_code === limitCode);
      return limit ? limit.limit_yn : null;
    } catch (error) {
      console.log(error)
    }
  };


  const fetchSubClasses = async () => {
    try {
      const res = await newRequest.get(`/uwPolicySc/findAll/${quoteData._id}`);
      setPolicySubClasses(res.data);
      if (res.data) {
        setSelectedSubClass(res.data[0]);
      }
    } catch (error) {
      console.error("Error fetching sub classes :", error);
    }
  };


  const fetchSysCode = async (sysType) => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: sysType });
      setSysCodesData(res.data);
    } catch (error) {
      console.log(error);
    }
  };


  const handleSysCodePageChange = (event, newPage) => {
    setSysCodePage(newPage);
  };

  const handleSysCodeRowsPerPage = (event) => {
    setRowsPerPageSysCode(parseInt(event.target.value, 5));
    setSysCodePage(0);
  };

  const slicedSysCodes = filteredSysCodesData.slice(
    sysCodePage * rowsPerPageSysCode,
    sysCodePage * rowsPerPageSysCode + rowsPerPageSysCode
  );

  // compare commission rates
  const handleComparePageChange = (event, newPage) => {
    setComparePage(newPage);
  };
  const handleCompareRowsPerPage = (event) => {
    setRowsPerPageCompare(parseInt(event.target.value, 5));
    setComparePage(0);
  };

  const paginatedRates = ratesComparison?.slice(
    comparePage * rowsPerPageCompare,
    comparePage * rowsPerPageCompare + rowsPerPageCompare
  );

  const handlePickCarrierRates = async (row) => {
    try {
      // console.log(`Selected ates  ${JSON.stringify(row, null, 2)}`);
      await newRequest.post("/uwPolicyRiskCover/applyCarrierRates", {
        policy_docid: quoteData?._id,
        cover_docid: selectedPolicyRiskCover?._id,
        commission_rate: row?.cr_comm_rate,
        commission_tax_rate: row?.cr_comm_tax_rate,
        premium_rate: row?.cr_prem_rate,
        carrier_ent_code: row?.cr_ent_code,
        carrier_aent_code: row?.ent_aent_code_xx
      });
      await refreshQuote();
    } catch (error) {
      console.log(error);
    }
  }

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteAllRisks") {
        // loop delete all risks
        for (const risk of filteredData) {
          await newRequest.delete(`/uwPolicyRisk/del/${risk?._id}`);
          // console.log("risk delete response " + res.data)
        }
        await newRequest.post("/uwPolicy/refresh", {
          policy_docid: quoteData?._id,
          userCode: currentUser.usr_id,
        });

        fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
      } else if (confirmDialogAction === "deleteSmi") {
        await newRequest.delete(`/uwPolicyRiskSmi/del/${objectToAction.object_id}`);
        // console.log("smi delete response " + smiRes.data)
        refreshQuote();
        fetchSelectedCoverSmi(
          selectedPolicyRiskCover?.rc_risk_note_no,
          selectedPolicyRiskCover?._id
        );
      } else if (confirmDialogAction === "deleteRisk") {
        if (objectToAction.object_id) {
          const res = await newRequest.delete(`/uwPolicyRisk/del/${objectToAction.object_id}`);
          // console.log("smi delete response " + smiRes.data)
          // refreshQuote();
          // fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
          setPolicyRisks((prev) => prev.filter(risk => risk?._id !== objectToAction.object_id));
          setShowView("multiple");
        }
      } else if (confirmDialogAction === "setDefaultCommRate") {
        const res = await newRequest.post("/uwCoverCommRate/inject", {
          cr_mc_code: objectToAction.param3,
          cr_sc_code: objectToAction.param4,
          cr_cc_code: objectToAction.param5,
          cr_ent_code: quoteData?.pl_ins_ent_code,
          cr_aent_code: quoteData?.pl_ins_aent_code,
          cr_comm_rate: objectToAction.param1,
          cr_comm_tax_rate: objectToAction.param2
        });
        if (res.data.status === "success") {
          showToast(`Commission rate ${objectToAction.param1} and tax rate ${objectToAction.param2} successfully set!`, "success");
        } else {
          showToast(`error ${res.data.msg}`, "error");
        }
      } else if (confirmDialogAction === "removeClaimBasis") {
        // remove claim basis
        try {
          await newRequest.post(
            "/uwPolicyRisk/claimBasisDel",
            {
              risk_docid: selectedPolicyRisk?._id,
              basis_docid: objectToAction.object_id,
            }
          );
          setPrClaimBasis((prev) => prev.filter(mm => mm?._id !== objectToAction?.object_id));
          showToast(t('removed'), "success");
        } catch (error) {
          console.log(error);
        }

        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "removePeril") {
        try {
          await newRequest.post(
            "/uwPolicyRisk/removePeril",
            {
              risk_docid: selectedPolicyRisk?._id,
              peril_docid: objectToAction.object_id,
            }
          );
          setPrPerils((prev) => prev.filter(mm => mm?._id !== objectToAction?.object_id));
          showToast(t('removed'), "success");
        } catch (error) {
          console.log(error);
        }
        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "deleteSubClass") {
        try {
          const res = await newRequest.delete(`/uwPolicySc/del/${objectToAction.object_id}`);
          if (res.data === "deleted") {
            setPolicySubClasses((prev) => prev.filter(sc => sc?._id !== objectToAction?.object_id));
            showToast(t('removedParam', { param1: objectToAction?.param1 }), "success");
            setSelectedSubClass(policySubClasses[0]);
          } else {
            showToast(t('unableToRemove', { param1: objectToAction?.param1 }), "error");
          }
        } catch (error) {
          console.log(error);
        }
        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "deleteCover") {
        try {
          const res = await newRequest.delete(`/uwPolicyRiskCover/del/${objectToAction.object_id}`);
          if (res.data === "deleted") {
            // setPolicySubClasses((prev) => prev.filter(sc => sc?._id !== objectToAction?.object_id));
            refreshQuote();
            showToast(t('removedParam', { param1: objectToAction?.param1 }), "success");
            // setSelectedSubClass(policySubClasses[0]);
          } else {
            showToast(t('unableToRemove', { param1: objectToAction?.param1 }), "error");
          }
        } catch (error) {
          console.log(error);
        }
        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "setPolicyNoFirst") {
        setPolicyNo();
      } else if (confirmDialogAction === "overrideNtsa") {
        if (!objectToAction?.object_id) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(t('issuanceIdMissing'));
          setIsNotifyDialogOpen(true);
          return;
        } else {
          setIsConfirmDialogOpen(false);
          setIsIssueCertOpen(false);
          setIsProcessingTitle(t('confirmingDmvicCertificate'));
          setIsProcessing(true);

          const res = await newRequest.post("/dmvic/confirmCert",
            {
              IssuanceRequestID: objectToAction?.object_id,
              IsApproved: true,
              IsLogBookVerified: true,
              IsVehicleInspected: true,
              AdditionalComments: "",
              UserName: ""
            }
          );
          logData("NTSA Override Response", res.data);
          if (res.data?.result?.success === true) {
            showToast(t('certificateIssued', {
              param1: res.data?.result?.callbackObj?.issueCertificate?.actualCNo,
              param2: res.data?.result?.callbackObj?.issueCertificate?.Email
            }),
              "success");
            setIsProcessingTitle(t('gettingDmvicCertificate', { param1: res.data?.result?.callbackObj?.issueCertificate?.actualCNo }));

            const pdf = await newRequest.post("/dmvic/getCerfPdf",
              {
                CertificateNumber: res.data?.result?.callbackObj?.issueCertificate?.actualCNo,
                policyDocid: quoteData?._id,
                riskDocid: selectedPolicyRisk?._id,
                certFm: selectedPolicyRisk?.pr_fm_date,
                certTo: selectedPolicyRisk?.pr_to_date,
                certType: selectedPolicyRiskCover?.dmvic_cover_xx,
                regnNo: selectedPolicyRisk?.pr_vehicle_regn,
                policyNo: quoteData?.pl_no,
                assrEntCode: quoteData?.pl_assr_ent_code,
                intEntCode: quoteData?.pl_ins_ent_code,
              }
            );
            setIsProcessing(false);
            logData("DMVIC Certificate PDF", pdf.data);
            setBinaryDocid(pdf.data?.savedCertId || null);
            setPdfUrl(pdf.data?.result?.callbackObj?.URL);
            setPdfPreviewDialogOpen(true);
          } else {
            setIsProcessing(false);
            // check insufficient inventory
            const hasInventoryError = Array.isArray(res.data?.result?.Error) &&
              res.data?.result?.Error.some(err => err?.errorText === "No Sufficient Inventory");
            if (hasInventoryError) {
              setNotifyDialogTitle(t('error'));
              setNotifyDialogText(`You have INSUFFICIENT INVENTORY for type ${getPrefixSafe(selectedPolicyRiskCover?.dmvic_cover_xx)} Certificates allocated to you by ${quoteData?.pl_int_entity_name}.`);
              setIsNotifyDialogOpen(true);
              return;
            }

            let errorObject = {
              result_status: "error",
              result_msg: `Oops!, sorry ${currentUser?.usr_full_name}, following exceptions occured while issuing certificate`,
            };

            const errors = res.data?.result?.Error?.map((val, index) => ({
              msg_index: index + 1,
              msg_no: val?.errorCode,
              msg_text: val?.errorText,
              msg_type: "error",
            })) || [];
            errorObject.result_msg_list = errors;
            setIsIssueCertOpen(false);
            // logData("DMVIC Certificate Issuance Errors", errorObject);
            setValidationMessagesResult(errorObject);
            setValidationMsgDialog(true);
            return;
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
    setIsConfirmDialogOpen(false);
  };


  const handleSmiEditUpdate = async () => {
    try {
      await newRequest.post(
        `/uwPolicyRiskSmi/upd/${selectedSmiForEdit?._id}`,
        {
          smi_policy_docid: quoteData?._id,
          smi_annual_wage_fc: selectedSmiForEdit?.smi_annual_wage_fc,
          smi_wiba_wage_fc: selectedSmiForEdit?.smi_wiba_wage_fc,
          smi_desc: selectedSmiForEdit?.smi_desc,
          smi_rate: selectedSmiForEdit?.smi_rate,
          smi_rate_per: selectedSmiForEdit?.smi_rate_per,
          smi_premium_fc: selectedSmiForEdit?.smi_premium_fc,
          smi_si_fc: selectedSmiForEdit?.smi_si_fc,
          smi_limit_fc: selectedSmiForEdit?.smi_limit_fc,
          smi_fcl_value_fc: selectedSmiForEdit?.smi_fcl_value_fc,
          smi_qty: selectedSmiForEdit?.smi_qty,
          smi_add_to_si: selectedSmiForEdit?.smi_add_to_si,
          smi_calc_type: selectedSmiForEdit?.smi_calc_type || "Normal",
        }
      );

      setSelectedSmiForEdit(null);
      // refresh SMI
      fetchSelectedCoverSmi(
        selectedPolicyRiskCover?.rc_risk_note_no,
        selectedPolicyRiskCover?._id
      );
      // refresh quote
      refreshQuote();
      showToast(t('updated'), "success");
    } catch (error) {
      console.error("Error updating SMI:", error);
    }
  };

  // const handleSmiEditChange = (e) => {
  //   const { name, value } = e.target;
  //   setSelectedSmiForEdit({
  //     ...selectedSmiForEdit,
  //     [name]: value,
  //   });
  // };
  const handleSmiEditChange = (name, value) => {
    setSelectedSmiForEdit((prev) => {
      return { ...prev, [name]: value };
    });
  };


  const handleSmiForBlur = (e) => {
    let formattedValue;
    const { name, value } = e.target;
    // console.log(`handleSmiForBlur  ${JSON.stringify(name, null, 2)}`);
    const numberFields = [
      "smi_rate",
      "smi_rate_per",
      "smi_premium_fc",
      "smi_premium_lc",
      "smi_si_fc",
      "smi_si_lc",
      "smi_fcl_value_fc",
      "smi_fcl_value_lc",
      "smi_qty",
      "smi_annual_wage_fc",
      "smi_annual_wage_lc",
      "smi_wiba_wage_fc",
      "smi_wiba_wage_lc",
      "smi_limit_fc",
      "smi_limit_lc",
    ];

    if (numberFields.includes(name)) {
      // console.log(`Its a Number and comma is ther ${value.includes(",")}`);
      if (value.includes(",")) {
        formattedValue = parseFloat(value.replace(/,/g, ""));
      } else {
        formattedValue = parseFloat(value);
      }
    } else {
      formattedValue = value;
    }

    // Update the state with the formatted value
    setSelectedSmiForEdit({
      ...selectedSmiForEdit,
      [name]: formattedValue,
    });
  };


  const fetchSubClassCovers = async () => {
    try {
      const res = await newRequest.post(
        "/uwSubClassCover/findAll",
        {
          cc_mc_code: selectedSubClass?.ps_mc_code,
          cc_sc_code: selectedSubClass?.ps_sc_code,
        }
      );

      const options = res.data.map((cover) => ({
        mc_code: cover?.cc_mc_code,
        sc_code: cover?.cc_sc_code,
        cc_code: cover?.cc_code,
        cc_desc: cover?.cc_desc,
        value: cover?.cc_code,
        label: cover?.cc_name,
      }));
      setSubClassCovers(options);
    } catch (error) {
      console.error("Error fetching class covers :", error);
    }
  };


  const handleCoverEditUpdate = async () => {
    try {
      await newRequest.post(
        `/uwPolicyRiskCover/upd/${selectedPolicyRiskCover?._id}`,
        { rc_desc: selectedPolicyRiskCover?.rc_desc }
      );
      fetchCoversForSelectedRisk(selectedPolicyRisk?._id);
      setShowCoverForEditing(false);
      showToast("Updated!", "success");
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const handleAddCover = async () => {
    try {
      if (selectedSubClassCover?.cc_code && selectedPolicyRisk?._id) {
        // save risk details
        await saveRisk();
        const res = await newRequest.post(
          "/uwPolicyRiskCover/add",
          {
            rc_risk_note_no: selectedPolicyRisk?.pr_risk_note_no,
            rc_risk_code:
              selectedPolicyRisk?.pr_risk_code || quoteData?.pl_risk_note_no,
            rc_mc_code: selectedSubClassCover.mc_code,
            rc_sc_code: selectedSubClassCover.sc_code,
            rc_cc_code: selectedSubClassCover.cc_code,
            rc_desc: selectedSubClassCover.cc_desc,
            rc_risk_docid: selectedPolicyRisk?._id,
            rc_policy_docid: selectedPolicyRisk?.pr_policy_docid,
            rc_end_index: quoteData?.pl_end_index
          }
        );

        //log the event here
        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "added cover",
              trc_remarks: `added cover ${selectedSubClassCover.cc_code}`,
              trc_tags: ["added cover"],
              trc_doc_docid: quoteData?._id
            }
          );
        } catch (error) {
          console.log(error);
        }

        // pass added cover to set it as current
        fetchCoversForSelectedRisk(selectedPolicyRisk?._id, res.data);
        setSelectedSubClassCover(null);
        // set current cover to the added cover
        // setSelectedSubClassCover(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };


  useImperativeHandle(ref, () => ({
    saveRisksAndSmisFromParent
  }));

  const saveRisksAndSmisFromParent = async () => {
    try {
      saveRisksInParent();
      // save risks also invokes save smi
      await saveRisk("N");
    } catch (error) {
      console.log(error)
    }
  }

  const saveRisksInParent = () => {
    try {

      if (policyExcessRef.current) {
        policyExcessRef.current.saveExcessFromParent();
      }

      if (policyCondRef.current) {
        policyCondRef.current.saveConditionsFromParent();
      }

    } catch (error) {
      console.log(error)
    }
  };

  const saveSmis = async () => {
    try {
      for (const [index, obj] of policyRiskCoverSmi.entries()) {
        // Create a JSON object with desired properties
        const jsonData = {
          index: index + 1,
          data: obj,
        };

        try {
          if (obj.flag_xx === "existing") {
            // console.log(`existing.smi_qty..\n${JSON.stringify(jsonData.data, null, 2)}`);
            await newRequest.post(`/uwPolicyRiskSmi/upd/${obj._id}`, {
              ...jsonData.data,
              smi_type: jsonData.data.smi_type,
              product_type_xx: quoteData?.product_type_xx || "",
              term_code: quoteData?.pl_term_code_xx?.term_code || "",
              term_years: quoteData?.pl_term_code_xx?.term_years || 0,
              term_mo_code: quoteData?.pl_term_code_xx?.term_mo_code || "",
              term_joint_type: quoteData?.pl_term_code_xx?.term_joint_type || "",
              ent_nextage_int_xx: selectedPolicyRisk?.risk_entity_xx?.ent_nextage_int_xx || 0,
              joint_avg_agenext_xx: selectedPolicyRisk?.joint_avg_agenext_xx || 0,
              ent_smoke_flag: selectedPolicyRisk?.risk_entity_xx?.ent_smoke_flag || "",
              ent_gender: selectedPolicyRisk?.risk_entity_xx?.ent_gender || "",
              smi_add_to_si: jsonData.data?.smi_add_to_si || "Y",
              smi_qty: jsonData.data?.smi_qty || 0,
            });

            // console.log(`Update Response ${res.data}`)
          } else if (obj.flag_xx === "new" && jsonData.data.smi_desc) {
            // console.log(`new.smi_add_to_si..\n${JSON.stringify(jsonData.data?.smi_add_to_si, null, 2)}`);
            await newRequest.post("/uwPolicyRiskSmi/add", {
              ...jsonData.data,
              product_type_xx: quoteData?.product_type_xx || "",
              term_code: quoteData?.pl_term_code_xx?.term_code || "",
              term_years: quoteData?.pl_term_code_xx?.term_years || 0,
              term_mo_code: quoteData?.pl_term_code_xx?.term_mo_code || "",
              term_joint_type: quoteData?.pl_term_code_xx?.term_joint_type || "",
              ent_nextage_int_xx: selectedPolicyRisk?.risk_entity_xx?.ent_nextage_int_xx || 0,
              joint_avg_agenext_xx: selectedPolicyRisk?.joint_avg_agenext_xx || 0,
              ent_smoke_flag: selectedPolicyRisk?.risk_entity_xx?.ent_smoke_flag || "",
              ent_gender: selectedPolicyRisk?.risk_entity_xx?.ent_gender || "",
              smi_rate: formatStringToNumberV2(jsonData.data.smi_rate),
              smi_rate_per: formatStringToNumberV2(jsonData.data.smi_rate_per),
              smi_premium_fc: formatStringToNumberV2(jsonData.data.smi_premium_fc),
              smi_si_fc: formatStringToNumberV2(jsonData.data.smi_si_fc),
              smi_fcl_value_fc: formatStringToNumberV2(jsonData.data.smi_fcl_value_fc),
              smi_limit_fc: formatStringToNumberV2(jsonData.data.smi_limit_fc),
              smi_add_to_si: jsonData.data.smi_add_to_si,
              smi_type: jsonData.data.smi_type || "normal",
              smi_qty: jsonData.data?.smi_qty || 0,
            });
            // console.log(`Insert Response ${res.data}`)
          }

          // Handle the response as needed
        } catch (error) {
          console.error(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const calculatePremium = async () => {
    try {
      setShowMovement(false);
      await saveRisk("N");
      // refresh SMI
      fetchSelectedCoverSmi(
        selectedPolicyRiskCover?.rc_risk_note_no,
        selectedPolicyRiskCover?._id
      );
      // refresh quote
      await refreshQuote('calculatingPremium');
      showToast("Premium Calculated!", "success");
    } catch (error) {
      console.log(error)
    }
  };




  const fetchRiAllocationTypes = async () => {
    try {
      const options = ["Cover", "Top Location", "Risk Based", "None"].map((ri) => ({
        value: ri,
        label: ri,
      }));
      setRiAllocationTypes(options);
    } catch (error) {
      console.error("Error fetching risk functions :", error);
    }
  };


  const fetchRiskFunctions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Risk Categories" });

      const options = res.data.map((codes) => ({
        risk_category: codes?.sys_flex2,
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setRiskFunctions(options);

    } catch (error) {
      console.error("Error fetching risk functions :", error);
    }
  };

  const fetchRiCategories = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "RI Categories" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setRiCategories(options);
    } catch (error) {
      console.error("Error fetching risk functions :", error);
    }
  };



  const fetchRelationshipTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Relationship Type" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setRelationshipTypes(options);
    } catch (error) {
      console.error("Error fetching relationship types :", error);
    }
  };



  const fetchMedicalReports = async (entCode) => {
    try {
      const res = await newRequest.post(
        "/uwMedicalRequest/findAll",
        {
          rq_code: "",
          rq_insured_ent_code: entCode,
          rq_facility_ent_code: "",
          result_limit: 100
        }
      );
      const options = res.data.map((mr) => ({
        value: mr?.rq_code,
        label: mr?.rq_code,
      }));
      setMedicalReports(options);
    } catch (error) {
      console.error("Error fetching risk functions :", error);
    }
  };

  const fetchBondTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Bond Types" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setBondTypes(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchEqZones = async () => {
    try {
      const res = await newRequest.post("/sysCode/findNullGrp", { sys_type: "EQ Zones" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setEqZones(options);
    } catch (error) {
      console.error("Error fetching eq zones :", error);
    }
  };

  const fetchEqSubZones = async (eqZone) => {
    try {
      const res = await newRequest.post("/sysCode/findGrp", { sys_type: "EQ Zones", sys_grouping: eqZone });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setEqSubZones(options);

    } catch (error) {
      console.error("Error fetching eq sub zones :", error);
    }
  };

  const fetchFloodZones = async () => {
    try {
      const res = await newRequest.post("/sysCode/findNullGrp", { sys_type: "Flood Zones" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setFloodZones(options);
    } catch (error) {
      console.error("Error fetching flood zones :", error);
    }
  };

  const fetchFloodSubZones = async (floodZone) => {
    try {
      const res = await newRequest.post("/sysCode/findGrp", { sys_type: "Flood Zones", sys_grouping: floodZone });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setFloodSubZones(options);

    } catch (error) {
      console.error("Error fetching flood sub zones :", error);
    }
  };

  const fetchBondCategories = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Bond Categories" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setBondCategories(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchDmvicCancel = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "DMVIC Cancel Reasons" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setDmvicCancelReasons(options);
    } catch (error) {
      console.log(error);
    }
  };



  const fetchBondPurposes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Bond Purpose" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setBondPurposes(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const updateBondField = (field, value) => {
    setPrBondInfo(prev => ({ ...prev, [field]: value }));
  };


  const fetchRiskAreas = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Risk Areas", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setRiskAreas(options);
    } catch (error) {
      console.error("Error fetching risk areas :", error);
    }
  };


  const fetchRiskJurisdictions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Jurisdictions", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setRiskJurisdictions(options);
    } catch (error) {
      console.error("Error fetching risk jurisdiction :", error);
    }
  };

  const handleSelectedRiskArea = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const res = await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Risk Areas",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value,
            sys_grouping: ""
          }
        );
        setPrRiskArea({
          value: selectedOption.value,
          label: selectedOption.value,
        });
        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setPrRiskArea(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectedRiskJurisdiction = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const res = await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Jurisdictions",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value,
            sys_grouping: ""
          }
        );
        setPrRiskJurisdiction({
          value: selectedOption.value,
          label: selectedOption.value,
        });
        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setPrRiskJurisdiction(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGender = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Gender" });

      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setGenders(options);
    } catch (error) {
      console.error("Error fetching risk functions :", error);
    }
  };



  const handlePersonDob = (e) => {
    try {
      if (e.target.value) {
        const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
        setPrPersonDob(formattedDate);
        setPersonAgeXx(calculateAgeFromMongoDate(formattedDate) + " years");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOtherAttributeChange = (id, newValue) => {
    const updatedAttributes = prOtherAttributes.map((attr) =>
      attr._id === id ? { ...attr, attribute_yn: newValue } : attr
    );
    setPrOtherAttributes(updatedAttributes);
  };

  const fetchOtherAttributes = async () => {
    try {
      const res = await newRequest.post("/uwPolicyRisk/getOtherAttr", { risk_docid: selectedPolicyRisk?._id, });
      setPrOtherAttributes(res.data);
    } catch (error) {
      console.error("Error fetching attributes :", error);
    }
  };


  const handlePrimaryBenChange = (id, newValue) => {
    const updatedBeneficiaries = primaryBeneficiaries?.map((attr) =>
      attr._id === id ? { ...attr, attribute_yn: newValue } : attr
    );
    setPrimaryBeneficiaries(updatedBeneficiaries);
  };

  const fetchPrimaryBeneficiaries = async (risk_docid) => {
    try {
      const res = await newRequest.post("/uwPolicyRisk/getBeneficiaries", { risk_docid: risk_docid, beneficiary_type: "pr_primary_beneficiary" });
      setPrimaryBeneficiaries(null);
      setPrimaryBeneficiaries(res.data.beneficiaries);
    } catch (error) {
      console.error("Error fetching attributes :", error);
    }
  };


  const handleSecondaryBenChange = (id, newValue) => {
    const updatedBeneficiaries = secondaryBeneficiaries?.map((attr) =>
      attr._id === id ? { ...attr, attribute_yn: newValue } : attr
    );
    setSecondaryBeneficiaries(updatedBeneficiaries);
  };

  const fetchSecondaryBeneficiaries = async (risk_docid) => {
    try {
      const res = await newRequest.post(
        "/uwPolicyRisk/getBeneficiaries",
        {
          risk_docid: risk_docid,
          beneficiary_type: "pr_secondary_beneficiary"
        }
      );
      setSecondaryBeneficiaries(null);
      setSecondaryBeneficiaries(res.data.beneficiaries);
    } catch (error) {
      console.error("Error fetching attributes :", error);
    }
  };


  const handlePersonOccupation = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const resModel = await newRequest.post("/sysCode/add", {
          sys_org_code: currentUser.usr_org_code,
          sys_type: "Occupations",
          sys_code: selectedOption.value,
          sys_name: selectedOption.value,
          userCode: currentUser.usr_id,
        });

        setPrPersonOccupation({
          value: selectedOption.value,
          label: selectedOption.value,
        });

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setPrPersonOccupation(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };




  const updateMarineField = (field, value) => {
    setPrMarineInfo(prev => ({ ...prev, [field]: value }));
  };


  const fetchShippingMode = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Shipping Mode" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setShippingModes(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };


  const fetchPorts = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Ports" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setPorts(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  const handleMarineLimitsBlur = (e) => {
    if (e.target.value) {
      const strippedValue = e.target.value.replace(/,/g, "");
      const parsedValue = Big(strippedValue); // Use big.js to handle the value
      // Check if the parsed value is NaN
      if (!parsedValue.eq(parsedValue)) {
        if (e.target.name === "any_one_loss_limit") {
          updateMarineField('any_one_loss_limit', "");
        } else if (e.target.name === "single_transit_limit") {
          updateMarineField('single_transit_limit', "");
        } else if (e.target.name === "annual_carry_limit") {
          updateMarineField('annual_carry_limit', "");
        }
      } else {
        // Format the parsed value with 2 decimal places and digit grouping
        const formattedValue = parsedValue
          .toFixed(2)
          .toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        if (e.target.name === "any_one_loss_limit") {
          updateMarineField('any_one_loss_limit', formattedValue);
        } else if (e.target.name === "single_transit_limit") {
          updateMarineField('single_transit_limit', formattedValue);
        } else if (e.target.name === "annual_carry_limit") {
          updateMarineField('annual_carry_limit', formattedValue);
        }
      }
    }
  };

  const handleSelectedOriginPort = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const res = await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Ports",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value
          }
        );
        // setOriginPort({
        //   value: selectedOption.value,
        //   label: selectedOption.value,
        // });
        //   // set the destination port as well so that the option appears in the list
        // setDestPort({
        //   value: selectedOption.value,
        //   label: selectedOption.value,
        // });

        updateMarineField('origin_port', selectedOption?.value);
        updateMarineField('dest_port', selectedOption?.value);

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        updateMarineField('origin_port', selectedOption?.value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectedDestPort = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const res = await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Ports",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value
          }
        );
        updateMarineField('dest_port', selectedOption?.value);
        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        updateMarineField('dest_port', selectedOption?.value);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchOccupations = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Occupations" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setOccupations(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  const fetchVehicleColor = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Color" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setVehicleColors(options);
    } catch (error) {
      console.error("Error fetching Color :", error);
    }
  };

  const handleSelectedVehicleColor = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        const res = await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Color",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value,
            sys_grouping: ""
          }
        );

        await fetchVehicleColor();

        setPrVehicleColor({
          value: selectedOption?.value,
          label: selectedOption?.value,
        });

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setPrVehicleColor(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchMemberStatus = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Member Status" });

      const options = res.data.map((make) => ({
        value: make?.sys_code,
        label: make?.sys_name,
      }));

      setMemberStatus(options);
    } catch (error) {
      console.error("Error fetching car member status :", error);
    }
  };

  const fetchVehicleModels = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Car Make Model" });

      const options = res.data.map((make) => ({
        vehicle_make: make.sys_grouping,
        vehicle_model: make.sys_code,
        value: make.sys_code,
        label: make.sys_name,
      }));

      setVehicleModels(options);
      //set default values
      if (selectedPolicyRisk) {
        setPrVehicleModel({
          vehicle_make: selectedPolicyRisk?.pr_vehicle_make,
          vehicle_model: selectedPolicyRisk?.pr_vehicle_model,
          value: selectedPolicyRisk?.pr_vehicle_model,
          label: selectedPolicyRisk?.vehicle_model_xx,
        });
      }
    } catch (error) {
      console.error("Error fetching car models :", error);
    }
  };

  const handleSelectedVehicleModel = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        await newRequest.post(
          "/sysCode/add",
          {
            sys_type: "Car Make Model",
            sys_code: selectedOption.value,
            sys_name: selectedOption.value,
            sys_grouping: ""
          }
        );
        await fetchVehicleModels();
        setPrVehicleModel({
          vehicle_make: selectedOption.value,
          vehicle_model: selectedOption.value,
          value: selectedOption.value,
          label: selectedOption.value,
        });

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setPrVehicleModel(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchVehicleUse = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Vehicle Use", });
      const options = res.data.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setVehicleUse(options);
    } catch (error) {
      console.error("Error fetching car models :", error);
    }
  };

  const fetchVehicleBodyTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Vehicle Body Types", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setVehicleBodyTypes(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchVehicleTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Vehicle Types" });
      const options = res.data.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setVehicleTypes(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchVehicleCertTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Vehicle Cert Type" });
      const options = res.data.map((codes) => ({
        grouping: codes?.sys_grouping,
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setVehicleCertTypes(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const handleProductScChangePage = (event, newPage) => {
    setProductScPage(newPage);
  };

  const handleProductScChangeRowsPerPage = (event) => {
    setRowsPerPageProductSc(parseInt(event.target.value, 5));
    setProductScPage(0);
  };


  const filteredProductScData = productSubClasses?.filter(
    (item) =>
      item.ps_mc_code?.toLowerCase().includes(searchProductSubClass?.toLowerCase()) ||
      item.ps_sc_code?.toLowerCase().includes(searchProductSubClass?.toLowerCase()) ||
      item.mc_code_xx?.toLowerCase().includes(searchProductSubClass?.toLowerCase()) ||
      item.sc_name_xx?.toLowerCase().includes(searchProductSubClass?.toLowerCase())
  );

  const slicedProductScData = filteredProductScData.slice(
    productScPage * rowsPerPageProductSc,
    productScPage * rowsPerPageProductSc + rowsPerPageProductSc
  );

  const fetchProductSubClasses = async (pr_code) => {
    try {
      const res = await newRequest.post("/uwProductSc/findAll", {
        ps_pr_code: pr_code,
      });
      setProductSubClasses(res.data);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchPolicyRisks = async (policyDocid, subclassDocid) => {
    try {

      setSelectedPolicyRisk(null);
      setSelectedPolicyRiskCover(null);
      fetchSelectedCoverSmi(null, null);

      const res = await newRequest.post(
        "/uwPolicyRisk/findById",
        {
          pr_policy_docid: policyDocid,
          pr_subclass_docid: subclassDocid,
        }
      );

      setPolicyRisks(res.data);

      // select first risk
      if (res.data) {
        setSelectedPolicyRisk(res.data[0]);
        setPrRiskNoteNo(res.data[0]?.pr_risk_note_no);
        setPrRiskCode(res.data[0]?.pr_risk_code);
        setPrOrderNo(res.data[0]?.pr_order_no);
        setPrRiskAddress(res.data[0]?.pr_risk_address);
        setPrBondInfo(res.data?.pr_bond_info);

        setPrRiskFunction({
          value: res.data[0]?.pr_risk_function,
          label: res.data[0]?.risk_function_xx,
        });

        setPrRiskArea({
          value: res.data[0]?.pr_risk_area,
          label: res.data[0]?.risk_area_xx,
        });

        setPrRiskJurisdiction({
          value: res.data[0]?.pr_risk_jurisdiction,
          label: res.data[0]?.pr_risk_jurisdiction,
        });

        setPrRiskCategory({
          value: res.data[0]?.pr_risk_category,
          label: res.data[0]?.pr_risk_category
        });

        setPrInterestEntCode({
          value: res.data[0]?.pr_interest_ent_code,
          label: res.data[0]?.pr_interest_ent_code_xx,
        });

        setPrRiskDescription(res.data[0]?.pr_risk_description);
        setPrClaimBasis(res.data[0]?.pr_claim_basis);
        setPrPerils(res.data[0]?.pr_perils);
        setInspected(res.data[0]?.pr_inspected);
        setPrStatus(res.data[0]?.pr_status);
        setPrVehicleRegn(res.data[0]?.pr_vehicle_regn);
        setPrVehicleEngine(res.data[0]?.pr_vehicle_engine);
        setPrVehicleChassis(res.data[0]?.pr_vehicle_chassis);
        setPrVehicleYom(res.data[0]?.pr_vehicle_yom);
        setPrVehiclePassangers(res.data[0]?.pr_vehicle_passangers);
        setPrVehicleCc(res.data[0]?.pr_vehicle_cc);
        setPrRemarks(res.data[0]?.pr_remarks);
        setPrVehicleTonnage(res.data[0]?.pr_vehicle_tonnage);

        setPrVehicleUse({
          value: res.data[0]?.pr_vehicle_use,
          label: res.data[0]?.vehicle_use_xx,
        });

        setPrVehicleBody({
          value: res.data[0]?.pr_vehicle_body,
          label: res.data[0]?.vehicle_body_type_xx,
        });

        setPrVehicleType({
          value: res.data[0]?.pr_vehicle_type,
          label: res.data[0]?.vehicle_type_xx,
        });

        setPrVehicleCert({
          value: res.data[0]?.pr_vehicle_cert,
          label: res.data[0]?.vehicle_cert_type_xx,
        });

        setPrVehicleModel({
          vehicle_make: res.data[0]?.pr_vehicle_make,
          vehicle_model: res.data[0]?.pr_vehicle_model,
          value: res.data[0]?.pr_vehicle_model,
          label: res.data[0]?.vehicle_model_xx,
        });
        setPrVehicleColor({
          value: res.data[0]?.pr_vehicle_color,
          label: res.data[0]?.pr_vehicle_color,
        });

        if (res.data[0]?.pr_fm_date) {
          const formattedFmDate = moment(res.data[0]?.pr_fm_date).format("YYYY-MM-DD");
          setPrFmDate(formattedFmDate);
        }

        if (res.data[0]?.pr_to_date) {
          const formattedToDate = moment(res.data[0]?.pr_to_date).format("YYYY-MM-DD");
          setPrToDate(formattedToDate);
        }

        if (res.data[0]?.pr_fm_date && res.data[0]?.pr_to_date) {
          calculateDateDifference();
        }

        if (res.data[0]?.pr_other_attributes) {
          setPrOtherAttributes(res.data[0]?.pr_other_attributes);
        }

        if (res.data[0]?.pr_full_name) {
          setPrFullName(res.data[0]?.pr_full_name);
        } else {
          setPrFullName(null);
        }

        if (res.data[0]?.pr_gender) {
          setPrGender({
            value: res.data[0]?.pr_gender,
            label: res.data[0]?.person_gender_xx,
          });
        } else {
          setPrGender({
            value: "Unspecified",
            label: "Unspecified",
          });
        }

        if (res.data[0]?.pr_person_dob) {
          const formattedDate = moment(res.data[0]?.pr_person_dob).format("YYYY-MM-DD");
          setPrPersonDob(formattedDate);
        } else {
          setPrPersonDob(null);
        }

        if (res.data[0]?.person_age_xx) {
          setPersonAgeXx(res.data[0]?.person_age_xx);
        } else {
          setPersonAgeXx(null);
        }

        if (res.data[0]?.pr_person_id) {
          setPrPersonId(res.data[0]?.pr_person_id);
        } else {
          setPrPersonId(null);
        }

        if (res.data[0]?.pr_member_no) {
          setPrMemberNo(res.data[0]?.pr_member_no);
        } else {
          setPrMemberNo(null);
        }

        if (res.data[0]?.pr_member_fm) {
          const formattedDate = moment(res.data[0]?.pr_member_fm).format("YYYY-MM-DD");
          setPrMemberFm(formattedDate);
        } else {
          setPrMemberFm(null);
        }

        if (res.data[0]?.pr_member_to) {
          const formattedDate = moment(res.data[0]?.pr_member_to).format("YYYY-MM-DD");
          setPrMemberTo(formattedDate);
        } else {
          setPrMemberTo(null);
        }

        if (res.data[0]?.pr_member_status) {
          setPrMemberStatus({
            value: res.data[0]?.pr_member_status,
            label: res.data[0]?.member_status_xx,
          });
        } else {
          setPrMemberStatus(null);
        }

        if (res.data[0]?.pr_person_occupation) {
          setPrPersonOccupation({
            value: res.data[0]?.pr_person_occupation,
            label: res.data[0]?.person_occupation_xx,
          });
        } else {
          setPrPersonOccupation(null);
        }

        if (res.data[0]?.pr_person_email) {
          setPrPersonEmail(res.data[0]?.pr_person_email);
        } else {
          setPrPersonEmail(null);
        }

        if (res.data[0]?.pr_person_phone) {
          setPrPersonPhone(res.data[0]?.pr_person_phone);
        } else {
          setPrMemberFm(null);
        }

        // google places
        setPrLatitude(res.data[0]?.pr_latitude);
        setPrLongitude(res.data[0]?.pr_longitude);
        setPrPlaceName(res.data[0]?.pr_place_name);


        if (res.data[0]?.pr_claim_basis) {
          setPrClaimBasis(res.data[0]?.pr_claim_basis);
        } else {
          setPrClaimBasis([]);
        }

        if (res.data[0]?.pr_perils) {
          setPrPerils(res.data[0]?.pr_perils);
        } else {
          setPrPerils([]);
        }


        // Marine Info
        setPrMarineInfo(res.data[0]?.pr_marine_info);
        setPrBondInfo(res.data[0]?.pr_bond_info);

        // set marine details
        // if (res.data[0]?.marine_cert_details_xx) {
        //   setMarineCertRow(res.data[0]?.marine_cert_details_xx);
        //   if (res.data[0]?.marine_cert_details_xx.cert_no) {
        //     setCertNo(res.data[0]?.marine_cert_details_xx.cert_no);
        //   } else {
        //     setCertNo(null);
        //   }
        //   if (res.data[0]?.marine_cert_details_xx.shipping_mode) {
        //     setShippingMode({
        //       value: res.data[0]?.marine_cert_details_xx.shipping_mode,
        //       label: res.data[0]?.marine_cert_details_xx.shipping_mode,
        //     });
        //   } else {
        //     setShippingMode(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.origin_address) {
        //     setOriginAddress(res.data[0]?.marine_cert_details_xx.origin_address);
        //   } else {
        //     setOriginAddress(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.dest_address) {
        //     setDestAddress(res.data[0]?.marine_cert_details_xx.dest_address);
        //   } else {
        //     setDestAddress(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.origin_port) {
        //     setOriginPort({
        //       value: res.data[0]?.marine_cert_details_xx.origin_port,
        //       label: res.data[0]?.marine_cert_details_xx.origin_port_xx,
        //     });
        //   } else {
        //     setOriginPort(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.dest_port) {
        //     setDestPort({
        //       value: res.data[0]?.marine_cert_details_xx.dest_port,
        //       label: res.data[0]?.marine_cert_details_xx.dest_port_xx,
        //     });
        //   } else {
        //     setDestPort(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.vessel_no) {
        //     setVesselNo(res.data[0]?.marine_cert_details_xx.vessel_no);
        //   } else {
        //     setVesselNo(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.flight_no) {
        //     setFlightNo(res.data[0]?.marine_cert_details_xx.flight_no);
        //   } else {
        //     setFlightNo(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.bill_of_lading_no) {
        //     setBillOfLadingNo(
        //       res.data[0]?.marine_cert_details_xx.bill_of_lading_no
        //     );
        //   } else {
        //     setBillOfLadingNo(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.bill_of_lading_date) {
        //     const formattedDate = moment(
        //       res.data[0]?.marine_cert_details_xx.bill_of_lading_date
        //     ).format("YYYY-MM-DD");
        //     setBillOfLadingDate(formattedDate);
        //   } else {
        //     setBillOfLadingDate(null);
        //   }


        //   if (res.data[0]?.marine_cert_details_xx.any_one_loss_limit) {
        //     const formattedValue =
        //       res.data[0]?.marine_cert_details_xx.any_one_loss_limit
        //         .toFixed(2)
        //         .toLocaleString(undefined, {
        //           minimumFractionDigits: 2,
        //           maximumFractionDigits: 2,
        //         });
        //     setAnyOneLossLimit(formattedValue);
        //   } else {
        //     setAnyOneLossLimit(0);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.single_transit_limit) {
        //     const formattedValue =
        //       res.data[0]?.marine_cert_details_xx.single_transit_limit
        //         .toFixed(2)
        //         .toLocaleString(undefined, {
        //           minimumFractionDigits: 2,
        //           maximumFractionDigits: 2,
        //         });
        //     setSingleTransitLimit(formattedValue);
        //   } else {
        //     setSingleTransitLimit(0);
        //   }
        //   if (res.data[0]?.marine_cert_details_xx.annual_carry_limit) {
        //     const formattedValue =
        //       res.data[0]?.marine_cert_details_xx.annual_carry_limit
        //         .toFixed(2)
        //         .toLocaleString(undefined, {
        //           minimumFractionDigits: 2,
        //           maximumFractionDigits: 2,
        //         });
        //     setAnnualCarryLimit(formattedValue);
        //   } else {
        //     setAnnualCarryLimit(0);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.est_depature_date) {
        //     const formattedDate = moment(
        //       res.data[0]?.marine_cert_details_xx.est_depature_date
        //     ).format("YYYY-MM-DD");
        //     setEstDepatureDate(formattedDate);
        //   } else {
        //     setEstDepatureDate(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.act_depature_date) {
        //     const formattedDate = moment(
        //       res.data[0]?.marine_cert_details_xx.act_depature_date
        //     ).format("YYYY-MM-DD");
        //     setActDepatureDate(formattedDate);
        //   } else {
        //     setActDepatureDate(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.est_arrival_date) {
        //     const formattedDate = moment(
        //       res.data[0]?.marine_cert_details_xx.est_arrival_date
        //     ).format("YYYY-MM-DD");
        //     setEstArrivalDate(formattedDate);
        //   } else {
        //     setEstArrivalDate(null);
        //   }


        //   if (res.data[0]?.marine_cert_details_xx.act_arrival_date) {
        //     const formattedDate = moment(
        //       res.data[0]?.marine_cert_details_xx.act_arrival_date
        //     ).format("YYYY-MM-DD");
        //     setActArrivalDate(formattedDate);
        //   } else {
        //     setActArrivalDate(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.invoice_no) {
        //     setInvoiceNo(res.data[0]?.marine_cert_details_xx.invoice_no);
        //   } else {
        //     setInvoiceNo(null);
        //   }


        //   if (res.data[0]?.marine_cert_details_xx.tranship_at) {
        //     setTranshipAt(res.data[0]?.marine_cert_details_xx.tranship_at);
        //   } else {
        //     setTranshipAt(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.no_of_packages) {
        //     setNoOfPackages(res.data[0]?.marine_cert_details_xx.no_of_packages);
        //   } else {
        //     setNoOfPackages(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.marks_and_number) {
        //     setMarksAndNumber(
        //       res.data[0]?.marine_cert_details_xx.marks_and_number
        //     );
        //   } else {
        //     setMarksAndNumber(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.idf_number) {
        //     setIdfNumber(res.data[0]?.marine_cert_details_xx.idf_number);
        //   } else {
        //     setIdfNumber(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.supplier) {
        //     setSupplier(res.data[0]?.marine_cert_details_xx.supplier);
        //   } else {
        //     setSupplier(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.clearing_agent) {
        //     setClearingAgent(res.data[0]?.marine_cert_details_xx.clearing_agent);
        //   } else {
        //     setClearingAgent(null);
        //   }

        //   if (res.data[0]?.marine_cert_details_xx.goods_desc) {
        //     setGoodsDesc(res.data[0]?.marine_cert_details_xx.goods_desc);
        //   } else {
        //     setGoodsDesc(null);
        //   }
        // }  

        // beneficiary details
        // if (res.data[0]?.primary_beneficiaries_xx) {
        //   setPrimaryBeneficiaries(res.data[0]?.primary_beneficiaries_xx?.beneficiaries);
        // }

        // if (res.data[0]?.secondary_beneficiaries_xx) {
        //   setSecondaryBeneficiaries(res.data[0]?.secondary_beneficiaries_xx?.beneficiaries);
        // }

        // set medical report
        if (res.data[0]?.pr_rq_code) {
          setPrRqCode({
            value: res.data[0]?.pr_rq_code,
            label: res.data[0]?.pr_rq_code,
          });
        } else {
          setPrRqCode(null);
        }

        // if (res.data.length === 1) {
        //   setShowView("single");
        // } else {
        //   setShowView("multiple");
        // }

        // end of marine details


        //get risk covers
        await fetchCoversForSelectedRisk(res.data[0]?._id);

        if (res.data?.length > 1) {
          setShowView("multiple");
        } else {
          setShowView("single");
        }
      } else {
        setSelectedPolicyRisk(null);
        setSelectedPolicyRiskCover(null);
        fetchSelectedCoverSmi(null, null);
      }
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCoversForSelectedRisk = async (riskDocId, addedCover = null) => {
    try {
      // console.log(`addedCover  ${JSON.stringify(addedCover, null, 2)}`);
      const res = await newRequest.post(
        "/uwPolicyRiskCover/findById",
        {
          rc_policy_docid: quoteData?._id,
          rc_risk_docid: riskDocId,
        }
      );

      setPolicyRiskCovers(res.data);
      // console.log(`setPolicyRiskCovers  ${JSON.stringify(res.data, null, 2)}`);
      // set selected risk cover
      if (res.data.length > 0) {
        if (addedCover) {
          setSelectedPolicyRiskCover(addedCover);
          await fetchSelectedCoverSmi(addedCover.rc_risk_note_no, addedCover._id);
        } else {
          setSelectedPolicyRiskCover(res.data[0]);
          const filteredTypes = vehicleCertTypes.filter((val) => val?.grouping === getPrefixSafe(res.data[0]?.dmvic_cover_xx));
          setFilteredCertTypes(filteredTypes);
        }
        if (res.data[0]?.rc_risk_note_no) {
          // fetch smi for the selected cover
          await fetchSelectedCoverSmi(res.data[0]?.rc_risk_note_no, res.data[0]?._id);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSelectedCoverSmi = async (riskNoteNo, coverDocId) => {
    try {
      const res = await newRequest.post(
        "/uwPolicyRiskSmi/findById",
        {
          smi_risk_note_no: riskNoteNo,
          smi_cover_docid: coverDocId,
        }
      );
      const formattedData = res.data.map(item => ({
        ...item,
        smi_si_fc: formatNumber(item?.smi_si_fc),
        smi_si_lc: formatNumber(item?.smi_si_lc),
        smi_rate: formatNumber(item?.smi_rate, 6),
        smi_rate_per: formatNumber(item?.smi_rate_per),
        smi_premium_fc: formatNumber(item?.smi_premium_fc),
        smi_premium_lc: formatNumber(item?.smi_premium_lc),
        smi_limit_fc: formatNumber(item?.smi_limit_fc),
        smi_limit_lc: formatNumber(item?.smi_limit_lc),
        smi_fcl_value_fc: formatNumber(item?.smi_fcl_value_fc),
        smi_fcl_value_lc: formatNumber(item?.smi_fcl_value_lc),
      }));
      setPolicyRiskCoverSmi(formattedData);
      if (res.data.length > 0) {
        setSelectedPolicyRiskCoverSmi(res.data[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };



  useEffect(() => {
    const filteredResults = policyRisks.filter(
      (item) =>
        item.pr_risk_description
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.pr_vehicle_regn
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.pr_vehicle_engine
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.pr_vehicle_chassis
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.vehicle_make_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.vehicle_model_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.vehicle_use_xx?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filteredResults);
  }, [policyRisks, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const slicedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );



  const selectRisk = async (risk) => {
    try {

      setSelectedPolicyRisk(risk);
      setPrRiskNoteNo(risk?.pr_risk_note_no);
      setPrRiskCode(risk?.pr_risk_code);
      setPrOrderNo(risk?.pr_order_no);
      setPrRiskAddress(risk?.pr_risk_address);
      setPrRiskFunction({
        value: risk?.pr_risk_function,
        label: risk?.pr_risk_function
      });

      setPrRiskJurisdiction({
        value: risk?.pr_risk_jurisdiction,
        label: risk?.pr_risk_jurisdiction
      });

      setPrRiskDescription(risk?.pr_risk_description);
      setPrClaimBasis(risk?.pr_claim_basis);
      setPrPerils(risk?.pr_perils);
      setPrRiskCategory({
        value: risk?.pr_risk_category,
        label: risk?.pr_risk_category
      });
      setPrInterestEntCode({
        value: risk?.pr_interest_ent_code,
        label: risk?.pr_interest_ent_code_xx,
      });
      setInspected(risk?.pr_inspected);
      setPrStatus(risk?.pr_status);
      setPrVehicleRegn(risk?.pr_vehicle_regn);
      setPrVehicleEngine(risk?.pr_vehicle_engine);
      setPrVehicleChassis(risk?.pr_vehicle_chassis);
      setPrVehicleYom(risk?.pr_vehicle_yom);
      setPrVehiclePassangers(risk?.pr_vehicle_passangers);
      setPrVehicleCc(risk?.pr_vehicle_cc);
      setPrRemarks(risk?.pr_remarks);
      setPrVehicleTonnage(risk?.pr_vehicle_tonnage);

      setPrVehicleColor({
        value: risk?.pr_vehicle_color,
        label: risk?.pr_vehicle_color,
      });

      setPrVehicleUse({
        value: risk?.pr_vehicle_use,
        label: risk?.vehicle_use_xx,
      });

      setPrVehicleBody({
        value: risk?.pr_vehicle_body,
        label: risk?.vehicle_body_type_xx,
      });

      setPrVehicleType({
        value: risk?.pr_vehicle_type,
        label: risk?.vehicle_type_xx,
      });

      setPrVehicleCert({
        value: risk?.pr_vehicle_cert,
        label: risk?.vehicle_cert_type_xx,
      });

      setPrVehicleModel({
        vehicle_make: risk?.pr_vehicle_make,
        vehicle_model: risk?.pr_vehicle_model,
        value: risk?.pr_vehicle_model,
        label: risk?.vehicle_model_xx,
      });

      setPrRiskFunction({
        value: risk?.pr_risk_function,
        label: risk?.risk_function_xx,
      });

      setPrRiskArea({
        value: risk?.pr_risk_area,
        label: risk?.risk_area_xx,
      });

      if (risk?.pr_other_attributes) {
        setPrOtherAttributes(risk?.pr_other_attributes);
      }

      if (risk?.pr_full_name) {
        setPrFullName(risk?.pr_full_name);
      }

      if (risk?.pr_gender) {
        setPrGender({
          value: risk?.pr_gender,
          label: risk?.person_gender_xx,
        });
      }

      if (risk?.pr_person_dob) {
        const formattedDate = moment(risk?.pr_person_dob).format("YYYY-MM-DD");
        setPrPersonDob(formattedDate);
      }

      if (risk?.person_age_xx) {
        setPersonAgeXx(risk?.person_age_xx);
      }

      if (risk?.pr_person_id) {
        setPrPersonId(risk?.pr_person_id);
      }

      if (risk?.pr_member_no) {
        setPrMemberNo(risk?.pr_member_no);
      }

      if (risk?.pr_member_fm) {
        const formattedDate = moment(risk?.pr_member_fm).format("YYYY-MM-DD");
        setPrMemberFm(formattedDate);
      }

      if (risk?.pr_member_to) {
        const formattedDate = moment(risk?.pr_member_to).format("YYYY-MM-DD");
        setPrMemberTo(formattedDate);
      }

      if (risk?.pr_member_status) {
        setPrMemberStatus({
          value: risk?.pr_member_status,
          label: risk?.member_status_xx,
        });
      }

      if (risk?.pr_person_occupation) {
        setPrPersonOccupation({
          value: risk?.pr_person_occupation,
          label: risk?.person_occupation_xx,
        });
      }

      if (risk?.pr_person_email) {
        setPrPersonEmail(risk?.pr_person_email);
      }

      if (risk?.pr_person_phone) {
        setPrPersonPhone(risk?.pr_person_phone);
      }

      if (risk?.pr_claim_basis) {
        setPrClaimBasis(risk?.pr_claim_basis);
      } else {
        setPrClaimBasis([]);
      }

      if (risk?.pr_perils) {
        setPrPerils(risk?.pr_perils);
      } else {
        setPrPerils([]);
      }
      // fetch covers associated with the risk
      await fetchCoversForSelectedRisk(risk?._id);

      setShowView("single");
    } catch (error) {
      console.log(error);
    }
  };


  const addNewRisk = async () => {
    try {
      // console.log(`addNewRisk   ... im getting called...`);
      const res = await newRequest.post("/uwPolicyRisk/add", {
        pr_risk_note_no: quoteData?.pl_risk_note_no,
        pr_risk_code: `R-${policyRisks?.length || 0 + 1}` || Date.now().toString(),
        pr_order_no: 1,
        pr_risk_address: prRiskAddress,
        pr_risk_function: prRiskFunction?.value,
        pr_risk_area: prRiskArea?.value,
        pr_risk_jurisdiction: prRiskJurisdiction?.value,
        pr_risk_description: "",
        pr_claim_basis: [],
        pr_risk_category: null,
        pr_status: prStatus,
        pr_fm_date: prFmDate,
        pr_to_date: prToDate,
        pr_remarks: "",
        pr_policy_docid: quoteData?._id,
        pr_policy_no: quoteData?.pl_no,
        pr_subclass_docid: selectedSubClass._id,
        pr_mc_code: selectedSubClass?.ps_mc_code,
        pr_sc_code: selectedSubClass?.ps_sc_code,
        pr_end_index: quoteData?.pl_end_index,
        product_code: quoteData?.pl_product_code,
        term_code: quoteData?.pl_term_code,
        pr_marine_info: prMarineInfo,
        pr_bond_info: prBondInfo,
        pr_interest_ent_code: prInterestEntCode?.value,
      });

      setPolicyRisks((prev) => [...prev, res?.data]);
      await resetRiskData();
      selectRisk(res?.data);
      // console.log(`savedRisk  ${JSON.stringify(res?.data, null, 2)}`);
      // await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
      // console.log(`quoteData?.product_type_xx is ${quoteData?.product_type_xx}`)
      if (["term life", "whole life"].includes(quoteData?.product_type_xx)) {
        setRiskEntity(null);
        setEntityAction("changeInsured");
        setEditLifeEntity(true);
      }
      setShowView("single");
    } catch (error) {
      console.log(error);
    }
  };

  const resetRiskData = async () => {
    try {
      // reset all risk data
      setSelectedPolicyRisk(null);
      setSelectedPolicyRiskCover(null);
      // refreshing smi
      await fetchSelectedCoverSmi(null, null);
      setPrRiskNoteNo("");
      setPrRiskCode("");
      setPrOrderNo("");
      setPrRiskAddress("");
      setPrRiskFunction("");
      setPrRiskDescription("");
      setPrClaimBasis([]);
      setPrPerils([]);

      setPrRiskCategory("");
      setInspected("N");
      setPrStatus("On Cover");
      setPrVehicleRegn("");
      setPrVehicleEngine("");
      setPrVehicleChassis("");
      setPrVehicleYom();
      setPrVehiclePassangers(0);
      setPrVehicleCc(0);
      setPrRemarks("");
      setPrVehicleTonnage(0);
      setPrGender({
        value: "Unspecified",
        label: "Unspecified",
      });
      setPrVehicleColor({
        value: null,
        label: null,
      });
      setPrVehicleUse({
        value: null,
        label: null,
      });

      setPrVehicleBody({
        value: null,
        label: null,
      });

      setPrVehicleType({
        value: null,
        label: null,
      });

      setPrVehicleCert({
        value: null,
        label: null,
      });

      setPrVehicleModel({
        vehicle_make: null,
        vehicle_model: null,
        value: null,
        label: null,
      });
      setPrInterestEntCode({
        value: null,
        label: null,
      });
      setPrRiskFunction({
        risk_function: null,
        value: null,
        label: null,
      });
      setPrRiskArea({
        risk_area: null,
        value: null,
        label: null,
      });

      setPrOtherAttributes([]);
      setPrFullName("");
      setPrGender({
        value: "Unspecified",
        label: "Unspecified",
      });
      setPrMemberStatus({
        value: null,
        label: null,
      });
      setPrPersonOccupation({
        value: null,
        label: null,
      });

      setPrPersonEmail("");
      setPrPersonPhone("");
      setPrPersonDob("");
      setPersonAgeXx("");
      setPrPersonId("");
      setPrMemberNo("");
      setPrMemberFm("");
      setPrMemberTo("");

      setPrMarineInfo(initialMarineInfo);
    } catch (error) {
      console.log(error);
    }
  };

  const setRiskData = () => {
    try {

      console.log(`prInterestEntCode?.value ... ${prInterestEntCode?.value}`);

      return {
        pr_org_code: currentUser.usr_org_code,
        pr_risk_note_no: quoteData?.pl_risk_note_no,
        pr_risk_code: prVehicleRegn || Date.now().toString(),
        pr_order_no: 1,
        pr_risk_address: prRiskAddress,
        pr_risk_function: prRiskFunction?.value,
        pr_risk_area: prRiskArea?.value,
        pr_risk_jurisdiction: prRiskJurisdiction?.value,
        pr_risk_description: prRiskDescription,
        pr_claim_basis: prClaimBasis || [],
        pr_risk_category: prRiskCategory?.value,
        pr_status: prStatus,
        pr_fm_date: prFmDate,
        pr_to_date: prToDate,
        pr_vehicle_regn: prVehicleRegn,
        pr_vehicle_engine: prVehicleEngine,
        pr_vehicle_chassis: prVehicleChassis,
        pr_vehicle_yom: prVehicleYom,
        pr_vehicle_color: prVehicleColor?.value,
        pr_vehicle_make: prVehicleModel?.vehicle_make,
        pr_vehicle_model: prVehicleModel?.vehicle_model,
        pr_vehicle_cc: prVehicleCc || 0,
        pr_vehicle_passangers: prVehiclePassangers || 0,
        pr_vehicle_tonnage: prVehicleTonnage || 0,
        pr_vehicle_use: prVehicleUse?.value,
        pr_vehicle_body: prVehicleBody?.value,
        pr_vehicle_type: prVehicleType?.value,
        pr_vehicle_cert: prVehicleCert?.value,
        pr_remarks: prRemarks,
        pr_policy_docid: quoteData?._id,
        pr_policy_no: quoteData?.pl_no,
        pr_subclass_docid: selectedSubClass._id,
        pr_mc_code: selectedSubClass?.ps_mc_code,
        pr_sc_code: selectedSubClass?.ps_sc_code,
        pr_end_index: quoteData?.pl_end_index,
        pr_full_name: prFullName,
        pr_gender: prGender?.value,
        pr_person_dob: prPersonDob,
        pr_person_id: prPersonId,
        pr_member_no: prMemberNo,
        pr_member_fm: prMemberFm || prFmDate,
        pr_member_to: prMemberTo || prToDate,
        pr_member_status: prMemberStatus?.value || "New",
        pr_other_attributes: prOtherAttributes,
        pr_person_email: prPersonEmail,
        pr_person_phone: prPersonPhone,
        pr_person_occupation: prPersonOccupation?.value ? prPersonOccupation?.value : "",
        product_code: quoteData?.pl_product_code,
        term_code: quoteData?.pl_term_code,
        pr_latitude: prLatitude,
        pr_longitude: prLongitude,
        pr_place_name: prPlaceName,
        pr_perils: prPerils || [],
        pr_marine_info: prMarineInfo,
        pr_bond_info: prBondInfo,
        pr_interest_ent_code: prInterestEntCode?.value ? prInterestEntCode?.value : "",
        pr_endorsed: selectedPolicyRisk?.pr_endorsed || "N",

        pr_eq_zone: prEqZone?.value || "",
        pr_eq_sub_zone: prEqSubZone?.value || "",
        pr_flood_zone: prFloodZone?.value || "",
        pr_flood_sub_zone: prFloodSubZone?.value || "",
      };
    } catch (error) {
      console.log(error);
    }
  }

  const saveRisk = async (show = "Y") => {
    try {

      const changedSubClass = policySubClasses?.filter((obj) => obj.changed_xx === "Y");
      for (let i = 0; i < changedSubClass.length; i++) {
        await newRequest.put(
          `/uwPolicySc/upd/${changedSubClass[i]._id}`,
          {
            ps_endorsed: changedSubClass[i].ps_endorsed
          }
        );
      }

      const changedCovers = policyRiskCovers?.filter((obj) => obj.changed_xx === "Y");
      for (let i = 0; i < changedCovers.length; i++) {
        await newRequest.post(
          `/uwPolicyRiskCover/upd/${changedCovers[i]._id}`,
          {
            rc_desc: changedCovers[i].rc_desc,
            rc_comm_perc: parseFloat(changedCovers[i].rc_comm_perc),
            rc_comm_tax_perc: parseFloat(changedCovers[i].rc_comm_tax_perc)
          }
        );
      }

      const isIdEmptyOrNull = !selectedPolicyRisk?._id;

      // console.log(`isIdEmptyOrNull is ${isIdEmptyOrNull}`);

      if (isIdEmptyOrNull) {
        // add risk

        const riskResponse = await newRequest.post("/uwPolicyRisk/add", setRiskData());

        fetchPolicyRisks(quoteData._id, selectedSubClass._id);
        selectRisk(riskResponse);
        if (show === "Y") {
          showToast("Added!", "success");
        }
      } else {
        // update risk
        await newRequest.put(`/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`, setRiskData());
        await saveSmis();
        if (show === "Y") {
          showToast("Risk Updated!", "success");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };


  //deal with dates
  const handleFromDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedFromDate = moment(e.target.value).format("YYYY-MM-DD");
        setPrFmDate(formattedFromDate);
        setSelectedPolicyRisk(prev => ({ ...prev, pr_fm_date: formattedFromDate }));
        calculateDateDifference();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleToDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
        setPrToDate(formattedToDate);
        setSelectedPolicyRisk(prev => ({ ...prev, pr_to_date: formattedToDate }));
        calculateDateDifference();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const calculateDateDifference = () => {
    if (prFmDate && prToDate) {
      const fromDate = moment(prFmDate, "YYYY-MM-DD");
      const toDate = moment(prToDate, "YYYY-MM-DD");
      const differenceInDays = toDate.diff(fromDate, "days");
      //console.log(`Difference in days: ${differenceInDays}`);
      setDaysDifference(differenceInDays + 1);
      // Now you can use the differenceInDays variable as needed.
    }
  };

  const [smiPage, setSmiPage] = useState(0);
  const [smiRowsPerPage, setSmiRowsPerPage] = useState(5);
  const handleSmiChangePage = (event, newPage) => {
    setSmiPage(newPage);
  };

  const handleSmiRowsPerPage = (event) => {
    try {
      setSmiRowsPerPage(parseInt(event.target.value, 5));
      setSmiPage(0);
    } catch (error) {
      console.log(error)
    }
  };

  const fetchEmails = () => {

  };

  const isRcCommPercDisabled = () => {
    if (quoteData?.document_enabled_xx === "N") return true;
    if (quoteData?.document_enabled_xx === "Y") {
      if (currentUser.user_type_xx === "superadmin") return false;
      return getLimitValue("UW1008") !== "Y";
    }
    return true;
  };

  const isRcCommTaxDisabled = (commRate) => {
    if (quoteData?.document_enabled_xx === "N") return true;
    if (quoteData?.document_enabled_xx === "Y") {
      if (currentUser.user_type_xx === "superadmin" && commRate > 0) return false;
      return getLimitValue("UW1008") !== "Y" && commRate > 0;
    }
    return true;
  };


  const handleCoverInputChange = (e, id, field) => {
    try {
      const newCoverData = [...policyRiskCovers];
      const index = newCoverData.findIndex(cover => cover?._id === id);
      if (index !== -1) {
        newCoverData[index][field] = e.target.value;
        newCoverData[index]["changed_xx"] = "Y";

        if (field === "rc_comm_perc" && formatNumber(e.target.value) === 0) {
          newCoverData[index]["rc_comm_tax_perc"] = 0;
        }

        setPolicyRiskCovers(newCoverData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCoverSetCommRate = (rowId, commRate, commTaxRate) => {
    try {
      const newCoverData = [...policyRiskCovers];
      const index = newCoverData.findIndex(cover => cover?._id === rowId);
      if (index !== -1) {
        newCoverData[index]["rc_comm_perc"] = formatNumber(commRate);
        newCoverData[index]["rc_comm_tax_perc"] = formatNumber(commTaxRate);
        newCoverData[index]["changed_xx"] = "Y";
        setPolicyRiskCovers(newCoverData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCoverBlur = (id, field) => {
    try {
      const updatedData = [...policyRiskCovers];
      const index = updatedData.findIndex(cover => cover?._id === id);
      if (index !== -1) {
        const value = updatedData[index][field];
        const numberFields = [
          "rc_comm_perc", "rc_comm_tax_perc"
        ];

        if (numberFields.includes(field)) {
          updatedData[index][field] = formatNumber(value);
        } else {
          updatedData[index][field] = value;
        }

        setPolicyRiskCovers(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetCertificateFields = () => {
    setSelectedPolicyRisk(prev => ({
      ...prev,
      pr_certificate_no: null,
      pr_certificate_docid: null,
      pr_cert_date_fm: null,
      pr_cert_date_to: null,
      pr_cert_issued_on: null,
      pr_cert_issued_by: null,
    }));
  };


  const handleCheckboxChange = (e, id) => {
    try {
      const newSmiData = [...policyRiskCoverSmi];
      const index = newSmiData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newSmiData[index].smi_add_to_si = e.target.checked ? 'Y' : 'N';
        setPolicyRiskCoverSmi(newSmiData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSmiInputChange = (e, id, field) => {
    try {
      const newSmiData = [...policyRiskCoverSmi];
      const index = newSmiData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newSmiData[index][field] = e.target.value;
        newSmiData[index]["smi_endorsed"] = "Y";
        setPolicyRiskCoverSmi(newSmiData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSmiBlur = (id, field) => {
    try {
      const updatedData = [...policyRiskCoverSmi];
      const index = updatedData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        const value = updatedData[index][field];
        const numberFields = [
          "smi_rate",
          "smi_rate_per",
          "smi_premium_fc",
          "smi_premium_lc",
          "smi_si_fc",
          "smi_si_lc",
          "smi_fcl_value_fc",
          "smi_fcl_value_lc",
          "smi_annual_wage_fc",
          "smi_annual_wage_lc",
          "smi_wiba_wage_fc",
          "smi_wiba_wage_lc",
          "smi_limit_fc",
          "smi_limit_lc"
        ];

        if (numberFields.includes(field)) {
          updatedData[index][field] = formatNumber(value, ["smi_rate"].includes(field) ? 6 : 2);
        } else if (numberFields.includes("smi_qty")) {
          updatedData[index][field] = formatNumber(value, 0);
        } else {
          updatedData[index][field] = value;
        }
        setPolicyRiskCoverSmi(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const addNewSmiRow = async () => {
    try {
      // check default premium rates
      let defaultPremiumRate = 0;
      if (quoteData?.pl_ins_ent_code) {
        const res = await newRequest.post("/uwSubClassCover/defaultRate",
          {
            ent_code: quoteData?.pl_ins_ent_code,
            mc_code: selectedPolicyRiskCover?.rc_mc_code,
            sc_code: selectedPolicyRiskCover?.rc_sc_code,
            cc_code: selectedPolicyRiskCover?.rc_cc_code,
          });
        // console.log(`uwSubClassCover  ${JSON.stringify(res.data, null, 2)}`);
        defaultPremiumRate = res.data?.cr_prem_rate || 0;
      }

      const smiCode = generateUniqueCode();
      const defaultSmiRow = {
        _id: smiCode,
        sr_no: '',
        smi_org_code: currentUser.usr_org_code,
        smi_risk_note_no: quoteData?.pl_risk_note_no,
        smi_pr_code: quoteData?.pl_product_code,
        smi_mc_code: selectedPolicyRiskCover?.rc_mc_code,
        smi_sc_code: selectedPolicyRiskCover?.rc_sc_code,
        smi_cc_code: selectedPolicyRiskCover?.rc_cc_code,
        smi_policy_docid: selectedPolicyRiskCover?.rc_policy_docid,
        smi_risk_docid: selectedPolicyRiskCover?.rc_risk_docid,
        smi_cover_docid: selectedPolicyRiskCover?._id,
        smi_code: smiCode,
        smi_desc: '',
        smi_rate: defaultPremiumRate,
        smi_rate_per: 100,
        smi_premium_fc: 0,
        smi_premium_lc: 0,
        smi_si_fc: 0,
        smi_si_lc: 0,
        smi_fcl_value_fc: 0,
        smi_fcl_value_lc: 0,
        smi_qty: 0,
        smi_annual_wage_fc: 0,
        smi_annual_wage_lc: 0,
        smi_wiba_wage_fc: 0,
        smi_wiba_wage_lc: 0,
        smi_limit_fc: 0,
        smi_limit_lc: 0,
        smi_end_index: quoteData?.pl_end_index,
        smi_add_to_si: "Y",
        calc_premium_fc: 0,
        calc_premium_lc: 0,
        calc_si_fc: 0,
        calc_si_lc: 0,
        flag_xx: "new",
        createdBy: currentUser.usr_id,
        updatedBy: currentUser.usr_id,
      };
      setPolicyRiskCoverSmi([...policyRiskCoverSmi, defaultSmiRow]);
    } catch (error) {
      console.log(error)
    }
  };


  const compareRates = async (cover) => {
    try {
      // console.log(`cover...  ${JSON.stringify(cover, null, 2)}`);
      const res = await newRequest.post(
        "/uwCoverCommRate/compareRates",
        {
          mc_code: cover?.mc_code,
          sc_code: cover?.sc_code,
          cc_code: cover?.cc_code,
        }
      );

      if (res.data?.length === 0) {
        showToast(`No rates found to compare for ${cover?.coverText}`, "success");
      } else {
        // console.log(`ratesComparison...  ${JSON.stringify(res.data, null, 2)}}`);
        setRatesComparison(res.data);
        setRatesComparisonDialog(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddClaimBasis = async () => {
    try {
      if (basisOfClaim) {
        try {
          const res = await newRequest.post(
            "/uwPolicyRisk/claimBasisAdd/",
            {
              risk_docid: selectedPolicyRisk?._id,
              basis_text: basisOfClaim
            }
          );

          if (res.data?.msg === "added") {
            setPrClaimBasis((prevParams) => [...prevParams, res.data?.doc]);
            showToast(`Added`, "success");
          } else {
            showToast("Error adding basis of claim!", "error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      setBasisOfClaim("");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddPeril = async () => {
    try {
      if (peril) {
        try {
          const res = await newRequest.post(
            "/uwPolicyRisk/addPeril",
            {
              risk_docid: selectedPolicyRisk?._id,
              peril: peril
            }
          );

          if (res.data?.msg === "added") {
            setPrPerils((prevParams) => [...prevParams, res.data?.doc]);
            showToast(`Added`, "success");
          } else {
            showToast("Error adding peril!", "error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      setPeril("");
    } catch (error) {
      console.log(error);
    }
  };

  const handleNoteClick = (text) => {
    console.log(`${text} clicked`);
    // Add your function logic here
  };

  const renderNote = (note) => {
    const parts = note.split(/(SUM INSURED|RATE|PREMIUM|RATE|FREE COVER LIMIT)/);
    return parts.map((part, index) => {
      if (["SUM INSURED", "RATE", "PREMIUM", "RATE", "FREE COVER LIMIT"].includes(part)) {
        return (
          <a href="#" key={index} onClick={() => handleNoteClick(part)} style={{ cursor: 'pointer', textDecoration: "none", color: "inherit" }}>
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const handleRiAllocationData = (name, value) => {
    setSelectedSubClass((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const riAllocationDescription = [
    { value: "Cover", description: "Reinsurance is allocated according to covers that apply regadless of the number of items covered" },
    { value: "Top Location", description: "Reinsurance is distributed by identifying and allocating based on the risk item with the highest exposure" },
    { value: "Risk Based", description: "Allocation is done based on individual risk items" },
    { value: "None", description: "No reinsurance allocation is done" },
  ]

  const notes = [
    `The SUM INSURED entered should be in ${quoteData?.pl_cur_code}`,
    'When RATE is entered, premium field is overridden. Premium will be calculated based on SUM INSURED and RATE',
    'If you enter both RATE & PREMIUM, premium will be calculated based on SUM INSURED and RATE',
    'You can directly enter PREMIUM for each item but the RATE field should be zero otherwise entered RATE will be used',
    'For items with FREE COVER LIMIT, the rate will be applied on the SUM INSURED minus FREE COVER LIMIT value'
  ];

  const handleSubClassChange = (value, rowId, field) => {
    try {
      setPolicySubClasses((prevData) => {
        const updated = prevData.map((item) =>
          item._id === rowId
            ? { ...item, [field]: value, changed_xx: "Y" }
            : item
        );

        // Get updated subclass and set it as selected
        const updatedSelected = updated.find(sc => sc._id === rowId);
        if (updatedSelected) {
          setSelectedSubClass({ ...updatedSelected }); // force fresh object reference
        }

        return updated;
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleRiskEndorsedChange = (value, rowId, field) => {
    try {
      // console.log("handleRiskEndorsedChange");
      setPolicyRisks((prevData) => {
        const updated = prevData.map((item) =>
          item._id === rowId
            ? { ...item, [field]: value, changed_xx: "Y" }
            : item
        );

        // Get updated subclass and set it as selected
        const updatedSelected = updated.find(sc => sc._id === rowId);
        if (updatedSelected) {
          setSelectedPolicyRisk({ ...updatedSelected }); // force fresh object reference
        }

        return updated;
      });
    } catch (error) {
      console.log(error);
    }
  };

  const issueCertificate = async () => {
    try {
      setIsProcessing(true);
      setIsProcessingTitle(t('issuingDmvicCertificate'));
      setIsIssueCertOpen(false);
      let res = null;
      let requestObject = {
        CertificateType: selectedPolicyRiskCover?.dmvic_cover_xx,
        policyNo: quoteData?.pl_no,
        AssrEntCode: quoteData?.pl_assr_ent_code,
        AssrEntName: quoteData?.pl_assr_entity_name,
        IntEntCode: quoteData?.pl_ins_ent_code,
        IntEntName: quoteData?.pl_int_entity_name,

        PolicyDocId: quoteData?._id,
        RiskDocId: selectedPolicyRisk?._id,
        CoverDocId: selectedPolicyRiskCover?._id,
        Typeofcover: formatStringToNumberV2(selectedPolicyRiskCover?.dmvic_code_xx),
        Policyholder: quoteData?.insured_details_xx?.ent_name,
        policynumber: quoteData?.pl_no,
        Commencingdate: moment(selectedPolicyRisk?.pr_fm_date).format("DD/MM/YYYY"),
        Expiringdate: moment(selectedPolicyRisk?.pr_to_date).format("DD/MM/YYYY"),
        Registrationnumber: selectedPolicyRisk?.pr_vehicle_regn,
        Chassisnumber: selectedPolicyRisk?.pr_vehicle_chassis,
        Phonenumber: getLastXDigits(normalizeKenyaPhone(quoteData?.insured_details_xx?.ent_phone_no), 9),
        Bodytype: selectedPolicyRisk?.pr_vehicle_body || "",
        Licensedtocarry: selectedPolicyRisk?.pr_vehicle_passangers,
        Vehiclemake: selectedPolicyRisk?.pr_vehicle_make || "",
        Vehiclemodel: selectedPolicyRisk?.pr_vehicle_model || "",
        Enginenumber: selectedPolicyRisk?.pr_vehicle_engine || "",
        Email: certificateEmail,
        SumInsured: formatStringToNumberV2(vehicleValue),
        InsuredPIN: quoteData?.insured_details_xx?.ent_tax_no,
        Yearofmanufacture: selectedPolicyRisk?.pr_vehicle_yom,
        HudumaNumber: ""
      }

      if (selectedPolicyRiskCover?.dmvic_cover_xx === "A_Single") {
        res = await newRequest.post("/dmvic/issueDmvicCert",
          {
            ...requestObject,
            TypeOfCertificate: parseFloat(prVehicleCert?.value)
          });
      } else if (selectedPolicyRiskCover?.dmvic_cover_xx === "B_Single") {
        res = await newRequest.post("/dmvic/issueDmvicCert",
          {
            ...requestObject,
            Tonnage: parseFloat(prVehicleTonnage) || 0,
            VehicleType: parseFloat(prVehicleType?.value)
          });
      } else if (selectedPolicyRiskCover?.dmvic_cover_xx === "C_Single") {
        res = await newRequest.post("/dmvic/issueDmvicCert",
          {
            ...requestObject,
            Tonnage: parseFloat(prVehicleTonnage) || 0
          });
      } else if (selectedPolicyRiskCover?.dmvic_cover_xx === "D_Single") {
        res = await newRequest.post("/dmvic/issueDmvicCert",
          {
            ...requestObject,
            Tonnage: prVehicleTonnage || 0,
            TypeOfCertificate: parseFloat(prVehicleCert?.value)
          });
      }

      console.log(`issueDmvicCert  ${JSON.stringify(res.data, null, 2)}`);

      if (res.data?.result?.success === true) {
        showToast(t('certificateIssued', {
          param1: res.data?.result?.callbackObj?.issueCertificate?.actualCNo,
          param2: res.data?.result?.callbackObj?.issueCertificate?.Email
        }),
          "success");
        setIsProcessingTitle(t('gettingDmvicCertificate', { param1: res.data?.result?.callbackObj?.issueCertificate?.actualCNo }));
        const pdf = await newRequest.post("/dmvic/getCerfPdf",
          {
            CertificateNumber: res.data?.result?.callbackObj?.issueCertificate?.actualCNo,
            policyDocid: quoteData?._id,
            riskDocid: selectedPolicyRisk?._id,
            certFm: selectedPolicyRisk?.pr_fm_date,
            certTo: selectedPolicyRisk?.pr_to_date,
            certType: selectedPolicyRiskCover?.dmvic_cover_xx,
            regnNo: selectedPolicyRisk?.pr_vehicle_regn,
            policyNo: quoteData?.pl_no,
            assrEntCode: quoteData?.pl_assr_ent_code,
            intEntCode: quoteData?.pl_ins_ent_code,
          }
        );
        logData("DMVIC Certificate PDF", pdf.data);
        setBinaryDocid(pdf.data?.savedCertId || null);
        setPdfUrl(pdf.data?.result?.callbackObj?.URL);
        setIsProcessing(false);
        setPdfPreviewDialogOpen(true);
      } else {
        setIsProcessing(false);
        setIsIssueCertOpen(true);

        if (res.data?.result?.Error?.length > 0) {

          // check NTSA Records Error
          const hasNtsaError = Array.isArray(res.data?.result?.Error) &&
            res.data?.result?.Error.some(err => err?.errorCode === "ERR10001");

          if (hasNtsaError) {
            setObjectToAction({
              object_id: res.data?.result?.callbackObj?.IssuanceRequestID,
              action_text: `Provided details do NOT match NTSA records. Do you still want to proceed and issue the certificate?`,
            });
            setConfirmDialogAction("overrideNtsa");
            setIsConfirmDialogOpen(true);
            return;
          } else {

            let errorObject = {
              result_status: "error",
              result_msg: `Oops!, sorry ${currentUser?.usr_full_name}, following exceptions occured while issuing certificate`,
            };

            const errors = res.data?.result?.Error?.map((val, index) => ({
              msg_index: index + 1,
              msg_no: val?.errorCode,
              msg_text: val?.errorText,
              msg_type: "error",
            })) || [];

            errorObject.result_msg_list = errors;

            setIsIssueCertOpen(false);
            // logData("DMVIC Certificate Issuance Errors", errorObject);
            setValidationMessagesResult(errorObject);
            setValidationMsgDialog(true);
            return;
          }
        } else {
          logData("res.data", res.data);
          let errorObject = {
            result_status: "error",
            result_msg: `Oops!, sorry ${currentUser?.usr_full_name}, following exceptions occured while issuing certificate`,
          };
          errorObject.result_msg_list = [{
            msg_index: 1,
            msg_no: res.data?.code,
            msg_text: res.data?.message,
            msg_type: "error",
          }];

          setIsIssueCertOpen(false);
          setValidationMessagesResult(errorObject);
          setValidationMsgDialog(true);
          return;
        }
      }
    } catch (error) {

      console.log(error);
    }
  };



  useEffect(() => {
    try {
      if (quoteData?._id) {
        fetchSubClasses();
      }
    } catch (error) {
      console.log(error);
    }
  }, [quoteData?._id]);

  useEffect(() => {
    try {
      if (["marine_cert"].includes(selectedSubClass?.sc_view_xx)) {
        fetchShippingMode();
        fetchPorts();
      }
    } catch (error) {
      console.log(error);
    }
  }, [selectedSubClass]);

  useEffect(() => {
    const filteredResults = sysCodesData.filter((item) =>
      item.sys_name?.toLowerCase().includes(sysCodeSearchTerm.toLowerCase())
    );
    setFilteredSysCodesData(filteredResults);
  }, [sysCodesData, sysCodeSearchTerm]);

  useEffect(() => {
    fetchSubClassCovers();
  }, [quoteData?._id, selectedSubClass?._id]);


  useEffect(() => {
    if (selectedPolicyRisk) {
      setPrRiskFunction({
        value: selectedPolicyRisk?.pr_risk_function,
        label: selectedPolicyRisk?.risk_function_xx,
      });

      setPrRiskCategory({
        value: selectedPolicyRisk?.pr_risk_category,
        label: selectedPolicyRisk?.pr_risk_category,
      });

      setPrRiskArea({
        value: selectedPolicyRisk?.pr_risk_area,
        label: selectedPolicyRisk?.risk_area_xx,
      });

      setPrRiskJurisdiction({
        value: selectedPolicyRisk?.pr_risk_jurisdiction,
        label: selectedPolicyRisk?.pr_risk_jurisdiction,
      });

      setPrVehicleColor({
        value: selectedPolicyRisk?.pr_vehicle_color,
        label: selectedPolicyRisk?.pr_vehicle_color,
      });

      setPrVehicleUse({
        value: selectedPolicyRisk?.pr_vehicle_use,
        label: selectedPolicyRisk?.vehicle_use_xx,
      });

      setPrVehicleBody({
        value: selectedPolicyRisk?.pr_vehicle_body,
        label: selectedPolicyRisk?.vehicle_body_type_xx,
      });

      setPrVehicleType({
        value: selectedPolicyRisk?.pr_vehicle_type,
        label: selectedPolicyRisk?.vehicle_type_xx,
      });

      setPrVehicleCert({
        value: selectedPolicyRisk?.pr_vehicle_cert,
        label: selectedPolicyRisk?.vehicle_cert_type_xx,
      });

      setPrEqZone({
        value: selectedPolicyRisk?.pr_eq_zone,
        label: selectedPolicyRisk?.pr_eq_zone_xx,
      });

      setPrEqSubZone({
        value: selectedPolicyRisk?.pr_eq_sub_zone,
        label: selectedPolicyRisk?.pr_eq_sub_zone_xx,
      });

      if (selectedPolicyRisk?.pr_flood_zone) {
        setPrFloodZone({
          value: selectedPolicyRisk?.pr_flood_zone,
          label: selectedPolicyRisk?.pr_flood_zone_xx,
        });
      }

      if (selectedPolicyRisk?.pr_flood_sub_zone) {
        setPrFloodSubZone({
          value: selectedPolicyRisk?.pr_flood_sub_zone,
          label: selectedPolicyRisk?.pr_flood_sub_zone_xx,
        });
      }

    }
  }, [selectedPolicyRisk]);

  useEffect(() => {
    setPolicyRisks([]);
    fetchPolicyRisks(quoteData?._id, selectedSubClass?._id);
    fetchVehicleModels();
    fetchVehicleUse();
    fetchVehicleBodyTypes();
    fetchVehicleTypes();
    fetchVehicleCertTypes();
    fetchVehicleColor();
    fetchRiskFunctions();
    fetchRiCategories();
    fetchRiskAreas();
    fetchGender();
    fetchMemberStatus();
    fetchOccupations();
    fetchRiskJurisdictions();
    fetchRiAllocationTypes();
    fetchBondTypes();
    fetchBondCategories();
    fetchBondPurposes();
    fetchRelationshipTypes();
    fetchEqZones();
    fetchFloodZones();

  }, [quoteData?._id, selectedSubClass?._id]);

  return (
    <>
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="uw-policy-risk">
          {quoteData?.appl_sub_classes_count > 1 &&
            <div className="multi-sc-wrapper">
              {policySubClasses?.map((sc) => {
                const IconComponent = qilloIconMap[sc?.sc_icon_xx] || HiHome;
                return (
                  <div key={sc?._id}
                    className={`${selectedSubClass?._id === sc?._id ? "multi-sc-item current" : "multi-sc-item"}`}
                    onClick={async () => {
                      try {
                        setPolicyRisks([]);
                        setSelectedSubClass(sc);
                      } catch (error) {
                        console.log(error);
                      }
                    }}>
                    <IconComponent className="sub-menu-icon" />
                    <div className="sub-menu-content">
                      <span className="sub-menu-name">{sc?.sc_name_xx}</span>
                      <span className="sub-menu-description">{`${t('class').toUpperCase()} : ${sc?.ps_mc_code} - ${t('subClass').toUpperCase()} : ${sc?.ps_sc_code}`}</span>
                    </div>
                    {quoteData?.document_enabled_xx === "Y" &&
                      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                        {quoteData?.end_internal_code_xx !== "000" &&
                          <ToggleSwitch
                            value={sc?.ps_endorsed}
                            onChange={(newValue) => {
                              try {
                                setSelectedSubClass(sc);
                                handleSubClassChange(newValue, sc?._id, "ps_endorsed");
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            label={t('endorsed')}
                            labelPosition="start"
                            labelWidth="max-content"
                            border="N"
                          />}
                        <CircularButton
                          currentTheme={currentTheme}
                          color="#D32F2F"
                          onClick={() => {
                            try {
                              setObjectToAction({
                                object_id: sc?._id,
                                action_text: `Delete ${sc?.sc_name_xx}?. </br></br>PLEASE NOTE : All risks under this class will be deleted`,
                                new_doc_status: "deleteSubClass",
                                param1: sc?.sc_name_xx
                              });
                              setConfirmDialogAction("deleteSubClass");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          icon={<MdDelete />}
                          width={"30px"}
                          height={"30px"} />
                      </div>}
                  </div>
                )
              })}
              {quoteData?.document_enabled_xx === "Y" &&
                <div className="multi-sc-item"
                  style={{ paddingRight: "0px", width: "max-content", alignItems: "center", justifyContent: "center" }}
                  onClick={async () => {
                    try {
                      await fetchProductSubClasses(quoteData?.pl_product_code);
                      setIsProductScOpen(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}>
                  <MdAdd className="sub-menu-icon" />
                </div>}
            </div>}
          {quoteData?.appl_sub_classes_count > 1 &&
            <div className="conds-excess-wrapper">
              <hr className="separator-h" />
              <UwPolicyCond
                key={`cond-${selectedSubClass?._id}`}
                quoteData={quoteData}
                refreshQuote={() => { }}
                ref={policyCondRef}
                profileLimitValues={profileLimitValues}
                mcCode={selectedSubClass?.ps_mc_code}
                scCode={selectedSubClass?.ps_sc_code}
                scEndorsed={selectedSubClass?.ps_endorsed}
              />
              {/* <hr className="separator-h" /> */}
              <UwPolicyExcess
                key={`excess-${selectedSubClass?._id}`}
                quoteData={quoteData}
                refreshQuote={() => { }}
                ref={policyExcessRef}
                profileLimitValues={profileLimitValues}
                mcCode={selectedSubClass?.ps_mc_code}
                scCode={selectedSubClass?.ps_sc_code}
                scEndorsed={selectedSubClass?.ps_endorsed}
                excessLevel="Policy"
                excessRiskDocid=""
              />
            </div>}
          {/* RI ALLOCATION */}
          {["insurance"].includes(currentUser?.token_org_type) &&
            <div className="ri-wrapper">
              {/* <span>{selectedSubClass?.ps_treaty_allocation}</span> */}
              <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                <label
                  htmlFor="allocation"
                  className="form-dropdown-label"
                  style={{ width: "110px" }}
                >
                  {t('allocation').toUpperCase()}
                </label>
                <span style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingRight: "10px" }}>
                  <Select
                    id="allocation"
                    name="allocation"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="170px"
                    value={riAllocationTypes.find(option => option.value === selectedSubClass?.ps_treaty_allocation) || null}
                    onChange={async (selectedOption) => {
                      try {
                        const res = await newRequest.put(`/uwPolicySc/upd/${selectedSubClass?._id}`,
                          { ps_treaty_allocation: selectedOption.value });
                        if (res.data?.msg === "updated") {
                          handleRiAllocationData("ps_treaty_allocation", selectedOption.value);
                        } else {
                          showToast("Error updating RI Allocation!", "error");
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    options={riAllocationTypes}
                    isSearchable={true}
                    isDisabled={quoteData?.document_enabled_xx === "N"}
                    placeholder={t('allocation').toUpperCase()}
                  />
                  <span className='sub-title' style={{ textAlign: "right" }}>{riAllocationDescription.find(ri => ri.value === selectedSubClass?.ps_treaty_allocation)?.description || ""}</span>
                </span>
              </div>
            </div>}
          {/* {["insurance"].includes(currentUser?.token_org_type) && <hr className='separator-h' />} */}
          {/* display for motor policies where risk is more than one */}
          {showView === "multiple" && selectedSubClass && (
            <motion.div
              className="motor-multiple"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="navbar">
                <div className="navbar-left">
                  {/* {showTitle && <h1 className='main-title'>{t('particulars').toUpperCase()}</h1>} */}
                  <h1 className='main-title'>{t('particulars').toUpperCase()}</h1>
                  {/* Show search only if there are more than 5 risks */}
                  {policyRisks?.length > 5 &&
                    <div className="search-input-wrapper" style={{ width: "60%" }}>
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      {searchTerm?.length > 0 && (
                        <MdClose
                          onClick={() => setSearchTerm("")}
                          className="search-input-icon"
                        />
                      )}
                    </div>}
                </div>
                <div className="navbar-right">
                  <CustomButtonSmall
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType='left'
                    endIcon={<RefreshIcon size={20} />}
                    onClick={async () => {
                      try {
                        setPolicyRisks([]);
                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {t('refresh')}
                  </CustomButtonSmall>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    <CustomButtonSmall
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType='none'
                      endIcon={<GetAppIcon />}
                      onClick={() => {
                        try {
                          if (selectedSubClass?.import_template_xx === "vehicles-template") {
                            navigate("/vehicleImport", {
                              state: {
                                ...selectedSubClass,
                                ps_gl_date: quoteData?.pl_gl_date,
                                ps_fm_date: quoteData?.pl_fm_date,
                                ps_to_date: quoteData?.pl_to_date,
                                pr_code: quoteData?.pl_product_code,
                              },
                            });
                          } else if (selectedSubClass?.import_template_xx === "fire-template") {
                            navigate("/riskImport", {
                              state: {
                                ...selectedSubClass,
                                ps_gl_date: quoteData?.pl_gl_date,
                                ps_fm_date: quoteData?.pl_fm_date,
                                ps_to_date: quoteData?.pl_to_date,
                                pr_code: quoteData?.pl_product_code,
                              },
                            });
                          } else {
                            setNotifyDialogTitle(t('note'));
                            setNotifyDialogText(`${selectedSubClass?.import_template_xx} is not setup`);
                            setIsNotifyDialogOpen(true);
                            return;
                          }
                        } catch (error) {
                          console.log(error)
                        }
                      }}
                    >
                      {t('import')}
                    </CustomButtonSmall>}
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" && (
                      <CustomButtonSmall
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType="both"
                        variant="tint"
                        color="#0ea5a4"
                        tooltip={"New risk item"}
                        endIcon={<MdAdd />}
                        onClick={addNewRisk}
                        isCurrent={false}
                      >
                        {t('add')}
                      </CustomButtonSmall>
                    )}
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" && (
                      <CustomButtonSmall
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType='right'
                        endIcon={<MdClose />}
                        onClick={() => {
                          try {
                            setObjectToAction({
                              object_id: quoteData?._id,
                              action_text: `Delete all risks?`,
                              new_doc_status: "deleteAllRisks",
                            });
                            setConfirmDialogAction("deleteAllRisks");
                            setIsConfirmDialogOpen(true);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        isCurrent={false}
                      >
                        {t('deleteAll')}
                      </CustomButtonSmall>
                    )}
                </div>
              </div>
              <div className="table-content">
                <TableContainer component={Paper} className="table-container">
                  <Table sx={{ width: "max-content" }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}  >
                          <span>#</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto", display: ["term life", "whole life"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none", }}>
                          <span>{t('insured').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none", }}  >
                          <span>{t('regnNo').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('model').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('use').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('chassis').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "80px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell center" : "none" }} >
                          <span>{t('yom').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "80px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell center" : "none" }} >
                          <span>{t('pax').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto", display: ["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('description').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "350px", display: ["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('address').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('fullName').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "120px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('gender').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('age').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "200px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('occupation').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "200px", display: ["medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('status').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "350px", display: ["marine_cert"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                          <span>{t('tripDetails').toUpperCase()}</span>
                        </TableCell>
                        {quoteData?.document_enabled_xx === "Y" &&
                          selectedSubClass?.ps_endorsed === "Y" &&
                          <TableCell
                            className="table-cell center"
                            style={{ maxWidth: "70px" }}  >
                            <span>{t('action').toUpperCase()}</span>
                          </TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {slicedData.map((risk, index) => (
                        <TableRow
                          key={risk?._id}
                          className={`${selectedPolicyRisk?._id === risk?._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => selectRisk(risk)}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}  >
                            {risk?.sr_no}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", display: ["term life", "whole life"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none", }}>
                            <span>{risk?.risk_entity_xx?.ent_name} [{risk?.risk_entity_xx?.gender_xx} - {risk?.risk_entity_xx?.ent_age_xx}]</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none", }}  >
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span>{risk?.pr_vehicle_regn}</span>
                              {risk?.opened_claims_xx > 0 && <span style={{
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#f44336"
                              }}>{risk?.opened_claims_xx === 1 ? `Has ${risk?.opened_claims_xx} open claim` : `Has ${risk?.opened_claims_xx} open claims`}</span>}
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.vehicle_model_xx}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.vehicle_use_xx}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.pr_vehicle_chassis}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "80px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell center" : "none" }} >
                            {risk?.pr_vehicle_yom}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "80px", display: ["motor"].includes(selectedSubClass?.sc_view_xx) ? "table-cell center" : "none" }} >
                            {risk?.pr_vehicle_passangers}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", display: ["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.pr_risk_description}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "350px", display: ["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.pr_risk_address}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.pr_full_name}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "120px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.person_gender_xx}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.person_age_xx}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "200px", display: ["people", "medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.person_occupation_xx}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "200px", display: ["medical"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {risk?.pr_member_status}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "350px", display: ["marine_cert"].includes(selectedSubClass?.sc_view_xx) ? "table-cell" : "none" }} >
                            {`Trip from ${risk?.marine_cert_details_xx?.origin_address ||
                              "Unspecified"
                              } to ${risk?.marine_cert_details_xx?.dest_address ||
                              "Unspecified"
                              }`}
                          </TableCell>
                          {quoteData?.document_enabled_xx === "Y" &&
                            selectedSubClass?.ps_endorsed === "Y" &&
                            <TableCell
                              className="table-cell center"
                              style={{ maxWidth: "70px" }}
                            >
                              <CircularButton
                                currentTheme={currentTheme}
                                color="#D32F2F"
                                onClick={(e) => {
                                  try {
                                    e.stopPropagation();
                                    setSelectedPolicyRisk(risk);
                                    setObjectToAction({
                                      object_id: risk?._id,
                                      action_text: `Remove current risk item?`,
                                      new_doc_status: "deleteRisk",
                                    });
                                    setConfirmDialogAction("deleteRisk");
                                    setIsConfirmDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                icon={<MdDelete />}
                                width={"30px"}
                                height={"30px"} />
                            </TableCell>}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {policyRisks.length > 5 &&
                    <TablePagination
                      rowsPerPageOptions={[5]}
                      component="div"
                      count={policyRisks.length}
                      rowsPerPage={5}
                      rows={filteredData}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />}
                </TableContainer>
              </div>
              <span style={{ display: "flex", height: "30px" }} />
            </motion.div>
          )}
          {/* display for motor policy where risk its just one */}
          {showView === "single" && (
            <motion.div className="motor-single"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}>
              <div className="single-navbar">
                <div className="single-navbar-left">
                  {/* {showTitle ? <h1 className='main-title'>{t('particulars').toUpperCase()}</h1> : <span>{""}</span>} */}
                  <h1 className='main-title'>{t('particulars').toUpperCase()}</h1>
                  {quoteData?.pl_internal_end_code !== "000" &&
                    quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    <ToggleSwitch
                      value={selectedPolicyRisk?.pr_endorsed}
                      onChange={(newValue) => handleRiskEndorsedChange(newValue, selectedPolicyRisk?._id, "pr_endorsed")}
                      label={t('endorse').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                    />}
                </div>
                <div className="single-navbar-right">
                  {/* <span>{selectedSubClass.sc_code}</span>
              <span>{selectedSubClass.ps_treaty_allocation}</span>
              <span>{selectedSubClass?.sc_view_xx}</span> 
              <span>{selectedPolicyRisk?._id}</span> */}
                  <div className="inline-buttons-wrapper">
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_add_risk") === "Y" &&
                      !["marine_cert"].includes(selectedSubClass?.sc_view_xx) && (
                        <CustomLoadingButton
                          currentTheme={currentTheme}
                          onClick={addNewRisk}
                          endIcon={<MdAdd />}
                          height={"32px"}
                          iconPosition='end'
                          borderRadiusType="both"
                          variant="tint"
                          color="#0ea5a4"
                          tooltip={"New risk item"}
                        >
                          {t('add')}
                        </CustomLoadingButton>
                      )}
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.import_template_xx &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedSubClass.import_template_xx.trim().toLowerCase() !== "none" &&
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        endIcon={<GetAppIcon />}
                        iconPosition='end'
                        height={"32px"}
                        borderRadiusType="both"
                        variant="tint"
                        color="#9C27B0"
                        tooltip={"Import items"}
                        onClick={async () => {
                          try {
                            if (selectedSubClass?.import_template_xx === "vehicles-template") {
                              navigate("/vehicleImport", {
                                state: {
                                  ...selectedSubClass,
                                  ps_gl_date: quoteData?.pl_gl_date,
                                  ps_fm_date: quoteData?.pl_fm_date,
                                  ps_to_date: quoteData?.pl_to_date,
                                  pr_code: quoteData?.pl_product_code,
                                },
                              });
                            } else if (selectedSubClass?.import_template_xx === "fire-template") {
                              navigate("/riskImport", {
                                state: {
                                  ...selectedSubClass,
                                  ps_gl_date: quoteData?.pl_gl_date,
                                  ps_fm_date: quoteData?.pl_fm_date,
                                  ps_to_date: quoteData?.pl_to_date,
                                  pr_code: quoteData?.pl_product_code,
                                },
                              });
                            } else {
                              setNotifyDialogTitle(t('note'));
                              setNotifyDialogText(`${selectedSubClass?.import_template_xx} is not setup`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}>
                        {t('import')}
                      </CustomLoadingButton>}
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" &&
                      getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_remove_risk") === "Y" &&
                      (<CustomLoadingButton
                        currentTheme={currentTheme}
                        endIcon={<MdDelete />}
                        iconPosition='end'
                        height={"32px"}
                        borderRadiusType="both"
                        variant="tint"
                        color="#DD2C00"
                        tooltip={"Remove current risk item"}
                        onClick={() => {
                          try {
                            setObjectToAction({
                              object_id: selectedPolicyRisk?._id,
                              action_text: `Remove current risk item?`,
                              new_doc_status: "deleteRisk",
                            });
                            setConfirmDialogAction("deleteRisk");
                            setIsConfirmDialogOpen(true);
                          } catch (error) {
                            console.log(error);
                          }
                        }}>
                        {t('remove')}
                      </CustomLoadingButton>
                      )}
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" &&
                      getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_save_risk") === "Y" && (
                        <CustomLoadingButton
                          currentTheme={currentTheme}
                          endIcon={<MdSave />}
                          iconPosition='end'
                          borderRadiusType="both"
                          variant="tint"
                          color="#00D37F"
                          tooltip="Save changes"
                          height={"32px"}
                          onClick={() => saveRisk("Y")}>
                          {t('save')}
                        </CustomLoadingButton>
                      )}
                    {policyRisks?.length > 1 &&
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        endIcon={<HiOutlineViewList />}
                        iconPosition='end'
                        borderRadiusType="both"
                        variant="tint"
                        color="#AB47BC"
                        tooltip="View list of covered risks"
                        height={"32px"}
                        onClick={() => {
                          try {
                            setPrimaryBeneficiaries(null);
                            setSecondaryBeneficiaries(null);
                            setViewBeneficiaries(false);
                            saveRisk("N");
                            // clear cover array
                            setSelectedPolicyRiskCover([]);
                            // clear smi array
                            setPolicyRiskCoverSmi([]);
                            // clear selected risk data
                            resetRiskData();

                            setShowView("multiple");
                            // refetch the risks
                            // fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        {t('viewList')}
                      </CustomLoadingButton>}
                  </div>
                </div>
              </div>
              {/* <span>single risk {selectedSubClass?.sc_view_xx}  {selectedSubClass._id}</span> */}
              {["motor"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-one">
                  {/* Registration No */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_regn"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('regnNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_vehicle_regn"
                        name="pr_vehicle_regn"
                        type="text"
                        placeholder={t('regnNo').toUpperCase()}
                        value={prVehicleRegn}
                        className="form-input-item"
                        style={{ width: "170px" }}
                        onChange={(e) => setPrVehicleRegn(e.target.value.toUpperCase())}
                      // onBlur={(e) => {
                      //   try {
                      //     if (!validateMotorVehicleRegn(e.target.value.toUpperCase())) {
                      //       setPrVehicleRegn("")
                      //       setNotifyDialogTitle("Note!");
                      //       setNotifyDialogText(`Invalid registration number <strong>${e.target.value.toUpperCase()}</strong><br><br>Ensure you use pattern like AAA000A. E.g KDM100Q`);
                      //       setIsNotifyDialogOpen(true);
                      //       return;
                      //     }
                      //   } catch (error) {
                      //     console.log(error)
                      //   }
                      // }}
                      />
                      : <span className='normal-title'>{prVehicleRegn || t('unspecified')}</span>}
                  </div>
                  {/* vehicle make and model */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_model"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('model').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <CreatableSelect
                        id="pr_vehicle_model"
                        name="pr_vehicle_model"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="170px"
                        value={prVehicleModel}
                        onChange={handleSelectedVehicleModel}
                        options={vehicleModels}
                        isSearchable={true}
                        placeholder={t('model').toUpperCase()}
                      /> : <span className='normal-title'>{prVehicleModel?.label || t('unspecified')}</span>}
                  </div>
                  {/* vehicle cc */}
                  <div style={{ display: "flex", width: "270px", flex: "1", flexDirection: "row", alignItems: "center", }}>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="pr_vehicle_cc"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('cc').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <input
                          id="pr_vehicle_cc"
                          name="pr_vehicle_cc"
                          type="text"
                          placeholder={t('cc').toUpperCase()}
                          value={prVehicleCc}
                          className="form-input-item"
                          style={{ width: "70px" }}
                          onChange={(e) => setPrVehicleCc(e.target.value)}
                        /> : <span className='normal-title'>{prVehicleCc || "-"}</span>}
                    </div>
                    <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                      <label
                        htmlFor="pr_vehicle_passangers"
                        className="form-dropdown-label"
                        style={{ width: "45px" }}
                      >
                        {t('pax').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <input
                          id="pr_vehicle_passangers"
                          name="pr_vehicle_passangers"
                          type="text"
                          placeholder="0"
                          value={prVehiclePassangers}
                          className="form-input-item"
                          style={{ width: "50px" }}
                          onChange={(e) => setPrVehiclePassangers(e.target.value)}
                        /> : <span className='normal-title'>{prVehiclePassangers || "-"}</span>}
                    </div>
                  </div>
                </div>}
              {["motor"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-two">
                  {/* Chassis No */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_chassis"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('chassisNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_vehicle_chassis"
                        name="pr_vehicle_chassis"
                        type="text"
                        placeholder={t('chassisNo').toUpperCase()}
                        value={prVehicleChassis}
                        className="form-input-item"
                        style={{ width: "170px" }}
                        onChange={(e) => setPrVehicleChassis(e.target.value)}
                      /> : <span className='normal-title'>{prVehicleChassis || t('unspecified')}</span>}
                  </div>
                  {/* vehicle use */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_use"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('use').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_vehicle_use"
                        name="pr_vehicle_use"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="170px"
                        value={prVehicleUse}
                        onChange={(selectedOption) => setPrVehicleUse(selectedOption)}
                        options={vehicleUse}
                        isSearchable={true}
                        placeholder={t('use').toUpperCase()}
                      /> : <span className='normal-title'>{prVehicleUse?.label || t('unspecified')}</span>}
                  </div>
                  <div style={{ display: "flex", width: "270px", flex: "1", flexDirection: "row", alignItems: "center", }}>
                    {/* year of manufacture */}
                    <div className="input-item-with-label">
                      <label
                        htmlFor="pr_vehicle_yom"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('yom').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <input
                          id="pr_vehicle_yom"
                          name="pr_vehicle_yom"
                          type="text"
                          placeholder={t('yom').toUpperCase()}
                          value={prVehicleYom}
                          className="form-input-item"
                          style={{ width: "70px" }}
                          onChange={(e) => setPrVehicleYom(e.target.value)}
                        /> : <span className='normal-title'>{prVehicleYom || "----"}</span>}
                    </div>
                    {/* tonnage */}
                    <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                      <label
                        htmlFor="pr_vehicle_passangers"
                        className="form-dropdown-label"
                        style={{ width: "45px" }}
                      >
                        {t('ton').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <input
                          id="pr_vehicle_tonnage"
                          name="pr_vehicle_tonnage"
                          type="number"
                          placeholder={t('tonnage').toUpperCase()}
                          value={prVehicleTonnage}
                          className="form-input-item"
                          style={{ width: "50px" }}
                          onChange={(e) => setPrVehicleTonnage(e.target.value)}
                        /> : <span className='normal-title'>{prVehicleTonnage || "---"}</span>}
                    </div>
                  </div>
                </div>}
              {["motor"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-three" >
                  {/* Engine No */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_engine"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('engineNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_vehicle_engine"
                        name="pr_vehicle_engine"
                        type="text"
                        placeholder={t('engineNo').toUpperCase()}
                        value={prVehicleEngine}
                        className="form-input-item"
                        style={{ width: "170px" }}
                        onChange={(e) => setPrVehicleEngine(e.target.value)}
                      /> : <span className='normal-title'>{prVehicleEngine || t('unspecified')}</span>}
                  </div>
                  {/* vehicle color */}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_color"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('color').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <CreatableSelect
                        id="pr_vehicle_color"
                        name="pr_vehicle_color"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="170px"
                        value={prVehicleColor}
                        onChange={handleSelectedVehicleColor}
                        options={vehicleColors}
                        isSearchable={true}
                        isDisabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        placeholder={t('color').toUpperCase()}
                      /> : <span className='normal-title'>{prVehicleColor.label || t('unspecified')}</span>}
                  </div>
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_fm_date"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('fromDate').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_fm_date"
                        name="pr_fm_date"
                        type="date"
                        placeholder={t('fromDate').toUpperCase()}
                        value={prFmDate}
                        className="form-input-item"
                        style={{ width: "170px" }}
                        onChange={handleFromDateChange}
                        onBlur={calculateDateDifference}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      /> : <span className='normal-title'>{moment(prFmDate).format("DD-MMM-YYYY")}</span>}
                  </div>
                </div>}
              {["motor"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-four">
                  {["A", "D"].includes(getPrefixSafe(selectedPolicyRiskCover?.dmvic_cover_xx)) &&
                    <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                      <label
                        htmlFor="pr_vehicle_cert"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('certificate').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <Select
                          id="pr_vehicle_cert"
                          name="pr_vehicle_cert"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="170px"
                          value={prVehicleCert}
                          onChange={(selectedOption) => setPrVehicleCert(selectedOption)}
                          options={filteredCertTypes}
                          isSearchable={true}
                          placeholder={t('certificate').toUpperCase()}
                        /> : <span className='normal-title'>{prVehicleCert?.label || t('unspecified')}</span>}
                    </div>}
                  {["B"].includes(getPrefixSafe(selectedPolicyRiskCover?.dmvic_cover_xx)) &&
                    <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                      <label
                        htmlFor="pr_vehicle_type"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('type').toUpperCase()}
                      </label>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" &&
                        selectedPolicyRisk?.pr_endorsed === "Y" ?
                        <Select
                          id="pr_vehicle_type"
                          name="pr_vehicle_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="170px"
                          value={prVehicleType}
                          onChange={(selectedOption) => setPrVehicleType(selectedOption)}
                          options={vehicleTypes}
                          isSearchable={true}
                          placeholder={t('type').toUpperCase()}
                        /> : <span className='normal-title'>{prVehicleType?.label || t('unspecified')}</span>}
                    </div>}

                  {/* THIS IS A PLACEHOLDER */}
                  {!["A", "B", "D"].includes(getPrefixSafe(selectedPolicyRiskCover?.dmvic_cover_xx)) &&
                    <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                      <span />
                    </div>}
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_vehicle_body"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('bodyType').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_vehicle_body"
                        name="pr_vehicle_body"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="170px"
                        value={prVehicleBody}
                        onChange={(selectedOption) => setPrVehicleBody(selectedOption)}
                        // onChange={(selectedOption) => {
                        //   setPrVehicleBody(selectedOption);
                        //   setSelectedPolicyRisk(prev => ({ ...prev, pr_vehicle_body: selectedOption?.value }));
                        // }}
                        options={vehicleBodyTypes}
                        isSearchable={true}
                        placeholder={t('bodyType')}
                      /> : <span className='normal-title'>{prVehicleBody?.label || t('unspecified')}</span>}
                  </div>
                  <div className="input-item-with-label" style={{ flex: "1", alignItems: "center" }}>
                    <label
                      htmlFor="pr_to_date"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('toDate').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_to_date"
                        name="pr_to_date"
                        type="date"
                        placeholder={t('toDate').toUpperCase()}
                        value={prToDate}
                        className="form-input-item"
                        style={{ width: "170px" }}
                        onChange={handleToDateChange}
                        onBlur={calculateDateDifference}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      /> : <span className='normal-title'>{moment(prToDate).format("DD-MMM-YYYY")}</span>}
                  </div>
                  {/* <span>{selectedPolicyRisk?.pr_subclass_docid}</span> */}
                </div>}
              {/* {["motor"].includes(selectedSubClass?.sc_view_xx) &&
            selectedPolicyRisk?.pr_certificate_no &&
            <hr className='separator-h' />} */}
              {["motor"].includes(selectedSubClass?.sc_view_xx) &&
                selectedPolicyRisk?.pr_certificate_no &&
                <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center", paddingRight: "10px" }}>
                  <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", flex: "2" }}>
                    <span className='main-title'>{t('certDetails').toUpperCase()}</span>
                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "center", flex: "1" }}>
                      <CustomButtonSmallDarkBg
                        borderRadiusType='left'
                        currentTheme={currentTheme}
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          try {
                            const response = await newRequest.get(`/dmvic/viewCertificate/${selectedPolicyRisk?.pr_certificate_no}`, {
                              responseType: 'arraybuffer',
                            });
                            const blob = new Blob([response.data], { type: response.headers['content-type'] });
                            const url = URL.createObjectURL(blob);
                            setPdfUrl(url);
                            setPdfPreviewDialogOpen(true);
                          } catch (error) {
                            console.log(error)
                          }
                        }}
                        startIcon={<IoArrowRedo />}
                        isCurrent={true}
                      >
                        {t('previewCertificate').toUpperCase()}
                      </CustomButtonSmallDarkBg>
                      {/* <span style={{ height: "100%" }}>|</span> */}
                      <CustomButtonSmallDarkBg
                        borderRadiusType='right'
                        currentTheme={currentTheme}
                        onClick={async (e) => {
                          await fetchDmvicCancel();
                          setCancelReasonDialog(true);
                        }}
                        startIcon={<MdOutlineCancel />}
                        isCurrent={true}
                      >
                        {t('cancelCertificate').toUpperCase()}
                      </CustomButtonSmallDarkBg>
                    </div>
                  </div>
                  <span style={{ flex: "1", alignSelf: "flex-end" }}>
                    <WorkedOnBy
                      name={selectedPolicyRisk?.cert_issued_by_name_xx}
                      photoUrl={selectedPolicyRisk?.cert_issued_by_avatar_xx}
                      time_ago_xx={selectedPolicyRisk?.cert_issued_ago_xx}
                      showTitle={false}
                      startFrom={"end"}
                    />
                  </span>
                </div>}
              {["motor"].includes(selectedSubClass?.sc_view_xx) && selectedPolicyRisk?.pr_certificate_no &&
                <div className="row-four">
                  <div className="input-item-with-label"
                    style={{ cursor: "pointer" }}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      try {
                        const response = await newRequest.get(`/dmvic/viewCertificate/${selectedPolicyRisk?.pr_certificate_no}`, {
                          responseType: 'arraybuffer',
                        });
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);
                        setPdfPreviewDialogOpen(true);
                      } catch (error) {
                        console.log(error)
                      }
                    }}>
                    <label style={{ width: "100px" }}>
                      {t('certNo').toUpperCase()}
                    </label>
                    <span className='normal-title' style={{ width: "170px" }}>{selectedPolicyRisk?.pr_certificate_no || ""}</span>
                  </div>
                  <div className="input-item-with-label">
                    <label style={{ width: "100px" }}>
                      {t('fromDate').toUpperCase()}
                    </label>
                    <span className='normal-title' style={{ width: "170px" }}>{moment(selectedPolicyRisk?.pr_cert_date_fm).format("DD-MMM-YYYY")}</span>
                  </div>
                  <div className="input-item-with-label">
                    <label style={{ width: "100px" }}>
                      {t('toDate').toUpperCase()}
                    </label>
                    <span className='normal-title' style={{ width: "170px" }}>{moment(selectedPolicyRisk?.pr_cert_date_to).format("DD-MMM-YYYY")}</span>
                  </div>
                </div>}
              {["fire", "engineering", "bond", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-five">
                  <div className="input-item-with-label" style={{ width: "100%" }}>
                    <label
                      htmlFor="pr_risk_description"
                      style={{ width: "100px", alignSelf: "flex-start" }}
                    >
                      {t('details').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <textarea
                        id="pr_risk_description"
                        name="pr_risk_description"
                        type="text"
                        placeholder={t('description').toUpperCase()}
                        value={prRiskDescription}
                        rows={3}
                        className="form-input-item"
                        style={{ width: "100%", height: "max-content" }}
                        onChange={(e) => setPrRiskDescription(e.target.value)}
                        disabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_desc") === "N"}
                      /> : <span className='normal-title' style={{ width: "100%" }}>{prRiskDescription}</span>
                    }
                  </div>
                </div>}
              {/* BONDS INFORMATION */}
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_no"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('bondNo').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_no"
                      name="bond_no"
                      type="text"
                      placeholder={t('no').toUpperCase()}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_no || ""}
                      onChange={(e) => updateBondField('bond_no', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_no || t('unspecified')}</span>}
                </div>
                <div
                  className="input-item-with-label"
                  style={{
                    flex: "1",
                    justifyContent: "flex-end"
                  }}
                >
                  <label
                    htmlFor="bond_type"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('type').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <Select
                      id="bond_type"
                      name="bond_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={bondTypes.find(option => option.value === prBondInfo?.bond_type) || null}
                      onChange={(selectedOption) => updateBondField('bond_type', selectedOption?.value)}
                      options={bondTypes}
                      isSearchable={true}
                      placeholder={t('type').toUpperCase()}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_type || t('unspecified')}</span>}
                </div>
              </div>
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_category"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('category').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <Select
                      id="bond_category"
                      name="bond_category"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={bondCategories.find(option => option.value === prBondInfo?.bond_category) || null}
                      onChange={(selectedOption) => updateBondField('bond_category', selectedOption?.value)}
                      options={bondCategories}
                      isSearchable={true}
                      placeholder={t('category').toUpperCase()}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_category || t('unspecified')}</span>}
                </div>
                <div
                  className="input-item-with-label"
                  style={{
                    justifyContent: "flex-end",
                    flex: "1",
                  }}
                >
                  <label
                    htmlFor="bond_purpose"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('purpose').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <Select
                      id="bond_purpose"
                      name="bond_purpose"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={bondPurposes.find(option => option.value === prBondInfo?.bond_purpose) || null}
                      onChange={(selectedOption) => updateBondField('bond_purpose', selectedOption?.value)}
                      options={bondPurposes}
                      isSearchable={true}
                      placeholder={t('purpose').toUpperCase()}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_purpose || t('unspecified')}</span>}
                </div>
              </div>
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" >
                  <label htmlFor="bond_issue_date"
                    style={{ width: "90px" }} >
                    {t('issue').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_issue_date"
                      name="bond_issue_date"
                      type="date"
                      placeholder={t('issue').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                      className="form-input-item"
                      style={{ width: "170px" }}
                      value={moment(prBondInfo?.bond_issue_date).format("YYYY-MM-DD")}
                      onChange={(e) => updateBondField('bond_issue_date', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "170px" }}>{moment(prBondInfo?.bond_issue_date).format("Do-MMM-YYYY") || t('unspecified')}</span>}
                </div>
                <div className="input-item-with-label" >
                  <label htmlFor="bond_effective_date"
                    style={{ width: "max-content" }} >
                    {t('effective').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_effective_date"
                      name="bond_effective_date"
                      type="date"
                      placeholder={t('effective').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                      className="form-input-item"
                      style={{ width: "170px" }}
                      value={moment(prBondInfo?.bond_effective_date).format("YYYY-MM-DD")}
                      onChange={(e) => updateBondField('bond_effective_date', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "170px" }}>{moment(prBondInfo?.bond_effective_date).format("Do-MMM-YYYY") || t('unspecified')}</span>}
                </div>
                <div className="input-item-with-label" >
                  <label htmlFor="bond_expiry_date"
                    style={{ width: "max-content" }}
                    className="form-dropdown-label">
                    {t('expiry').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_expiry_date"
                      name="bond_expiry_date"
                      type="date"
                      placeholder={t('expiry').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                      className="form-input-item"
                      style={{ width: "170px" }}
                      value={moment(prBondInfo?.bond_expiry_date).format("YYYY-MM-DD")}
                      onChange={(e) => updateBondField('bond_expiry_date', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "170px" }}>{moment(prBondInfo?.bond_expiry_date).format("Do-MMM-YYYY") || t('unspecified')}</span>}
                </div>
              </div>
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_alien_name"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('fullName').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_alien_name"
                      name="bond_alien_name"
                      type="text"
                      placeholder={t('fullName').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N"}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_alien_name || ""}
                      onChange={(e) => updateBondField('bond_alien_name', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_alien_name || t('unspecified')}</span>}
                </div>
                <div
                  className="input-item-with-label"
                  style={{
                    justifyContent: "flex-end",
                    flex: "1",
                  }}
                >
                  <label
                    htmlFor="bond_alien_passport"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('passport').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_alien_passport"
                      name="bond_alien_passport"
                      type="text"
                      placeholder={t('passport').toUpperCase()}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_alien_passport || ""}
                      onChange={(e) => updateBondField('bond_alien_passport', e.target.value)}
                    />
                    :
                    <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_alien_passport || t('unspecified')}</span>
                  }
                </div>
              </div>
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_alien_gender"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('gender').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <Select
                      id="bond_alien_gender"
                      name="bond_alien_gender"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={genders.find(option => option.value === prBondInfo?.bond_alien_gender) || null}
                      onChange={(selectedOption) => updateBondField('bond_alien_gender', selectedOption?.value)}
                      options={genders}
                      isSearchable={true}
                      placeholder={t('gender').toUpperCase()}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_alien_gender || t('unspecified')}</span>}
                </div>
                {quoteData?.document_enabled_xx === "Y" &&
                  selectedSubClass?.ps_endorsed === "Y" &&
                  selectedPolicyRisk?.pr_endorsed === "Y" ?
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="bond_alien_dob"
                      className="form-dropdown-label"
                      style={{ width: "90px" }}
                    >
                      {t('dob').toUpperCase()}
                    </label>
                    <span style={{ display: "flex", flexDirection: "row", width: "300px" }}>
                      <input
                        id="bond_alien_dob"
                        name="bond_alien_dob"
                        type="date"
                        placeholder={t('dob').toUpperCase()}
                        value={moment(prBondInfo?.bond_alien_dob).format("YYYY-MM-DD")}
                        onChange={(e) => updateBondField('bond_alien_dob', e.target.value)}
                        className="form-input-item"
                        style={{ width: "60%", height: "40px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                        disabled={quoteData?.document_enabled_xx === "N"}
                      />
                      <input
                        id="alien_dob_xx"
                        name="alien_dob_xx"
                        type="text"
                        placeholder={t('age').toUpperCase()}
                        value={calculateAgeFromMongoDate(moment(prBondInfo?.bond_alien_dob).format("YYYY-MM-DD")) + ` ${t('yrs')}`}
                        className="form-input-item"
                        style={{
                          width: "40%",
                          height: "40px",
                          textAlign: "center",
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                          borderLeft: "none",
                          borderLeftWidth: "0px"
                        }}
                        disabled
                      />
                    </span>
                  </div>
                  :
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >   <label
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                      {t('born').toUpperCase()}
                    </label>
                    <span style={{ width: "300px" }}>{`${moment(prBondInfo?.bond_alien_dob).format("Do-MMM-YYYY")} | ${calculateAgeFromMongoDate(moment(prBondInfo?.bond_alien_dob).format("YYYY-MM-DD")) + ` ${t('yrs')}`}`}</span>
                  </div>}
              </div>
              <div className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }}>
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_alien_phone"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('phoneNo').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_alien_phone"
                      name="bond_alien_phone"
                      type="text"
                      placeholder={t('phoneNo').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N"}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_alien_phone || ""}
                      onChange={(e) => updateBondField('bond_alien_phone', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_alien_phone || t('unspecified')}</span>}
                </div>
                <div className="input-item-with-label" style={{ justifyContent: "flex-end", flex: "1", }}>
                  <label
                    htmlFor="bond_alien_email"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('email').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_alien_email"
                      name="bond_alien_email"
                      type="email"
                      placeholder={t('email').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N"}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_alien_email || ""}
                      onChange={(e) => updateBondField('bond_alien_email', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_alien_email || t('unspecified')}</span>}
                </div>
              </div>
              <div
                className="row-five" style={{ display: ["bond"].includes(selectedSubClass?.sc_view_xx) ? "flex" : "none" }} >
                <div className="input-item-with-label" style={{ flex: "1", }}>
                  <label
                    htmlFor="bond_indemnitor"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('indemnitor').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <input
                      id="bond_indemnitor"
                      name="bond_indemnitor"
                      type="text"
                      placeholder={t('indemnitor').toUpperCase()}
                      disabled={quoteData?.document_enabled_xx === "N"}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={prBondInfo?.bond_indemnitor || ""}
                      onChange={(e) => updateBondField('bond_indemnitor', e.target.value)}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_indemnitor || t('unspecified')}</span>}
                </div>
                <span style={{ flex: "1" }} /> {/* This is a placeholder */}
                <div className="input-item-with-label" style={{ flex: "1" }}>
                  <label
                    htmlFor="bond_indemnitor_rela"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('relationship').toUpperCase()}
                  </label>
                  {quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                    <Select
                      id="bond_indemnitor_rela"
                      name="bond_indemnitor_rela"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={relationshipTypes.find(option => option.value === prBondInfo?.bond_indemnitor_rela) || null}
                      onChange={(selectedOption) => updateBondField('bond_indemnitor_rela', selectedOption?.value)}
                      options={relationshipTypes}
                      isSearchable={true}
                      placeholder={t('relationship').toUpperCase()}
                    /> : <span className='normal-title' style={{ width: "300px" }}>{prBondInfo?.bond_indemnitor_rela?.label || t('unspecified')}</span>}
                </div>
              </div>
              {/* END OF BONDS */}
              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-six">
                  <div className="input-item-with-label" style={{ width: "100%" }}>
                    <label
                      htmlFor="pr_risk_address"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('address').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_risk_address"
                        name="pr_risk_address"
                        type="text"
                        placeholder="ADDRESS"
                        value={prRiskAddress}
                        className="form-input-item"
                        style={{ width: "100%" }}
                        onChange={(e) => setPrRiskAddress(e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_address") === "N"}
                      /> :
                      <span className='normal-title' style={{ width: "100%" }}>{prRiskAddress}</span>
                    }
                  </div>
                </div>}
              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label" style={{ flex: "1" }}>
                    <label
                      htmlFor="pr_risk_function"
                      className="form-dropdown-label"
                      style={{ width: "90px" }}
                    >
                      {t('function').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_risk_function"
                        name="pr_risk_function"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prRiskFunction}
                        onChange={(selectedOption) => {
                          try {
                            setPrRiskFunction(selectedOption);
                            setPrRiskCategory({
                              value: selectedOption.risk_category,
                              label: selectedOption.risk_category,
                            })
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={riskFunctions}
                        isSearchable={true}
                        isDisabled={quoteData?.document_enabled_xx === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('function').toUpperCase()}
                      /> :
                      <span className='normal-title'>{prRiskFunction?.label || t('unspecified')}</span>
                    }
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="pr_risk_area"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('area').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <CreatableSelect
                        id="pr_risk_area"
                        name="pr_risk_area"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prRiskArea}
                        onChange={handleSelectedRiskArea}
                        options={riskAreas}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_area") === "N"}
                        placeholder={t('area').toUpperCase()}
                      />
                      : <span className='normal-title'>{prRiskArea?.label || t('unspecified')}</span>
                    }
                  </div>
                </div>}
              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label" style={{ flex: "1" }}>
                    <label
                      htmlFor="pr_risk_category"
                      className="form-dropdown-label"
                      style={{ width: quoteData?.document_enabled_xx === "Y" ? "90px" : "100px" }}
                    >
                      {t('category').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_risk_category"
                        name="pr_risk_category"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prRiskCategory}
                        onChange={(selectedOption) => setPrRiskCategory(selectedOption)}
                        options={riCategories}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('category').toUpperCase()}
                      /> :
                      <span className='normal-title'>{prRiskCategory?.label || t('unspecified')}</span>
                    }
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="pr_risk_jurisdiction"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('jurisdiction').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <CreatableSelect
                        id="pr_risk_jurisdiction"
                        name="pr_risk_jurisdiction"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prRiskJurisdiction}
                        onChange={handleSelectedRiskJurisdiction}
                        options={riskJurisdictions}
                        isSearchable={true}
                        isDisabled={quoteData?.document_enabled_xx === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_area") === "N"}
                        placeholder={t('jurisdiction').toUpperCase()}
                      />
                      : <span className='normal-title'>{prRiskJurisdiction?.label || t('unspecified')}</span>
                    }
                  </div>
                </div>}


              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label" style={{ flex: "1" }}>
                    <label
                      htmlFor="pr_eq_zone"
                      className="form-dropdown-label"
                      style={{ width: quoteData?.document_enabled_xx === "Y" ? "90px" : "100px" }}
                    >
                      {t('eqZone').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_eq_zone"
                        name="pr_eq_zone"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prEqZone}
                        onChange={async (selectedOption) => {
                          try {
                            setPrEqZone(selectedOption);
                            if (selectedOption?.value) {
                              await fetchEqSubZones(selectedOption?.value);
                              setPrEqSubZone(null);
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={eqZones}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('eqZone')}
                      /> :
                      <span className='normal-title'>{prEqZone?.label || t('unspecified')}</span>
                    }
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="pr_flood_zone"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('floodZone').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_flood_zone"
                        name="pr_flood_zone"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prFloodZone}
                        onChange={async (selectedOption) => {
                          try {
                            setPrFloodZone(selectedOption);
                            if (selectedOption?.value) {
                              setPrFloodSubZone(null);
                              await fetchFloodSubZones(selectedOption?.value);
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={floodZones}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('floodZone')}
                      />
                      : <span className='normal-title'>{prFloodZone?.label || t('unspecified')}</span>
                    }
                  </div>
                </div>}

              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label" style={{ flex: "1" }}>
                    <label
                      htmlFor="pr_eq_sub_zone"
                      className="form-dropdown-label"
                      style={{ width: quoteData?.document_enabled_xx === "Y" ? "90px" : "100px" }}
                    >
                      {t('eqSubZone').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_eq_sub_zone"
                        name="pr_eq_sub_zone"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prEqSubZone}
                        onChange={(selectedOption) => setPrEqSubZone(selectedOption)}
                        options={eqSubZones}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('eqSubZone')}
                      /> :
                      <span className='normal-title'>{prEqSubZone?.label || t('unspecified')}</span>
                    }
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="pr_flood_sub_zone"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('floodSubZone').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_flood_sub_zone"
                        name="pr_flood_sub_zone"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prFloodSubZone}
                        onChange={(selectedOption) => setPrFloodSubZone(selectedOption)}
                        options={floodSubZones}
                        isSearchable={true}
                        isDisabled={getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_risk_function") === "N"}
                        placeholder={t('floodSubZone')}
                      />
                      : <span className='normal-title'>{prFloodSubZone?.label || t('unspecified')}</span>
                    }
                  </div>
                </div>}


              {/* fields for life insurance */}
              {["term life", "whole life", "annuity"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-five" >
                  <motion.div
                    className="entity-details-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="entity-details-wrapper">
                      <div className="entity-details-left">
                        {selectedPolicyRisk?.risk_entity_xx?.ent_photo_url ?
                          <img src={selectedPolicyRisk?.risk_entity_xx?.ent_photo_url} alt="" className="img" /> :
                          <InitialsAvatar
                            name={selectedPolicyRisk?.risk_entity_xx?.ent_name}
                            size={80}
                            currentTheme={currentTheme}
                          />
                        }
                      </div>
                      <div className="entity-details-right">
                        <div className="name-row">
                          <h1 className="main-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_name}</h1>
                          <div className="age-wrapper">
                            <h1 className="sub-title" style={{ color: "#181A20" }}>{`Date of Birth ${selectedPolicyRisk?.risk_entity_xx?.formatted_dob || ""} [${selectedPolicyRisk?.risk_entity_xx?.ent_age_xx || ""}]`}</h1>
                            <h1 className="sub-title" style={{ color: "#181A20" }}>{`Age Next Birthday ${selectedPolicyRisk?.risk_entity_xx?.ent_nextage_xx || ""}`}</h1>
                          </div>
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details">
                            <MdAlternateEmail className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_email || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <LocalPhoneIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_phone_no || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <TbCertificate className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_type || ""}</h1>
                          </span>
                          <span className="email-phone-details"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/entity/${selectedPolicyRisk?.risk_entity_xx?._id}`)}>
                            <TagIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_code}</h1>
                          </span>
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details">
                            <BsSuitcaseLgFill className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_occupation_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <MdOutlineSmokeFree className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.smoke_flag_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <MdGroupWork className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.aent_name_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <GrStatusCriticalSmall className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_xx?.ent_status || ""}</h1>
                          </span>
                        </div>
                        {/* Shown if selected term requires medical valuation */}
                        {quoteData?.pl_term_code_xx?.term_medical === "Y" &&
                          <div className="email-phone-row">
                            {selectedPolicyRisk?.medical_report_id &&
                              <h1 className='please-note'>
                                {selectedPolicyRisk?.medical_report_msg_xx?.split("Click here")[0]}
                                <Link
                                  onClick={(e) => {
                                    try {
                                      e.preventDefault();
                                      navigate(`/medical/${selectedPolicyRisk?.medical_report_id}`);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}
                                >
                                  {t('clickHere')}</Link>
                                {selectedPolicyRisk?.medical_report_msg_xx?.split("Click here")[1]}
                              </h1>}
                          </div>}
                        <div className="email-phone-row" style={{ flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                          {quoteData?.document_enabled_xx === "Y" &&
                            selectedSubClass?.ps_endorsed === "Y" &&
                            selectedPolicyRisk?.pr_endorsed === "Y" && !editLifeEntity &&
                            <CustomButtonSmallDarkBg
                              currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setRiskEntity(null);
                                  setEntityAction("changeInsured");
                                  setEditLifeEntity(true);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                              startIcon={selectedPolicyRisk?.risk_entity_xx ? <TbUserEdit /> : <TbUserPlus />}
                              isCurrent={true}
                            >
                              {`${selectedPolicyRisk?.risk_entity_xx ? t('changeInsured').toUpperCase() : t('addInsured').toUpperCase()}`}
                            </CustomButtonSmallDarkBg>}
                          {quoteData?.document_enabled_xx === "Y" &&
                            selectedSubClass?.ps_endorsed === "Y" &&
                            selectedPolicyRisk?.pr_endorsed === "Y" && !editLifeEntity &&
                            <CustomButtonSmallDarkBg
                              currentTheme={currentTheme}
                              onClick={async () => {
                                try {
                                  await fetchMedicalReports(selectedPolicyRisk?.pr_ent_code);
                                  setRiskEntity(null);
                                  setEntityAction("medicalReport");
                                  setEditLifeEntity(true);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                              startIcon={<FaLaptopMedical />}
                              isCurrent={true}
                            >
                              {t('linkMedical').toUpperCase()}
                            </CustomButtonSmallDarkBg>}
                          {!editLifeEntity &&
                            <CustomButtonSmallDarkBg
                              currentTheme={currentTheme}
                              onClick={async () => {
                                try {
                                  await fetchRelationshipTypes();
                                  await fetchPrimaryBeneficiaries(selectedPolicyRisk?._id);
                                  setViewBeneficiaries(!viewBeneficiaries);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                              startIcon={!viewBeneficiaries ? <FaPeopleLine /> : <GiPresent />}
                              isCurrent={true}
                            >
                              {!viewBeneficiaries ? t('viewBeneficiaries').toUpperCase() : t('viewBenefits').toUpperCase()}
                            </CustomButtonSmallDarkBg>}
                          {editLifeEntity &&
                            <motion.div className='edit-risk-entity-row'
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1, transition: { duration: 1 } }}
                              exit={{ opacity: 0, transition: { duration: 1 } }}>
                              {/* For changing insured */}
                              {entityAction === "changeInsured" &&
                                <AsyncSelect
                                  id="risk_entity"
                                  name="risk_entity"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="300px"
                                  value={riskEntity}
                                  onChange={(selectedOption) => setRiskEntity(selectedOption)}
                                  loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                                  isSearchable={true}
                                  placeholder={t('insured')}
                                  noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                />}
                              {/* for linking medical report to insured */}
                              {entityAction === "medicalReport" &&
                                <Select
                                  id="medical_report"
                                  name="medical_report"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="300px"
                                  value={prRqCode}
                                  onChange={(selectedOption) => setPrRqCode(selectedOption)}
                                  options={medicalReports}
                                  isSearchable={true}
                                  isDisabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                                  placeholder={t('medical').toUpperCase()}
                                  noOptionsMessage={() => "No Medical Records Found"}
                                />}
                              <MdClear
                                size={50}
                                className="file-edit-icon cancel"
                                onClick={async (e) => {
                                  try {
                                    setEntityAction(null);
                                    setEditLifeEntity(false);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                              <MdOutlineCheck
                                size={50}
                                className="file-edit-icon ok"
                                onClick={async (e) => {
                                  try {
                                    // this action is for changing insured
                                    if (entityAction === "changeInsured") {
                                      if (riskEntity && selectedPolicyRisk?._id) {
                                        await newRequest.put(
                                          `/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`,
                                          {
                                            pr_aent_code: riskEntity?.ent_aent_code,
                                            pr_ent_code: riskEntity?.ent_code,
                                            pr_rq_code: null
                                          }
                                        );
                                        setRiskEntity(riskEntity);
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntity(false);
                                        showToast(`Insured changed to ${riskEntity?.ent_name}!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select insured`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    } else if (entityAction === "medicalReport") {
                                      // this action is for linking medical report
                                      if (prRqCode && selectedPolicyRisk?._id) {
                                        await newRequest.put(`/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`, { pr_rq_code: prRqCode?.value });
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntity(false);
                                        showToast(`Medical report linked!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select medical report to link`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    } else if (entityAction === "changeInsuredJoint") {
                                      // this action is for adding joint insured
                                      if (riskEntity && selectedPolicyRisk?._id) {
                                        await newRequest.put(
                                          `/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`,
                                          {
                                            pr_joint_aent_code: riskEntity?.ent_aent_code,
                                            pr_joint_ent_code: riskEntity?.ent_code,
                                            pr_joint_rq_code: null
                                          }
                                        );
                                        setRiskEntity(riskEntity);
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntity(false);
                                        showToast(`Joint Insured ${riskEntity?.ent_name} added!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select insured`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    } else if (entityAction === "medicalReportJoint") {
                                      // this action is for linking medical report
                                      if (prRqCode && selectedPolicyRisk?._id) {
                                        await newRequest.put(`/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`, { pr_joint_rq_code: prJointRqCode?.value });
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntity(false);
                                        showToast(`Medical report linked!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select medical report to link`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                            </motion.div>}
                        </div>
                      </div>
                    </div>
                    {(
                      [selectedPolicyRisk?.risk_entity_xx?.smoke_flag_xx, selectedPolicyRisk?.risk_entity_xx?.ent_nextage_xx].includes("Not Set") ||
                      selectedPolicyRisk?.risk_entity_xx?.ent_status !== "Active" &&
                      selectedPolicyRisk?.risk_entity_xx?.ent_code &&
                      quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y"
                    ) &&
                      <span className='please-note'>{`PLEASE NOTE YOU WILL NOT BE ABLE TO CALCULATE PREMIUM UNTIL YOU HAVE SPECIFIED DATE OF BIRTH, GENDER AND SMOKING FLAG FOR ${selectedPolicyRisk?.risk_entity_xx?.ent_name?.toUpperCase()} AND STATUS SHOULD BE ACTIVE`}</span>}
                  </motion.div>
                </div>}
              {/* for the second joint insured */}
              {["term life", "whole life", "annuity"].includes(selectedSubClass?.sc_view_xx) &&
                quoteData?.pl_term_code_xx?.term_joint_type !== "none" &&
                <div className="row-five" >
                  <motion.div
                    className="entity-details-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="entity-details-wrapper">
                      <div className="entity-details-left">
                        {selectedPolicyRisk?.risk_entity_joint_xx?.ent_photo_url ?
                          <img src={selectedPolicyRisk?.risk_entity_joint_xx?.ent_photo_url} alt="" className="img" /> :
                          <InitialsAvatar
                            name={selectedPolicyRisk?.risk_entity_joint_xx?.ent_name}
                            size={80}
                            currentTheme={currentTheme}
                          />
                        }
                      </div>
                      <div className="entity-details-right">
                        <div className="name-row">
                          <h1 className="main-title" style={{ color: "#181A20" }}>
                            {selectedPolicyRisk?.risk_entity_joint_xx?.ent_name}
                          </h1>
                          <div className="age-wrapper">
                            <h1 className="sub-title" style={{ color: "#181A20" }}>{`Date of Birth ${selectedPolicyRisk?.risk_entity_joint_xx?.formatted_dob || ""} [${selectedPolicyRisk?.risk_entity_joint_xx?.ent_age_xx || ""}]`}</h1>
                            <h1 className="sub-title" style={{ color: "#181A20" }}>{`Age Next Birthday ${selectedPolicyRisk?.risk_entity_joint_xx?.ent_nextage_xx || ""}`}</h1>
                          </div>
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details">
                            <MdAlternateEmail className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_email || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <LocalPhoneIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_phone_no || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <TbCertificate className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_type || ""}</h1>
                          </span>
                          <span className="email-phone-details"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/entity/${selectedPolicyRisk?.risk_entity_joint_xx?._id}`)}>
                            <TagIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_code || ""}</h1>
                          </span>
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details">
                            <BsSuitcaseLgFill className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_occupation_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <MdOutlineSmokeFree className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.smoke_flag_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <MdGroupWork className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.aent_name_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details">
                            <GrStatusCriticalSmall className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{selectedPolicyRisk?.risk_entity_joint_xx?.ent_status || ""}</h1>
                          </span>
                        </div>
                        {/* Shown if selected term requires medical valuation */}
                        {quoteData?.pl_term_code_xx?.term_medical === "Y" &&
                          <div className="email-phone-row">
                            {selectedPolicyRisk?.medical_report_joint_id &&
                              <h1 className='please-note'>
                                {selectedPolicyRisk?.medical_report_msg_joint_xx?.split("Click here")[0]}
                                <Link
                                  onClick={(e) => {
                                    try {
                                      e.preventDefault();
                                      navigate(`/medical/${selectedPolicyRisk?.medical_report_joint_id}`);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}
                                >{t('clickHere')}</Link>
                                {selectedPolicyRisk?.medical_report_msg_joint_xx?.split("Click here")[1]}
                              </h1>}
                          </div>}
                        <div className="email-phone-row" style={{ flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                          {!editLifeEntityJoint &&
                            <CustomButtonSmallDarkBg
                              onClick={() => {
                                try {
                                  setRiskEntity(null);
                                  setEntityAction("changeInsuredJoint");
                                  setEditLifeEntityJoint(true)
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                              bgColor={"#fff"}
                              ftColor={"#263238"}
                              startIcon={<TbUserEdit />}
                              isCurrent={true}
                            >
                              {t('changeJointInsured').toUpperCase()}
                            </CustomButtonSmallDarkBg>}
                          {!editLifeEntityJoint &&
                            <CustomButtonSmallDarkBg
                              onClick={async () => {
                                try {
                                  await fetchMedicalReports(selectedPolicyRisk?.pr_joint_ent_code);
                                  setRiskEntity(null);
                                  setEntityAction("medicalReportJoint");
                                  setEditLifeEntityJoint(true);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                              bgColor={"#fff"}
                              ftColor={"#263238"}
                              startIcon={<FaLaptopMedical />}
                              isCurrent={true}
                            >
                              {t('linkMedical').toUpperCase()}
                            </CustomButtonSmallDarkBg>}

                          {editLifeEntityJoint &&
                            <motion.div className='edit-risk-entity-row'
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1, transition: { duration: 1 } }}
                              exit={{ opacity: 0, transition: { duration: 1 } }}>
                              {/* For changing insured */}
                              {entityAction === "changeInsuredJoint" &&
                                <AsyncSelect
                                  id="risk_entity_joint"
                                  name="risk_entity_joint"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="300px"
                                  value={riskEntityJoint}
                                  onChange={(selectedOption) => setRiskEntityJoint(selectedOption)}
                                  loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                                  isSearchable={true}
                                  placeholder={t('insured')}
                                  noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                />}
                              {/* for linking medical report to insured */}
                              {entityAction === "medicalReportJoint" &&
                                <Select
                                  id="medical_report_joint"
                                  name="medical_report_joint"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="300px"
                                  value={prJointRqCode}
                                  onChange={(selectedOption) => setPrJointRqCode(selectedOption)}
                                  options={medicalReports}
                                  isSearchable={true}
                                  isDisabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                                  placeholder={t('medical')}
                                  noOptionsMessage={() => "No Medical Records Found"}
                                />}
                              <MdClear
                                size={50}
                                className="file-edit-icon cancel"
                                onClick={async (e) => {
                                  try {
                                    setEntityAction(null);
                                    setEditLifeEntityJoint(false);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                              <MdOutlineCheck
                                size={50}
                                className="file-edit-icon ok"
                                onClick={async (e) => {
                                  try {
                                    // this action is for changing insured
                                    if (entityAction === "changeInsuredJoint") {
                                      // this action is for adding joint insured
                                      if (riskEntityJoint) {
                                        await newRequest.put(
                                          `/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`,
                                          {
                                            pr_joint_aent_code: riskEntityJoint?.ent_aent_code,
                                            pr_joint_ent_code: riskEntityJoint?.ent_code,
                                            pr_joint_rq_code: null
                                          }
                                        );
                                        setRiskEntityJoint(riskEntityJoint);
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntityJoint(false);
                                        showToast(`Joint Insured ${riskEntityJoint?.ent_name} added!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select insured`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    } else if (entityAction === "medicalReportJoint") {
                                      // this action is for linking medical report
                                      if (prJointRqCode) {
                                        await newRequest.put(
                                          `/uwPolicyRisk/upd/${selectedPolicyRisk?._id}`,
                                          {
                                            pr_joint_rq_code: prJointRqCode?.value
                                          }
                                        );
                                        await fetchPolicyRisks(quoteData?._id, selectedSubClass._id);
                                        setEditLifeEntityJoint(false);
                                        showToast(`Medical report linked!`, "success");
                                      } else {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select medical report to link`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                            </motion.div>}
                        </div>
                      </div>
                    </div>
                    {(
                      [selectedPolicyRisk?.risk_entity_joint_xx?.smoke_flag_xx, selectedPolicyRisk?.risk_entity_joint_xx?.ent_nextage_xx].includes("Not Set") ||
                      selectedPolicyRisk?.risk_entity_joint_xx?.ent_status !== "Active"
                      && selectedPolicyRisk?.risk_entity_joint_xx?.ent_code
                    ) &&
                      <span className='please-note'>{`PLEASE NOTE YOU WILL NOT BE ABLE TO CALCULATE PREMIUM UNTIL YOU HAVE SPECIFIED DATE OF BIRTH, GENDER AND SMOKING FLAG FOR ${selectedPolicyRisk?.risk_entity_joint_xx?.ent_name?.toUpperCase()} AND STATUS SHOULD BE ACTIVE`}</span>}
                  </motion.div>
                </div>}
              {/* end of joint insured */}
              {/* show average age next birthday for joint plans */}
              {["term life", "whole life", "annuity"].includes(selectedSubClass?.sc_view_xx) &&
                quoteData?.pl_term_code_xx?.term_joint_type !== "none" &&
                <div className="row-five">
                  <div className="entity-details-container"><span className='please-note red'>{selectedPolicyRisk?.joint_avg_msg_xx}</span></div>
                </div>
              }
              {/* end of fields for life insurance */}
              {/* person fields */}
              {["people", "medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-six" style={{ justifyContent: "space-between" }}          >
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_full_name"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('fullName').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_full_name"
                        name="pr_full_name"
                        type="text"
                        placeholder={t('fullName').toUpperCase()}
                        value={prFullName}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrFullName(e.target.value)}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prFullName || t('unspecified')}</span>}
                  </div>
                  <div className="input-item-with-label" >
                    <label
                      htmlFor="pr_person_dob"
                      className="form-dropdown-label"
                    >
                      {t('dob').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <>
                        <input
                          id="pr_person_dob"
                          name="pr_person_dob"
                          type="date"
                          placeholder={t('dob').toUpperCase()}
                          value={prPersonDob}
                          className="form-input-item"
                          style={{ width: "200px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                          onChange={handlePersonDob}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                        <input
                          id="person_age_xx"
                          name="person_age_xx"
                          type="text"
                          placeholder={t('age').toUpperCase()}
                          value={personAgeXx}
                          className="form-input-item"
                          style={{
                            width: "100px",
                            height: "42px",
                            textAlign: "center",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            borderLeft: "none",
                            borderLeftWidth: "0px"
                          }}
                          disabled
                        />
                      </>
                      : <span className='normal-title' style={{ width: "300px" }}>{`${moment(prPersonDob).format("Do MMM YYYY")} | ${personAgeXx}`}</span>}
                  </div>
                </div>}
              {/* email and phone number */}
              {["people", "medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_person_email"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('email').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_person_email"
                        name="pr_person_email"
                        type="email"
                        placeholder={t('email').toUpperCase()}
                        value={prPersonEmail}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrPersonEmail(e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prPersonEmail}</span>}
                  </div>
                  <div
                    className="input-item-with-label" >
                    <label
                      htmlFor="pr_person_phone"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('phoneNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_person_phone"
                        name="pr_person_phone"
                        type="text"
                        placeholder={t('phoneNo').toUpperCase()}
                        value={prPersonPhone}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrPersonPhone(e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prPersonPhone}</span>}
                  </div>
                </div>}
              {/* gender and id */}
              {["people", "medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-four">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_person_address"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('address').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_person_address"
                        name="pr_person_address"
                        type="text"
                        placeholder={t('address').toUpperCase()}
                        value={prRiskAddress}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrRiskAddress(e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prRiskAddress}</span>}
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_gender"
                      className="form-dropdown-label"
                    >
                      {t('gender').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_gender"
                        name="pr_gender"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prGender}
                        onChange={(selectedOption) => setPrGender(selectedOption)}
                        options={genders}
                        isSearchable={true}
                        placeholder={t('gender').toUpperCase()}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prGender?.label || t('unspecified')}</span>}
                  </div>
                </div>}
              {/* occupation */}
              {["people", "medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-four">
                  <div className="input-item-with-label" >
                    <label
                      htmlFor="pr_person_occupation"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('occupation').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <CreatableSelect
                        id="pr_person_occupation"
                        name="pr_person_occupation"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prPersonOccupation}
                        onChange={handlePersonOccupation}
                        options={occupations}
                        isSearchable={true}
                        placeholder={t('occupation').toUpperCase()}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prPersonOccupation?.label || t('unspecified')}</span>}
                  </div>
                  <div
                    className="input-item-with-label" >
                    <label
                      htmlFor="pr_person_id"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('idNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_person_id"
                        name="pr_person_id"
                        type="text"
                        placeholder={t('idNo').toUpperCase()}
                        value={prPersonId}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrPersonId(e.target.value)}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prPersonId || t('unspecified')}</span>}
                  </div>
                </div>}
              {/* member no and member from date */}
              {["medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_member_no"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('memberNo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_member_no"
                        name="pr_member_no"
                        type="text"
                        placeholder={t('memberNo').toUpperCase()}
                        value={prMemberNo}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrMemberNo(e.target.value)}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prMemberNo || t('unspecified')}</span>}
                  </div>
                  <div
                    className="input-item-with-label"
                  >
                    <label
                      htmlFor="pr_member_fm"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('memberFrom').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_member_fm"
                        name="pr_member_fm"
                        type="date"
                        placeholder={t('memberFrom').toUpperCase()}
                        value={prMemberFm}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrMemberFm(e.target.value)}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{moment(prMemberFm).format("Do MMM YYYY") || t('unspecified')}</span>}
                  </div>
                </div>}
              {/* member status and to date */}
              {["medical"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-four">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_member_status"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('status').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <Select
                        id="pr_member_status"
                        name="pr_member_status"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={prMemberStatus}
                        onChange={(selectedOption) => setPrMemberStatus(selectedOption)}
                        options={memberStatus}
                        isSearchable={true}
                        placeholder={t('status').toUpperCase()}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{prMemberStatus?.label || t('unspecified')}</span>}
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{
                      justifyContent: "flex-end",
                      flex: "1",
                    }}
                  >
                    <label
                      htmlFor="pr_member_to"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('memberTo').toUpperCase()}
                    </label>
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                      <input
                        id="pr_member_to"
                        name="pr_member_to"
                        type="date"
                        placeholder={t('memberTo').toUpperCase()}
                        value={prMemberTo}
                        className="form-input-item"
                        style={{ width: "300px" }}
                        onChange={(e) => setPrMemberTo(e.target.value)}
                      /> : <span className='normal-title' style={{ width: "300px" }}>{moment(prMemberTo).format("Do MMM YYYY") || t('unspecified')}</span>}
                  </div>
                </div>}
              {quoteData?.pl_interest_yn === "Y" &&
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    alignItems: "center",
                    paddingRight: "5px",
                    justifyContent: "flex-end"
                  }}
                >
                  <div className="input-item-with-label">
                    <label htmlFor="pr_interest_ent_code">{t('financier').toUpperCase()}</label>
                    <AsyncSelect
                      id="pr_interest_ent_code"
                      name="pr_interest_ent_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      isClearable
                      width="480px"
                      value={prInterestEntCode}
                      onChange={(selectedOption) => setPrInterestEntCode(selectedOption)}
                      loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                      isSearchable={true}
                      placeholder={t('financialInterest')}
                      noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                      isDisabled={quoteData?.document_enabled_xx !== "Y" || selectedSubClass?.ps_endorsed !== "Y" || selectedPolicyRisk?.pr_endorsed !== "Y"}
                    />
                  </div>
                </div>}
              {["fire", "engineering", "default"].includes(selectedSubClass?.sc_view_xx) &&
                <div className="row-seven">
                  <div className="input-item-with-label" style={{ width: "100%" }}>
                    <label
                      htmlFor="place"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('place').toUpperCase()}
                    </label>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "10px" }}>
                      <div style={{ display: "flex", flex: "1", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                        <span className='normal-title'>{prPlaceName || t('notSelected').toUpperCase()}</span>
                        {quoteData?.document_enabled_xx === "Y" &&
                          selectedSubClass?.ps_endorsed === "Y" &&
                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={(e) => setPlacesDialogOpen(true)}
                            color="#3F51B5"
                            icon={<IoLocationSharp />}
                            width={"30px"}
                            height={"30px"} />}
                      </div>
                      <div className='google-place-wrapper' onClick={() => {
                        if (prLatitude && prLongitude) { handleOpenMap(prLatitude, prLongitude) }
                      }}>
                        <span className='normal-title'>{`${t('latitude')} ${prLatitude || ""}`}</span>
                        <span className='normal-title'>{`${t('longitude')} ${prLongitude || ""}`}</span>
                      </div>
                    </div>
                  </div>
                </div>}
              {selectedSubClass?.attributes_xx !== "default" && (
                <div className="person-attributes-wrapper">
                  <div className="person-attributes-title">
                    <span className='normal-title'>{t('attributes').toUpperCase()}</span>
                    {quoteData?.document_enabled_xx === "Y" &&
                      <CircularButton
                        currentTheme={currentTheme}
                        onClick={async () => {
                          try {
                            await fetchSysCode(selectedSubClass?.attributes_xx);
                            setShowAddSysCodes(true);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        color="#2E7D32"
                        icon={<MdAdd />}
                        width={"30px"}
                        height={"30px"} />}
                  </div>
                  <div className="person-attributes-content">
                    {prOtherAttributes.map((attr, index) => (
                      <div key={attr._id} className="attribute-item">
                        <ToggleSwitch
                          key={attr._id}
                          id={attr._id}
                          value={attr.attribute_yn}
                          onChange={(newValue) => handleOtherAttributeChange(attr?._id, newValue)}
                          label={`${index + 1}. ${attr?.attribute_desc}`}
                          labelPosition="start"
                          labelWidth="160px"
                          labelStyle={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                          disabled={quoteData?.document_enabled_xx !== "Y"}
                          border="Y"
                          style={{ width: "100%" }}
                          delete_yn={true}
                          onClickClear={async () => {
                            try {
                              if (quoteData?.document_enabled_xx !== "Y") {
                                setNotifyDialogTitle(t('note'));
                                setNotifyDialogText("Delete not allowed when document is not enabled");
                                setIsNotifyDialogOpen(true);
                                return;
                              } else {
                                await newRequest.post(
                                  "/uwPolicyRisk/delOtherAttr",
                                  {
                                    risk_docid: selectedPolicyRisk?._id,
                                    other_attribute_docid: attr._id,
                                  }
                                );
                                await fetchOtherAttributes();
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* end of person fields */}
              {/* start of marine fields */}
              {["marine_cert"].includes(selectedSubClass?.sc_view_xx) && (
                <div className="marine-details-wrapper">
                  <div className="marine-details-row">
                    <div className="marine-details-left">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="cert_no"
                          className="form-dropdown-label"
                          style={{ width: "130px" }}
                        >
                          {t('certNo').toUpperCase()}
                        </label>
                        <input
                          id="cert_no"
                          name="cert_no"
                          type="text"
                          placeholder={t('certNo').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "250px" }}
                          value={prMarineInfo?.cert_no}
                          onChange={(e) => updateMarineField('cert_no', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                    </div>
                    <div className="marine-details-right">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="shipping_mode"
                          className="form-dropdown-label"
                          style={{ width: "130px" }}
                        >
                          {t('shippingBy').toUpperCase()}
                        </label>
                        <input
                          id="shipping_mode"
                          name="shipping_mode"
                          type="text"
                          placeholder={t('shippingBy').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "250px" }}
                          value={prMarineInfo?.shipping_mode}
                          onChange={(e) => updateMarineField('shipping_mode', e.target.value)}
                          disabled={true}
                        />
                        {/* <Select
                      id="shipping_mode"
                      name="shipping_mode"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="250px"
                      options={shippingModes}
                      value={shippingModes.find(option => option.value === prMarineInfo?.shipping_mode) || null}
                      onChange={(selectedOption) => {
                        try {
                          updateMarineField('shipping_mode', selectedOption?.value);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      isSearchable={true}
                      isDisabled={quoteData?.document_enabled_xx === "N"}
                      placeholder={t('shippingBy').toUpperCase()}
                    /> */}
                      </div>
                    </div>
                  </div>
                  <hr className='separator-h' />
                  <div className="marine-details-row">
                    <div className="marine-details-left">
                      <h1 className="main-title" style={{ alignSelf: "center" }}>{t('origin').toUpperCase()}</h1>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="origin_address"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('originAddress').toUpperCase()}
                        </label>
                        <input
                          id="origin_address"
                          name="origin_address"
                          type="text"
                          placeholder={t('originAddress').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "250px" }}
                          value={prMarineInfo?.origin_address}
                          onChange={(e) => updateMarineField('origin_address', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="origin_port"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('originPort').toUpperCase()}
                        </label>
                        <CreatableSelect
                          id="origin_port"
                          name="origin_port"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="250px"
                          onChange={handleSelectedOriginPort}
                          value={ports.find(option => option.value === prMarineInfo?.origin_port) || null}
                          options={ports}
                          isSearchable={true}
                          isDisabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                          placeholder={t('originPort').toUpperCase()}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="est_depature_date"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('estDepatureDate').toUpperCase()}
                        </label>
                        <input
                          id="est_depature_date"
                          name="est_depature_date"
                          type="date"
                          placeholder={t('estDepatureDate').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          value={moment(prMarineInfo?.est_depature_date).format("YYYY-MM-DD")}
                          onChange={(e) => updateMarineField('est_depature_date', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="act_depature_date"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('actDepatureDate').toUpperCase()}
                        </label>
                        <input
                          id="act_depature_date"
                          name="act_depature_date"
                          type="date"
                          placeholder={t('actDepatureDate').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          value={moment(prMarineInfo?.act_depature_date).format("YYYY-MM-DD")}
                          onChange={(e) => updateMarineField('act_depature_date', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                    </div>
                    <div className="marine-details-right">
                      <h1 className="main-title" style={{ alignSelf: "center" }}>{t('destination').toUpperCase()}</h1>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="dest_address"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('destAddress').toUpperCase()}
                        </label>
                        <input
                          id="dest_address"
                          name="dest_address"
                          type="text"
                          placeholder={t('destAddress').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "250px" }}
                          value={prMarineInfo?.dest_address}
                          onChange={(e) => updateMarineField('dest_address', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="dest_port"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('destPort').toUpperCase()}
                        </label>
                        <CreatableSelect
                          id="dest_port"
                          name="dest_port"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="250px"
                          onChange={handleSelectedDestPort}
                          value={ports.find(option => option.value === prMarineInfo?.dest_port) || null}
                          options={ports}
                          isSearchable={true}
                          isDisabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                          placeholder={t('destPort').toUpperCase()}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="est_arrival_date"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('estArrivalDate').toUpperCase()}
                        </label>
                        <input
                          id="est_arrival_date"
                          name="est_arrival_date"
                          type="date"
                          placeholder={t('estArrivalDate').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          value={moment(prMarineInfo?.est_arrival_date).format("YYYY-MM-DD")}
                          onChange={(e) => updateMarineField('est_arrival_date', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="act_arrival_date"
                          className="form-dropdown-label"
                          style={{ width: "max-content" }}
                        >
                          {t('actArrivalDate').toUpperCase()}
                        </label>
                        <input
                          id="act_arrival_date"
                          name="act_arrival_date"
                          type="date"
                          placeholder={t('actArrivalDate').toUpperCase()}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          value={moment(prMarineInfo?.act_arrival_date).format("YYYY-MM-DD")}
                          onChange={(e) => updateMarineField('act_arrival_date', e.target.value)}
                          disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        />
                      </div>
                    </div>
                  </div>
                  <hr className='separator-h' />
                  <div className="marine-details-row">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="vessel_no"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('vesselNo').toUpperCase()}
                      </label>
                      <input
                        id="vessel_no"
                        name="vessel_no"
                        type="text"
                        placeholder={t('vesselNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.vessel_no}
                        onChange={(e) => updateMarineField('vessel_no', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="flight_no"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('flightNo').toUpperCase()}
                      </label>
                      <input
                        id="flight_no"
                        name="flight_no"
                        type="text"
                        placeholder={t('flightNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.flight_no}
                        onChange={(e) => updateMarineField('flight_no', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="marks_and_number"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('marksNo').toUpperCase()}
                      </label>
                      <input
                        id="marks_and_number"
                        name="marks_and_number"
                        type="text"
                        placeholder={t('marksNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.marks_and_number}
                        onChange={(e) => updateMarineField('marks_and_number', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                  </div>
                  <div className="marine-details-row">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="invoice_no"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('invoiceNo').toUpperCase()}
                      </label>
                      <input
                        id="invoice_no"
                        name="invoice_no"
                        type="text"
                        placeholder={t('invoiceNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.invoice_no}
                        onChange={(e) => updateMarineField('invoice_no', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="idf_number"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('idfNo').toUpperCase()}
                      </label>
                      <input
                        id="idf_number"
                        name="idf_number"
                        type="text"
                        placeholder={t('idfNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.idf_number}
                        onChange={(e) => updateMarineField('idf_number', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="no_of_packages"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('noOfPkgs').toUpperCase()}
                      </label>
                      <input
                        id="no_of_packages"
                        name="no_of_packages"
                        type="text"
                        placeholder="NO OF PACKAGES"
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.no_of_packages}
                        onChange={(e) => updateMarineField('no_of_packages', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                  </div>
                  <hr className='separator-h' />
                  <h1 className='main-title'>{`${t('limits')} ${quoteData?.pl_cur_code}`}</h1>
                  <div className="marine-details-row">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="any_one_loss_limit"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('singleLoss').toUpperCase()}
                      </label>
                      <input
                        id="any_one_loss_limit"
                        name="any_one_loss_limit"
                        type="text"
                        placeholder="0.00"
                        className="form-input-item"
                        style={{ width: "160px", textAlign: "right" }}
                        value={prMarineInfo?.any_one_loss_limit}
                        onChange={(e) => updateMarineField('any_one_loss_limit', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        onBlur={handleMarineLimitsBlur}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="single_transit_limit"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('singleTransit').toUpperCase()}
                      </label>
                      <input
                        id="single_transit_limit"
                        name="single_transit_limit"
                        type="text"
                        placeholder="0.00"
                        className="form-input-item"
                        style={{ width: "160px", textAlign: "right" }}
                        value={prMarineInfo?.single_transit_limit}
                        onChange={(e) => updateMarineField('single_transit_limit', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        onBlur={handleMarineLimitsBlur}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="annual_carry_limit"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('annualCarry').toUpperCase()}
                      </label>
                      <input
                        id="annual_carry_limit"
                        name="annual_carry_limit"
                        type="number"
                        placeholder="0.00"
                        className="form-input-item"
                        style={{ width: "160px", textAlign: "right" }}
                        value={prMarineInfo?.annual_carry_limit}
                        onChange={(e) => updateMarineField('annual_carry_limit', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                        onBlur={handleMarineLimitsBlur}
                      />
                    </div>
                  </div>
                  <hr className='separator-h' />
                  <div className="marine-details-row">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="bill_of_lading_no"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('ladingNo').toUpperCase()}
                      </label>
                      <input
                        id="bill_of_lading_no"
                        name="bill_of_lading_no"
                        type="text"
                        placeholder={t('ladingNo').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.bill_of_lading_no}
                        onChange={(e) => updateMarineField('bill_of_lading_no', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="bill_of_lading_date"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('ladingDate').toUpperCase()}
                      </label>
                      <input
                        id="bill_of_lading_date"
                        name="bill_of_lading_date"
                        type="date"
                        placeholder={t('ladingDate').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={moment(prMarineInfo?.bill_of_lading_date).format("YYYY-MM-DD")}
                        onChange={(e) => updateMarineField('bill_of_lading_date', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="tranship_at"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('transhipAt').toUpperCase()}
                      </label>
                      <input
                        id="tranship_at"
                        name="tranship_at"
                        type="text"
                        placeholder={t('transhipAt').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "160px" }}
                        value={prMarineInfo?.tranship_at}
                        onChange={(e) => updateMarineField('tranship_at', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                  </div>
                  <div className="marine-details-row">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="supplier"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('supplier').toUpperCase()}
                      </label>
                      <input
                        id="supplier"
                        name="supplier"
                        type="text"
                        placeholder={t('supplier').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "250px" }}
                        value={prMarineInfo?.supplier}
                        onChange={(e) => updateMarineField('supplier', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="clearing_agent"
                        className="form-dropdown-label"
                        style={{ width: "max-content" }}
                      >
                        {t('clearingAgent').toUpperCase()}
                      </label>
                      <input
                        id="clearing_agent"
                        name="clearing_agent"
                        type="text"
                        placeholder={t('clearingAgent').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "250px" }}
                        value={prMarineInfo?.clearing_agent}
                        onChange={(e) => updateMarineField('clearing_agent', e.target.value)}
                        disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                      />
                    </div>
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="goods_desc"
                      className="form-dropdown-label"
                      style={{ width: "115px", alignSelf: "flex-start" }}
                    >
                      {t('goodsDescription').toUpperCase()}
                    </label>
                    <textarea
                      id="goods_desc"
                      name="goods_desc"
                      type="text"
                      placeholder={t('goodsDescription').toUpperCase()}
                      rows={3}
                      className="form-input-item"
                      style={{ width: "100%" }}
                      value={prMarineInfo?.goods_desc}
                      onChange={(e) => updateMarineField('goods_desc', e.target.value)}
                      disabled={quoteData?.document_enabled_xx === "N" || selectedSubClass?.ps_endorsed === "N"}
                    />
                  </div>
                </div>
              )}
              {/* This view is for claim settlement and applicable perils */}
              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <hr className="separator-h" />
                <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "flex-start", gap: "5px" }}>
                  {/* basis of claim settlement */}
                  {selectedSubClass?.sc_show_basis_xx === "Y" &&
                    <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                      <div className="content-details-row">
                        <span className="sub-title">{`${t('basisOfClaimSettlement').toUpperCase()} ${prClaimBasis?.length === 0 ? t('notSpecified').toUpperCase() : ""}`}</span>
                      </div>
                      {quoteData?.document_enabled_xx === "Y" && (
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", width: "100%", padding: "0px 5px", marginBottom: "10px" }}>
                          <div
                            className="input-item-with-label"
                            style={{ width: "100%" }}
                          >
                            <input
                              type="text"
                              value={basisOfClaim}
                              className="form-input-item"
                              placeholder={t('enterBasisText')}
                              style={{ width: "100%" }}
                              onChange={(e) => setBasisOfClaim(e.target.value)}
                            />
                          </div>
                          {quoteData?.document_enabled_xx === "Y" &&
                            selectedSubClass?.ps_endorsed === "Y" &&
                            <CircularButton
                              currentTheme={currentTheme}
                              onClick={handleAddClaimBasis}
                              color="#0ea5a4"
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          }
                        </div>
                      )}
                      <div className="content-details-row">
                        {/* basis of claim text */}
                        {prClaimBasis?.length > 0 && (
                          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            {prClaimBasis?.map((claim, index) => (
                              <div key={claim._id} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", padding: "2px 5px" }}>
                                <span className='sub-title' style={{ width: "15px", textAlign: "center" }} >
                                  {index + 1}.
                                </span>
                                <span className='sub-title'>{claim?.basis_text}</span>
                                {quoteData?.document_enabled_xx === "Y" &&
                                  selectedSubClass?.ps_endorsed === "Y" && (
                                    <Tooltip
                                      title={`${t('remove')} ${claim?.basis_text}`}
                                      placement="right"
                                    >
                                      <MdClose
                                        size={24}
                                        style={{
                                          borderRadius: "5px",
                                          padding: "3px",
                                          cursor: "pointer",
                                          color: "rgba(172, 33, 9)",
                                          backgroundColor: "rgba(172, 33, 9, 0.5)",
                                        }}
                                        onClick={() => {
                                          try {
                                            setObjectToAction({
                                              object_id: claim?._id,
                                              action_text: `Remove ${claim?.basis_text} from this document?`,
                                            });
                                            setConfirmDialogAction("removeClaimBasis");
                                            setIsConfirmDialogOpen(true);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>}
                  {/* end of basis of claim settlement */}
                  {selectedSubClass?.sc_show_perils_xx === "Y" && selectedSubClass?.sc_show_basis_xx === "Y" && <hr className="separator-v" />}
                  {/* applicable perils */}
                  {selectedSubClass?.sc_show_perils_xx === "Y" &&
                    <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                      <div className="content-details-row">
                        <span className="sub-title">{`${t('applicablePerils').toUpperCase()} ${prClaimBasis?.length === 0 ? t('notSpecified').toUpperCase() : ""}`}</span>
                      </div>
                      {quoteData?.document_enabled_xx === "Y" &&
                        selectedSubClass?.ps_endorsed === "Y" && (
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", width: "100%", padding: "0px 5px", marginBottom: "10px" }}>
                            <div
                              className="input-item-with-label"
                              style={{ width: "100%" }}
                            >
                              <input
                                type="text"
                                value={peril}
                                className="form-input-item"
                                placeholder={t('peril')}
                                style={{ width: "100%" }}
                                onChange={(e) => setPeril(e.target.value)}
                              />
                            </div>
                            {quoteData?.document_enabled_xx === "Y" &&
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={handleAddPeril}
                                color="#0ea5a4"
                                icon={<MdAdd />}
                                width={"35px"}
                                height={"35px"} />
                            }
                          </div>
                        )}
                      <div className="content-details-row">
                        {/* applicable perils */}
                        {prPerils?.length > 0 && (
                          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            {prPerils?.map((row, index) => (
                              <div key={row?._id} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", padding: "2px 5px" }}>
                                <span className='sub-title' style={{ width: "15px", textAlign: "center" }} >
                                  {index + 1}.
                                </span>
                                <span className='sub-title'>{row?.peril}</span>
                                {quoteData?.document_enabled_xx === "Y" &&
                                  selectedSubClass?.ps_endorsed === "Y" && (
                                    <Tooltip
                                      title={`${t('remove')} ${row?.peril}`}
                                      placement="right"
                                    >
                                      <MdClose
                                        size={24}
                                        style={{
                                          borderRadius: "5px",
                                          padding: "3px",
                                          cursor: "pointer",
                                          color: "rgba(172, 33, 9)",
                                          backgroundColor: "rgba(172, 33, 9, 0.5)",
                                        }}
                                        onClick={() => {
                                          try {
                                            setObjectToAction({
                                              object_id: row?._id,
                                              action_text: `Do remove ${row?.peril} from this document?`,
                                            });
                                            setConfirmDialogAction("removePeril");
                                            setIsConfirmDialogOpen(true);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>}
                  {/* end of applicable perils */}
                </div>
              </div>
              {/* end of marine fields */}
              {/* <hr className='separator-h' /> */}
              {viewBeneficiaries &&
                <motion.div
                  className="beneficiaries"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <div className="beneficiaries-wrapper">
                    {quoteData?.document_enabled_xx === "Y" &&
                      selectedSubClass?.ps_endorsed === "Y" &&
                      <div className="beneficiaries-navbar">
                        <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                          <AsyncSelect
                            id="risk_beneficiary"
                            name="risk_beneficiary"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={riskBeneficiary}
                            onChange={(selectedOption) => setRiskBeneficiary(selectedOption)}
                            loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Individual"])}
                            isSearchable={true}
                            placeholder={t('beneficiary')}
                            noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                          />
                          <div className="input-item-with-label">
                            <Select
                              id="rela_type"
                              name="rela_type"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="160px"
                              value={selectedRelationshipType}
                              onChange={(selectedOption) => setSelectedRelationshipType(selectedOption)}
                              options={relationshipTypes}
                              isSearchable={true}
                              isDisabled={quoteData?.document_enabled_xx === "N"}
                              placeholder={t('relationship').toUpperCase()}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <input
                              id="rela_perc"
                              name="rela_perc"
                              type="number"
                              placeholder="%"
                              value={beneficiaryPerc}
                              className="form-input-item"
                              style={{ width: "80px", textAlign: "right" }}
                              min="1"
                              max="100"
                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (value < 1 || value > 100) {
                                  e.target.value = beneficiaryPerc;
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please ener value <b>between 1 and 100</b>.`);
                                  setIsNotifyDialogOpen(true);
                                } else {
                                  try {
                                    setBeneficiaryPerc(value);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }
                              }}
                            />
                          </div>
                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={async (e) => {
                              try {
                                if (!selectedRelationshipType) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please select beneficiary relationship to insured`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                if (!beneficiaryPerc) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please beneficiary percentage`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                if (riskBeneficiary) {
                                  if (riskBeneficiary?.ent_code === selectedPolicyRisk?.risk_entity_xx?.ent_code) {
                                    setNotifyDialogTitle("Note!");
                                    setNotifyDialogText(`${riskBeneficiary?.label} is the insured. CANNOT be a beneficiary.`);
                                    setIsNotifyDialogOpen(true);
                                    setRiskBeneficiary(null);
                                    setSelectedRelationshipType(null);
                                    setBeneficiaryPerc(0);
                                    return;
                                  }

                                  const res = await newRequest.post(
                                    "/uwPolicyRisk/addBeneficiary",
                                    {
                                      risk_docid: selectedPolicyRisk?._id,
                                      beneficiary_type: "pr_primary_beneficiary",
                                      ben_aent_code: riskBeneficiary?.ent_aent_code,
                                      ben_ent_code: riskBeneficiary?.ent_code,
                                      ben_relationship: selectedRelationshipType?.value,
                                      ben_percentage: beneficiaryPerc,
                                      ben_remarks: currentUser.usr_id,
                                    }
                                  );

                                  if (res.data === "added") {
                                    setRiskBeneficiary(null);
                                    setSelectedRelationshipType(null);
                                    setBeneficiaryPerc(0);
                                    showToast(`Beneficiary ${riskBeneficiary?.ent_name} added`, "success"
                                    );
                                  } else if (res.data === "exists") {
                                    showToast(`Beneficiary ${riskBeneficiary?.ent_name} already attached`, "error"
                                    );
                                  } else {
                                    setNotifyDialogTitle("Error!");
                                    setNotifyDialogText(res.data);
                                    setIsNotifyDialogOpen(true);
                                    return;
                                  }
                                  await fetchPrimaryBeneficiaries(selectedPolicyRisk?._id);
                                } else {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please select beneficiary`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            color="#0ea5a4"
                            icon={<MdAdd />}
                            width={"35px"}
                            height={"35px"} />
                        </span>
                        <CustomButtonSmallDarkBg
                          currentTheme={currentTheme}
                          onClick={() => setViewBeneficiaries(!viewBeneficiaries)}
                          bgColor={"#fff"}
                          ftColor={"#263238"}
                          startIcon={<GiPresent />}
                          isCurrent={true}
                        >
                          {t('benefits').toUpperCase()}
                        </CustomButtonSmallDarkBg>
                      </div>}
                    <div className="beneficiaries-content">
                      {primaryBeneficiaries?.length > 0 &&
                        <div className="beneficiaries-wrapper">
                          {primaryBeneficiaries?.map((row, index) => (
                            <div key={row?._id} className='single-beneficiary'>
                              <div className="single-beneficiary-left">
                                {row?.beneficiary_photo_url ?
                                  <img src={row?.beneficiary_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                              </div>
                              <div className="single-beneficiary-right">
                                <div className="single-beneficiary-header">
                                  <span className='beneficiary-name'>{row?.beneficiary_name}</span>
                                  <span className="relationship-type">{row?.relationship_xx}</span>
                                </div>
                                <div className="beneficiary-phone-row">
                                  <span className="beneficiary-phone-details" style={{ flex: "1.5" }}> <MdAlternateEmail className="icon" />{row?.beneficiary_email}</span>
                                  <span className="beneficiary-phone-details" style={{ flex: "1" }}> <MdPhone className="icon" />{row?.beneficiary_phone_no}</span>
                                  {!["Male", "Female"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details" style={{ flex: "0.7" }}><TbGenderEpicene className="icon" /> {row?.beneficiary_gender}</span>}
                                  {["Male"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details" style={{ flex: "0.7" }}><PiGenderMaleBold className="icon" /> {row?.beneficiary_gender}</span>}
                                  {["Female"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details" style={{ flex: "0.7" }}><PiGenderFemaleBold className="icon" /> {row?.beneficiary_gender}</span>}
                                  <span className="beneficiary-phone-details"
                                    style={{ cursor: "pointer", flex: "0.7" }}
                                    onClick={() => navigate(`/entity/${row?.beneficiary_ent_docid}`)}>
                                    <MdNumbers className="icon" />{row?.ben_ent_code}</span>
                                  <span className="percentage">{`${row?.ben_percentage}%`}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>}
                    </div>
                  </div>
                </motion.div>}
              {selectedSubClass?.sc_show_charges_xx === "Y" &&
                <motion.div
                  className="applicable-covers"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <ExpandableComponent
                    title={t('riskCharges').toUpperCase()}
                    subtitle={""}
                    onSubtitleClick={() => { }}
                    defaultExpanded={true}
                  >
                    <UwPolicyCharges
                      key={selectedPolicyRisk?._id}
                      ref={ref}
                      policyDocid={quoteData._id}
                      plCurCode={quoteData?.pl_cur_code}
                      riskNoteNo={quoteData?.pl_risk_note_no}
                      endIndex={quoteData?.pl_end_index}
                      chargeLevel="Risk"
                      riskDocid={selectedPolicyRisk?._id}
                      productCode={quoteData?.pl_product_code}
                      endorsementCode={quoteData?.pl_end_code}
                      documentEnabled={quoteData?.document_enabled_xx}
                      profileLimitValues={profileLimitValues} />
                  </ExpandableComponent>
                </motion.div>}

              {selectedSubClass?.sc_show_excess_xx === "Y" &&
                <motion.div
                  className="applicable-covers"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  <ExpandableComponent
                    title={t('riskExcess').toUpperCase()}
                    subtitle={""}
                    onSubtitleClick={() => { }}
                    defaultExpanded={true}
                  >
                    <UwPolicyExcess
                      key={`excess-${selectedPolicyRisk?._id}`}
                      quoteData={quoteData}
                      refreshQuote={() => { }}
                      ref={policyExcessRef}
                      profileLimitValues={profileLimitValues}
                      mcCode={selectedSubClass?.ps_mc_code}
                      scCode={selectedSubClass?.ps_sc_code}
                      scEndorsed={selectedSubClass?.ps_endorsed}
                      excessLevel="Risk"
                      excessRiskDocid={selectedPolicyRisk?._id}
                    />
                  </ExpandableComponent>
                </motion.div>}

              {!viewBeneficiaries &&
                <motion.div
                  className="applicable-covers"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  {!editLifeEntity &&
                    quoteData?.document_enabled_xx === "Y" &&
                    selectedSubClass?.ps_endorsed === "Y" &&
                    getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_add_cover") === "Y" && (
                      <div className="cover-buttons-wrapper" >
                        <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                          <Select
                            id="cover"
                            name="cover"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="315px"
                            value={selectedSubClassCover}
                            onChange={(selectedOption) => setSelectedSubClassCover(selectedOption)}
                            options={subClassCovers}
                            isSearchable={true}
                            placeholder={t('cover').toUpperCase()}
                          />
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition='end'
                            borderRadiusType="both"
                            variant="tint"
                            color="#0ea5a4"
                            tooltip={"Add cover to selected risk"}
                            endIcon={<AddIcon />}
                            onClick={handleAddCover}
                          >
                            {t('addCover')}
                          </CustomLoadingButton>
                        </div>
                        {quoteData?.document_enabled_xx === "Y" &&
                          selectedSubClass?.ps_endorsed === "Y" &&
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition='end'
                            borderRadiusType="both"
                            variant="tint"
                            color="#DD2C00"
                            tooltip={"Calculate premium for this document"}
                            endIcon={<CalculateIcon />}
                            onClick={calculatePremium}
                          >
                            {t('calculatePremium')}
                          </CustomLoadingButton>
                        }
                      </div>
                    )}
                  {policyRiskCovers !== null && (
                    <div className="applicable-covers-wrapper"
                      key={quoteData?.policy_fc_premium}
                    >
                      {policyRiskCovers.map((cover) => (
                        <div
                          key={cover?._id}
                          className={`${cover?._id === selectedPolicyRiskCover?._id
                            ? "single-cover active"
                            : "single-cover"
                            }`}
                          onClick={async () => {
                            try {
                              await saveSmis();
                              setSelectedPolicyRiskCover(cover);
                              // console.log(`getPrefixSafe(cover?.dmvic_cover_xx) ... ${cover?.dmvic_cover_xx} ... ${getPrefixSafe(cover?.dmvic_cover_xx)}`);
                              const filteredTypes = vehicleCertTypes.filter((val) => val?.grouping === getPrefixSafe(cover?.dmvic_cover_xx));
                              setFilteredCertTypes(filteredTypes);
                              // refreshing smi
                              fetchSelectedCoverSmi(cover?.rc_risk_note_no, cover?._id);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <div className="single-cover-title" style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                              <span className='normal-title'>{cover?.cover_name_xx}</span>

                              {quoteData?.document_enabled_xx === "Y" &&
                                selectedSubClass?.ps_endorsed === "Y" &&
                                selectedPolicyRisk?.pr_endorsed === "Y" &&
                                getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_edit_cover") === "Y" && (
                                  <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "3px",
                                  }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={() => {
                                        try {
                                          setSelectedPolicyRiskCover(cover);
                                          // console.log(`getPrefixSafe(cover?.dmvic_cover_xx) ... ${cover?.dmvic_cover_xx} ... ${getPrefixSafe(cover?.dmvic_cover_xx)}`);
                                          const filteredTypes = vehicleCertTypes.filter((val) => val?.grouping === getPrefixSafe(cover?.dmvic_cover_xx));
                                          setFilteredCertTypes(filteredTypes);
                                          setShowCoverForEditing(true);
                                          setShowMovement(false);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      icon={<MdEdit color='green' />} width={"30px"} height={"30px"} />
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      color="#D32F2F"
                                      onClick={() => {
                                        try {
                                          setObjectToAction({
                                            object_id: cover._id,
                                            action_text: `Remove ${cover?.cover_name_xx}?`,
                                            new_doc_status: "deleteCover",
                                            param1: cover?.cover_name_xx
                                          });
                                          setConfirmDialogAction("deleteCover");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      icon={<MdDelete />}
                                      width={"30px"}
                                      height={"30px"} />
                                  </div>
                                )}
                            </div>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="rc_comm_perc"
                                  style={{ width: "max-content" }}
                                >
                                  {t('commission').toUpperCase()}
                                </label>
                                <div className="tooltip-container">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                                    <input
                                      id="rc_comm_perc"
                                      name="rc_comm_perc"
                                      type="text"
                                      value={cover?.rc_comm_perc}
                                      onChange={(e) => handleCoverInputChange(e, cover?._id, 'rc_comm_perc')}
                                      className="form-input-item table"
                                      style={{ width: "70px", textAlign: "right" }}
                                      onBlur={() => {
                                        handleCoverBlur(cover?._id, "rc_comm_perc");
                                      }}
                                      disabled={isRcCommPercDisabled()}
                                    /> :
                                    <span>{cover?.rc_comm_perc}</span>
                                  }
                                  {isRcCommPercDisabled() && (
                                    <span className="tooltip-text">{`UW1008 - You are not allowed to amend COMMISSION RATE for ${quoteData?.product_name_xx}`}</span>
                                  )}
                                </div>
                              </div>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="rc_comm_tax_perc"
                                  style={{ width: "max-content" }}
                                >
                                  {t('tax').toUpperCase()}
                                </label>
                                <div className="tooltip-container">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" ?
                                    <input
                                      id="rc_comm_tax_perc"
                                      name="rc_comm_tax_perc"
                                      type="text"
                                      value={cover?.rc_comm_tax_perc}
                                      onChange={(e) => handleCoverInputChange(e, cover?._id, 'rc_comm_tax_perc')}
                                      className="form-input-item table"
                                      style={{ width: "70px", textAlign: "right" }}
                                      onBlur={() => { handleCoverBlur(cover?._id, "rc_comm_tax_perc"); }}
                                      disabled={isRcCommTaxDisabled(parseFloat(cover?.rc_comm_perc))}
                                    /> : <span>{cover?.rc_comm_tax_perc}</span>
                                  }
                                  {isRcCommTaxDisabled(parseFloat(cover?.rc_comm_perc)) && (
                                    <span className="tooltip-text">{`UW1008 - You are not allowed to amend COMMISSION TAX RATE for ${quoteData?.product_name_xx}`}</span>
                                  )}
                                </div>
                              </div>
                              {/* set commission as default */}
                              {parseFloat(cover?.rc_comm_perc) > 0 &&
                                quoteData?.document_enabled_xx === "Y" &&
                                selectedSubClass?.ps_endorsed === "Y" &&
                                selectedPolicyRisk?.pr_endorsed === "Y" &&
                                getLimitValue("UW1024") === "Y" ?
                                <CustomLoadingButton
                                  currentTheme={currentTheme}
                                  height={"36px"}
                                  iconPosition="end"
                                  borderRadiusType="both"
                                  variant="tint"
                                  color="#00D37F"
                                  tooltip={`Set ${cover?.rc_comm_perc} as default commission rate for ${quoteData?.carrier_name_xx}`}
                                  onClick={() => {
                                    try {
                                      if (!cover?.rc_comm_perc) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Enter commission rate`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }
                                      const formattedRate = parseFloat(cover?.rc_comm_perc);
                                      const formattedTax = parseFloat(cover?.rc_comm_tax_perc);

                                      let action_text = `When you click YES, system will set COMMISSION RATE ${cover?.rc_comm_perc}% and TAX ${cover?.rc_comm_tax_perc}% as <strong>DEFAULT</strong> for ${quoteData?.carrier_name_xx} for cover ${cover?.cover_name_xx}. This means next <strong>${cover?.cover_name_xx} you underwrite for this carrier, these values will be defaulted</strong>. Do you want to proceed?`;

                                      setObjectToAction({
                                        object_id: cover?._id,
                                        action_text: action_text,
                                        new_doc_status: "setDefaultCommRate",
                                        param1: formattedRate,
                                        param2: formattedTax,
                                        param3: cover?.rc_mc_code,
                                        param4: cover?.rc_sc_code,
                                        param5: cover?.rc_cc_code
                                      });
                                      setConfirmDialogAction("setDefaultCommRate");
                                      setIsConfirmDialogOpen(true);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}>
                                  {t('setDefault').toUpperCase()}
                                </CustomLoadingButton> : <span style={{ display: "flex", width: "50px" }}></span>}
                            </span>
                          </div>
                          <div className={`${cover?._id === selectedPolicyRiskCover?._id
                            ? "single-cover-desc active"
                            : "single-cover-desc"
                            }`}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                              <span className='normal-text'> {cover?.rc_desc}</span>
                              <span className='normal-title' style={{ fontSize: "12px", fontWeight: "bold" }}>{cover?.rc_cc_code}</span>
                            </div>
                          </div>
                          {quoteData?.document_enabled_xx === "Y" &&
                            selectedSubClass?.ps_endorsed === "Y" &&
                            selectedPolicyRisk?.pr_endorsed === "Y" &&
                            <div className='compare-rates-wrapper'>
                              {/* <hr className='separator-h' /> */}
                              <div className="compare-content">
                                {["agent", "broker"].includes(currentUser?.token_org_type) &&
                                  <div className="compare-rates"
                                    onClick={(e) => {
                                      try {
                                        e.stopPropagation();
                                        compareRates({
                                          mc_code: cover?.rc_mc_code,
                                          sc_code: cover?.rc_sc_code,
                                          cc_code: cover?.rc_cc_code,
                                          coverText: `${cover?.cover_name_xx} - ${cover?.rc_cc_code}`
                                        });
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}>
                                    <span className='sub-title'>{t('compareRatesDesc', { param1: `${cover?.cover_name_xx} - ${cover?.rc_cc_code}` })}</span>
                                  </div>}
                                {cover?.dmvic_issue_xx === "Y" &&
                                  quoteData?.drcr_flag_xx === "D" &&
                                  <div className="issue-cert-actions">
                                    <CustomLoadingButton
                                      currentTheme={currentTheme}
                                      iconPosition='end'
                                      height={"32px"}
                                      borderRadiusType='both'
                                      variant="tint"
                                      // color="#009688"
                                      tooltip={`Issue ${cover?.cover_name_xx} to ${selectedPolicyRisk?.pr_vehicle_regn}`}
                                      endIcon={<AiFillSafetyCertificate />}
                                      onClick={() => {
                                        try {

                                          if (!quoteData?.pl_no) {
                                            setObjectToAction({
                                              object_id: cover?._id,
                                              action_text: (t('setPolicyNoFirst')),
                                              new_doc_status: "setPolicyNoFirst",
                                              param1: cover?.cover_name_xx
                                            });
                                            setConfirmDialogAction("setPolicyNoFirst");
                                            setIsConfirmDialogOpen(true);
                                            return;
                                          }

                                          if (!quoteData?.insured_details_xx?.ent_phone_no) {
                                            setNotifyDialogTitle(t('note'));
                                            setNotifyDialogText(t('mandatoryParam2', { param1: t('insured'), param2: t('phoneNo') }));
                                            setIsNotifyDialogOpen(true);
                                            return;
                                          }

                                          if (!quoteData?.insured_details_xx?.ent_tax_no) {
                                            setNotifyDialogTitle(t('note'));
                                            setNotifyDialogText(t('mandatoryParam2', { param1: t('insured'), param2: t('taxPin') }));
                                            setIsNotifyDialogOpen(true);
                                            return;
                                          }

                                          if (!cover?.dmvic_code_xx) {
                                            setNotifyDialogTitle(t('note'));
                                            setNotifyDialogText(t('dmvicCodeMissing', { param1: cover?.cover_name_xx }));
                                            setIsNotifyDialogOpen(true);
                                            return;
                                          }

                                          if (!cover?.dmvic_cover_xx) {
                                            setNotifyDialogTitle(t('note'));
                                            setNotifyDialogText(t('dmvicCoverMissing', { param1: cover?.cover_name_xx }));
                                            setIsNotifyDialogOpen(true);
                                            return;
                                          }

                                          if (cover?.dmvic_cover_xx) {
                                            if (cover?.dmvic_cover_xx === "A_Single") {
                                              if (!selectedPolicyRisk?.pr_vehicle_cert) {
                                                setNotifyDialogTitle(t('note'));
                                                setNotifyDialogText(t('mandatoryParam2', { param1: t('certificateType'), param2: t('mandatory') }));
                                                setIsNotifyDialogOpen(true);
                                                return;
                                              }
                                            } else if (cover?.dmvic_cover_xx === "B_Single") {
                                              if (!selectedPolicyRisk?.pr_vehicle_type) {
                                                setNotifyDialogTitle(t('note'));
                                                setNotifyDialogText(t('mandatoryParam2', { param1: t('vehicleType'), param2: t('mandatory') }));
                                                setIsNotifyDialogOpen(true);
                                                return;
                                              }
                                            } else if (cover?.dmvic_cover_xx === "C_Single") {
                                              if (!selectedPolicyRisk?.pr_vehicle_body) {
                                                setNotifyDialogTitle(t('note'));
                                                setNotifyDialogText(t('mandatoryParam2', { param1: t('bodyType'), param2: t('mandatory') }));
                                                setIsNotifyDialogOpen(true);
                                                return;
                                              }
                                              if (!selectedPolicyRisk?.pr_vehicle_chassis) {
                                                setNotifyDialogTitle(t('note'));
                                                setNotifyDialogText(t('mandatoryParam2', { param1: t('chassisNo'), param2: t('mandatory') }));
                                                setIsNotifyDialogOpen(true);
                                                return;
                                              }
                                            } else if (cover?.dmvic_cover_xx === "D_Single") {
                                              if (!selectedPolicyRisk?.pr_vehicle_cert) {
                                                setNotifyDialogTitle(t('note'));
                                                setNotifyDialogText(t('mandatoryParam2', { param1: t('certificateType'), param2: t('mandatory') }));
                                                setIsNotifyDialogOpen(true);
                                                return;
                                              }
                                            }
                                          }

                                          const vehicleValue = policyRiskCoverSmi.filter(item => {
                                            const desc = item.smi_desc.replace(/\s+/g, "").toLowerCase();
                                            return desc === "vehiclevalue";
                                          });

                                          setVehicleValue(vehicleValue.length > 0 ? vehicleValue[0].smi_si_fc : "");
                                          setCertificateEmail(quoteData?.insured_details_xx?.ent_email);
                                          setSelectedPolicyRiskCover(cover);
                                          const filteredTypes = vehicleCertTypes.filter((val) => val?.grouping === getPrefixSafe(cover?.dmvic_cover_xx));
                                          setFilteredCertTypes(filteredTypes);
                                          setIsIssueCertOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    >
                                      {t('issueCertificate')}
                                    </CustomLoadingButton>
                                  </div>}
                              </div>
                            </div>}
                        </div>
                      ))}
                    </div>
                  )}
                  <motion.div
                    className="table-content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow" style={{ fontWeight: "bold", }}>
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <span>#</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('smi').toUpperCase()}</span>
                              {quoteData?.document_enabled_xx === "Y" &&
                                selectedSubClass?.ps_endorsed === "Y" &&
                                getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_add_smi") === "Y" &&
                                policyRiskCovers?.length > 0 &&
                                selectedPolicyRiskCover?.rc_cover_type === "normal" &&
                                <div style={{ display: "flex", flexDirection: "row", gap: "1px", marginLeft: "5px" }}>
                                  <CustomButtonSmallDarkBg
                                    borderRadiusType='both'
                                    currentTheme={currentTheme}
                                    onClick={addNewSmiRow}
                                    startIcon={<AddIcon />}
                                    isCurrent={true}
                                  >
                                    {t('add').toUpperCase()}
                                  </CustomButtonSmallDarkBg>
                                  {/* <CustomButtonSmallDarkBg
                                borderRadiusType='right'
                                currentTheme={currentTheme}
                                startIcon={<LibraryAddIcon />}
                                isCurrent={true}
                              >
                                {t('pick').toUpperCase()}
                              </CustomButtonSmallDarkBg> */}
                                </div>}
                            </TableCell>
                            {selectedSubClass?.show_qty_xx === "Y" &&
                              <TableCell className="table-cell right" style={{ maxWidth: "70px" }}>
                                <span className='sub-title'>{t('qty').toUpperCase()}</span>
                              </TableCell>}
                            <TableCell className="table-cell right" style={{ maxWidth: "160px" }}>
                              {selectedPolicyRiskCover?.rc_cover_type !== "death benefit" && <span>{`${t('sumInsured').toUpperCase()} [${quoteData?.pl_cur_code}]`}</span>}
                              {selectedPolicyRiskCover?.rc_cover_type === "death benefit" && <span>{`${t('deathBenefit').toUpperCase()} [${quoteData?.pl_cur_code}]`}</span>}
                            </TableCell>
                            {/* <TableCell className="table-cell" style={{ maxWidth: "150px", display: 'flex', justifyContent: 'flex-end' }}>
                        <span>FCL LIMIT</span>
                      </TableCell> */}
                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                              <span>{t('rate').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                              <span>{t('per').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "160px" }}>
                              <span>{`${t('premium').toUpperCase()} [${quoteData?.pl_cur_code}]`}</span>
                            </TableCell>
                            {quoteData?.document_enabled_xx === "Y" &&
                              selectedSubClass?.ps_endorsed === "Y" &&
                              selectedPolicyRisk?.pr_endorsed === "Y" &&
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {policyRiskCoverSmi?.map((smi, index) => (
                            <TableRow
                              key={smi._id}
                              className={`${selectedPolicyRiskCoverSmi?._id === smi?._id ? "tablerow current" : "tablerow"}`}
                              style={{ alignItems: "flex-start" }}
                              onClick={() => setSelectedPolicyRiskCoverSmi(smi)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                <span>{index + 1}</span>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                {selectedPolicyRiskCover?.rc_cover_type !== "death benefit"
                                  &&
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    {quoteData?.document_enabled_xx === "Y" &&
                                      selectedSubClass?.ps_endorsed === "Y" &&
                                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                                      <input
                                        id="smi_desc"
                                        value={smi?.smi_desc}
                                        onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_desc')}
                                        style={{ width: "100%" }}
                                        className="form-input-item table"
                                        onBlur={() => handleSmiBlur(smi._id, "smi_desc")}
                                        disabled={quoteData?.document_enabled_xx === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_smi_desc_edit") === "N"}
                                      /> :
                                      <h1 className='normal-title'>{smi?.smi_desc}</h1>
                                    }
                                  </div>
                                }
                                {selectedPolicyRiskCover?.rc_cover_type === "death benefit" && <span className='normal-title'>{smi?.smi_desc}</span>}

                                {/* <FormControlLabel
                            control={
                              <Checkbox
                                checked={smi.smi_add_to_si === 'Y'}
                                onChange={(e) => handleCheckboxChange(e, smi._id)}
                                disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                                sx={{
                                  color: '#9c27b0',
                                  '&.Mui-checked': {
                                    color: '#9c27b0',
                                  },
                                  padding: 0,
                                  margin: 0
                                }}
                              />
                            }
                            label="Add to Sum Insured"
                            style={{ marginLeft: 0 }}
                          /> */}
                              </TableCell>
                              {selectedSubClass?.show_qty_xx === "Y" &&
                                <TableCell className="table-cell right" style={{ maxWidth: "70px" }}>
                                  <div className="input-item-with-label">
                                    {quoteData?.document_enabled_xx === "Y" &&
                                      selectedSubClass?.ps_endorsed === "Y" &&
                                      selectedPolicyRisk?.pr_endorsed === "Y" ?
                                      <input
                                        id="smi_qty"
                                        type="number"
                                        value={smi.smi_qty}
                                        onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_qty')}
                                        className="form-input-item table"
                                        style={{ width: "100%", textAlign: "right" }}
                                        onBlur={() => handleSmiBlur(smi._id, "smi_qty")}
                                      /> : <h1 className='normal-title'>{numeral(smi.smi_qty).format("0,0")}</h1>}
                                  </div>
                                </TableCell>}
                              <TableCell className="table-cell right" style={{ maxWidth: "160px", }}>
                                <div className="input-item-with-label">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" &&
                                    getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_smi_si_edit") === "Y" ?
                                    <input
                                      id="smi_si_fc"
                                      type="text"
                                      value={smi.smi_si_fc}
                                      onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_si_fc')}
                                      className="form-input-item table"
                                      style={{ width: "100%", textAlign: "right" }}
                                      onBlur={() => handleSmiBlur(smi._id, "smi_si_fc")}
                                    /> : <h1 className='normal-title'>{numeral(smi.smi_si_fc).format("0,0.00")}</h1>}
                                </div>
                              </TableCell>
                              {/* <TableCell className="table-cell" style={{ maxWidth: "150px" }}>
                          <input
                            id="smi_fcl_value_fc"
                            type="text"
                            value={smi.smi_fcl_value_fc}
                            onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_fcl_value_fc')}
                            className="form-input-item"
                            style={{ width: "100%", textAlign: "right" }}
                            onBlur={() => {
                              handleSmiBlur(smi._id, "smi_fcl_value_fc");
                            }}
                            disabled={quoteData?.document_enabled_xx === "N" && selectedSubClass?.ps_endorsed === "N"}
                          />
                          <span style={{ height: "28px", color: "transparent" }}>1</span>
                        </TableCell> */}
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <div className="input-item-with-label">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" &&
                                    getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_smi_rate_edit") === "Y" ?
                                    <input
                                      id="smi_rate"
                                      type="text"
                                      value={smi.smi_rate}
                                      onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_rate')}
                                      className="form-input-item table"
                                      style={{ width: "100%", textAlign: "right" }}
                                      onBlur={() => handleSmiBlur(smi._id, "smi_rate")}
                                    /> : <h1 className='normal-title'>{numeral(smi.smi_rate).format("0,0.0000")}</h1>}
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <div className="input-item-with-label">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" &&
                                    getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_smi_rateper_edit") === "Y" ?
                                    <input
                                      id="smi_rate_per"
                                      type="text"
                                      value={smi.smi_rate_per}
                                      onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_rate_per')}
                                      className="form-input-item table"
                                      style={{ width: "100%", textAlign: "right" }}
                                      onBlur={() => {
                                        handleSmiBlur(smi._id, "smi_rate_per");
                                      }}
                                    /> : <h1 className='normal-title'>{numeral(smi.smi_rate_per).format("0,0.00")}</h1>}
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "160px" }}>
                                <div className="input-item-with-label">
                                  {quoteData?.document_enabled_xx === "Y" &&
                                    selectedSubClass?.ps_endorsed === "Y" &&
                                    selectedPolicyRisk?.pr_endorsed === "Y" &&
                                    getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_smi_premium_edit") === "Y" ?
                                    <input
                                      id="smi_premium_fc"
                                      type="text"
                                      value={smi.smi_premium_fc}
                                      onChange={(e) => handleSmiInputChange(e, smi._id, 'smi_premium_fc')}
                                      className="form-input-item table"
                                      style={{ width: "100%", textAlign: "right" }}
                                      onBlur={() => handleSmiBlur(smi._id, "smi_premium_fc")}
                                    /> : <h1 className='normal-title'>{numeral(smi.smi_premium_fc).format("0,0.00")}</h1>}
                                </div>
                                {smi?.smi_calc_type === "Prorata" && <span className='sub-title soft'>{`${t('using')?.toLowerCase()} ${smi?.smi_calc_type?.toLowerCase()}`}</span>}
                              </TableCell>
                              {quoteData?.document_enabled_xx === "Y" &&
                                selectedSubClass?.ps_endorsed === "Y" &&
                                selectedPolicyRisk?.pr_endorsed === "Y" &&
                                <TableCell className="table-cell center" style={{ maxWidth: "80px", flexDirection: "row", gap: "5px" }}>
                                  <CircularButton currentTheme={currentTheme}
                                    onClick={() => setSelectedSmiForEdit(smi)}
                                    icon={<MdEdit />}
                                    width={"30px"}
                                    height={"30px"} />
                                  {getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_delete_smi") === "Y" &&
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      color="#D32F2F"
                                      onClick={() => {
                                        try {
                                          setObjectToAction({
                                            object_id: smi._id,
                                            action_text: `Remove ${smi?.smi_name_xx}?`,
                                            new_doc_status: "deleteSmi",
                                          });

                                          setConfirmDialogAction("deleteSmi");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      icon={<MdDelete />}
                                      width={"30px"}
                                      height={"30px"} />}
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Toggle switch component */}
                        {policyRiskCoverSmi?.length > 0 &&
                          <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            {quoteData?.document_enabled_xx === "Y" && selectedSubClass?.ps_endorsed === "Y" ?
                              <ToggleSwitch
                                id="show_help"
                                value={showHelp}
                                onChange={setShowHelp}
                                label={"SHOW PREMIUM CALCULATION NOTES"}
                                labelPosition="end"
                                labelWidth="max-content"
                                disabled={false}
                                border="Y"
                                style={{ width: "max-content" }}
                              /> : <span>{" "}</span>}
                            {quoteData?.pl_term_code_xx?.term_death_level !== "level" &&
                              selectedPolicyRiskCoverSmi?.smi_type === "death benefit" &&
                              <CustomButtonSmallDarkBg
                                currentTheme={currentTheme}
                                iconPosition='end'
                                borderRadiusType="both"
                                variant="tint"
                                color="#7CB342"
                                tooltip={"Show movement of death benefit"}
                                endIcon={<CalculateIcon />}
                                onClick={() => setShowMovement(!showMovement)}
                              >
                                {t('showBenefitMovement')}
                              </CustomButtonSmallDarkBg>}
                          </div>
                        }
                        {/* This is a placeholder span to prevent pagination from aligning to left when no SMI has been created */}
                        {policyRiskCoverSmi?.length === 0 && <span>{" "}</span>}
                        {/* Pagination controls */}
                        {policyRiskCoverSmi?.length > rowsPerPage &&
                          <TablePagination
                            rowsPerPageOptions={[5]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleSmiRowsPerPage}
                            component="div"
                            count={policyRiskCoverSmi?.length}
                            rows={policyRiskCoverSmi}
                            page={page}
                            onPageChange={handleSmiChangePage}
                          />}
                      </div>
                    </TableContainer>
                  </motion.div>
                  {policyRiskCovers?.length > 0 && showHelp === "Y" && <hr className='separator-h' />}
                  {policyRiskCovers?.length > 0 && showHelp === "Y" &&
                    <motion.div className="notes-content"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1, transition: { duration: 1 } }}
                      exit={{ opacity: 0, transition: { duration: 1 } }}
                    >
                      <div className="notes-title">
                        <h1 className='main-title'>{t('pleaseNote').toUpperCase()}</h1>
                      </div>
                      {/* <PleaseNote /> */}
                      <div className="notes-list">
                        {notes.map((note, index) => (
                          <span key={index}>
                            {index + 1}. {renderNote(note)}
                          </span>
                        ))}
                      </div>
                    </motion.div>}
                  {policyRiskCovers?.length > 0 &&
                    showMovement &&
                    <motion.div
                      style={{ marginTop: "5px" }}
                      key={showMovement}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1, transition: { duration: 1 } }}
                      exit={{ opacity: 0, transition: { duration: 1 } }}
                    >
                      <UwDbMovement death_benefit={selectedPolicyRiskCoverSmi?.smi_si_fc} factor={0} start_year={1} interest_rate={0} term_death_level={quoteData?.pl_term_code_xx?.term_death_level} term_years={quoteData?.pl_term_years} from_date={moment(quoteData?.pl_fm_date).format("YYYY-MM-DD")} />
                    </motion.div>}
                </motion.div>}
            </motion.div>
          )}
          {selectedSmiForEdit && (
            <div className="edit-smi-dialog">
              <div className="edit-smi-dialog-wrapper">
                <div className="edit-smi-dialog-navbar">
                  <span>{`${t('edit').toUpperCase()} ${selectedSmiForEdit?.smi_name_xx}`}</span>
                  <CircularButton currentTheme={currentTheme} onClick={() => setSelectedSmiForEdit(null)} icon={<MdClose />} width={"30px"} height={"30px"} />
                </div>
                <div className="edit-smi-dialog-content">
                  <div
                    className="input-item-with-label"
                    style={{ width: "100%" }}
                  >
                    <label htmlFor="smi_name_xx" style={{ width: "100px" }}>
                      {t('smi').toUpperCase()}
                    </label>
                    <input
                      id="smi_name_xx"
                      name="smi_name_xx"
                      type="text"
                      placeholder={t('smi').toUpperCase()}
                      value={selectedSmiForEdit?.smi_name_xx}
                      className="form-input-item"
                      onChange={(e) => handleSmiEditChange("smi_name", e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="edit-smi-row">
                    <div className="column1">
                      <div className="input-item-with-label"  >
                        <label
                          htmlFor="smi_fcl_value_fc"
                          style={{ width: "82px" }}
                        >
                          {t('fcl').toUpperCase()}
                        </label>
                        <input
                          id="smi_fcl_value_fc"
                          name="smi_fcl_value_fc"
                          type="text"
                          placeholder={t('fcl').toUpperCase()}
                          value={selectedSmiForEdit?.smi_fcl_value_fc}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_fcl_value_fc", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "200px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                    <div className="column2">
                      <div
                        className="input-item-with-label"
                        style={{ width: "max-content" }}
                      >
                        <label htmlFor="smi_qty" style={{ width: "max-content" }}>
                          {t('qty').toUpperCase()}
                        </label>
                        <input
                          id="smi_qty"
                          name="smi_qty"
                          type="text"
                          placeholder={t('qty').toUpperCase()}
                          value={selectedSmiForEdit?.smi_qty}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_qty", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "120px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="edit-smi-row">
                    <div className="column1">
                      <div className="input-item-with-label"  >
                        <label
                          htmlFor="smi_si_fc"
                          style={{ width: "82px" }}
                        >
                          {t('si').toUpperCase()}
                        </label>
                        <input
                          id="smi_si_fc"
                          name="smi_si_fc"
                          type="text"
                          placeholder={t('sumInsured').toUpperCase()}
                          value={selectedSmiForEdit?.smi_si_fc}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_si_fc", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "200px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                    <div className="column2">
                      <div
                        className="input-item-with-label"
                        style={{ width: "max-content" }}
                      >
                        <label htmlFor="smi_rate" style={{ width: "max-content" }}>
                          {t('rate').toUpperCase()}
                        </label>
                        <input
                          id="smi_rate"
                          name="smi_rate"
                          type="text"
                          placeholder={t('rate').toUpperCase()}
                          value={selectedSmiForEdit?.smi_rate}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_rate", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "120px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="edit-smi-row">
                    <div className="column1">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="smi_premium_fc"
                          style={{ width: "82px" }}
                        >
                          {t('premium').toUpperCase()}
                        </label>
                        <input
                          id="smi_premium_fc"
                          name="smi_premium_fc"
                          type="text"
                          placeholder={t('premium').toUpperCase()}
                          value={selectedSmiForEdit?.smi_premium_fc}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_premium_fc", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "200px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                    <div className="column2">
                      <div
                        className="input-item-with-label"
                        style={{ width: "max-content" }}
                      >
                        <label htmlFor="smi_rate_per" style={{ width: "max-content" }}>
                          {t('per').toUpperCase()}
                        </label>
                        <input
                          id="smi_rate_per"
                          name="smi_rate_per"
                          type="text"
                          placeholder={t('per').toUpperCase()}
                          value={selectedSmiForEdit?.smi_rate_per}
                          className="form-input-item"
                          onChange={(e) => handleSmiEditChange("smi_rate_per", e.target.value)}
                          onBlur={handleSmiForBlur}
                          style={{ width: "120px", textAlign: "right" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="edit-smi-row">
                    <div className="column1">
                      <ToggleSwitch
                        id="smi_add_to_si"
                        value={selectedSmiForEdit?.smi_add_to_si}
                        onChange={(val) => handleSmiEditChange("smi_add_to_si", val)}
                        label={t('addToSi').toUpperCase()}
                        labelWidth="82px"
                        labelPosition="start"
                        border="N"
                        style={{ width: "max-content" }}
                      />
                    </div>
                    <div className="column2">
                      <div className="input-item-with-label">
                        <label htmlFor="smi_calc_type" style={{ width: "100px" }}>{t('type').toUpperCase()}</label>
                        <Select
                          id="smi_calc_type"
                          name="smi_calc_type"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="120px"
                          value={calcultionTypes.find((option) => option.value === selectedSmiForEdit?.smi_calc_type) || null}
                          onChange={(selectedOption) => handleSmiEditChange("smi_calc_type", selectedOption.value)}
                          options={calcultionTypes}
                          placeholder={t('type').toUpperCase()}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="input-item-with-label"
                    style={{ width: "100%" }}
                  >
                    <label htmlFor="smi_desc" style={{ width: "100px", alignSelf: "flex-start" }}>
                      {t('desc').toUpperCase()}
                    </label>
                    <textarea
                      id="smi_desc"
                      name="smi_desc"
                      type="text"
                      placeholder={t('description').toUpperCase()}
                      value={selectedSmiForEdit?.smi_desc}
                      rows={4}
                      className="form-input-item"
                      onChange={(e) => handleSmiEditChange("smi_desc", e.target.value)}
                      onBlur={handleSmiForBlur}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                {/* <div>{`DocId ${selectedSmiForEdit?._id} and prev ${selectedSmiForEdit?.smi_prev_policy_docid}`}</div> */}
                <div className="edit-smi-dialog-action">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    borderRadiusType="both"
                    variant="tint"
                    color="#f55656"
                    iconPosition="end"
                    onClick={() => setSelectedSmiForEdit(null)}>
                    {t('cancel')}
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#00D37F"
                    onClick={handleSmiEditUpdate}>
                    {t('update')}
                  </CustomLoadingButton>
                </div>
              </div>
            </div>
          )}
          {showCoverForEditing && (
            <div className="edit-smi-dialog">
              <div className="edit-smi-dialog-wrapper">
                <div className="edit-smi-dialog-navbar">
                  <span>{`${t('edit').toUpperCase()} ${selectedPolicyRiskCover?.cover_name_xx}`}</span>
                  <CircularButton currentTheme={currentTheme} onClick={() => setShowCoverForEditing(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="edit-smi-dialog-content">
                  <div className="input-item-with-label">
                    <textarea
                      id="edit_cover_desc"
                      name="edit_cover_desc"
                      type="text"
                      className="form-input-item"
                      placeholder={t('description').toUpperCase()}
                      value={selectedPolicyRiskCover?.rc_desc}
                      rows={10}
                      style={{
                        width: "95%",
                        height: "max-content",
                        padding: "8px 12px",
                        margin: "0px 20px",
                      }}
                      onChange={(e) => {
                        try {
                          setSelectedPolicyRiskCover({
                            ...selectedPolicyRiskCover,
                            rc_desc: e.target.value,
                          });
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="edit-smi-dialog-action">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    borderRadiusType="left"
                    iconPosition="end"
                    onClick={() => setShowCoverForEditing(false)}>
                    {t('cancel')}
                  </CustomLoadingButton>
                  <CustomLoadingButton currentTheme={currentTheme}
                    borderRadiusType="right"
                    iconPosition="end"
                    onClick={handleCoverEditUpdate}>
                    {t('update')}
                  </CustomLoadingButton>
                </div>
              </div>
            </div>
          )}
          {showAddSysCodes && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.5 } }}
              exit={{ opacity: 0, transition: { duration: 0.5 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <div className="overlay-navbar-left">
                    <div className="search-input-wrapper">
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        value={sysCodeSearchTerm}
                        onChange={(e) => setSysCodeSearchTerm(e.target.value)}
                      />
                      {sysCodeSearchTerm.length > 0 && (
                        <MdClose
                          onClick={() => setSysCodeSearchTerm("")}
                          className="search-input-icon"
                        />
                      )}
                    </div>
                  </div>
                  <div className="overlay-navbar-right">
                    <CircularButton
                      currentTheme={currentTheme} onClick={() => setShowAddSysCodes(false)}
                      icon={<MdClose />}
                      width={"35px"}
                      height={"35px"} />
                  </div>
                </div>
                <div className="overlay-content">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                      className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableBody className="tablebody">
                          {slicedSysCodes.map((sc, index) => (
                            <TableRow key={sc?._id} className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", maxWidth: "550px" }}>
                                {sc?.sys_name}
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {
                                      const res = await newRequest.post(
                                        "/uwPolicyRisk/addOtherAttr",
                                        {
                                          risk_docid: selectedPolicyRisk?._id,
                                          attribute_code: sc?.sys_code,
                                          attribute_desc: sc?.sys_name,
                                          attribute_yn: "N",
                                          attribute_remarks: sc?.sys_desc,
                                          createdBy: currentUser.usr_id,
                                        }
                                      );

                                      if (res.data === "exists") {
                                        showToast(`Attribute ${sc?.sys_name} already attached`, "error");
                                      } else {
                                        showToast(`Attribute ${sc?.sys_name} added`, "success");
                                      }
                                      fetchOtherAttributes();
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  color="#2E7D32"
                                  icon={<MdAdd />}
                                  width={"30px"}
                                  height={"30px"} />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {filteredSysCodesData.length > rowsPerPageSysCode &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPageSysCode}
                          onRowsPerPageChange={handleSysCodeRowsPerPage}
                          component="div"
                          count={filteredSysCodesData.length}
                          rows={filteredSysCodesData}
                          page={sysCodePage}
                          onPageChange={handleSysCodePageChange}
                        />}
                    </TableContainer>
                  </div>
                </div>
              </div>
            </motion.div>
          )}

          {placesDialogOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}>
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <h1 className="main-title">{t('place')}</h1>
                  <CircularButton currentTheme={currentTheme} onClick={() => setPlacesDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <GooglePlacesSelect onPlaceSelect={handlePlaceSelect} />
                  {selectedPlace && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "10px" }}>
                      {/* <hr className='separator-h' /> */}
                      <span className='sub-title'>{`${t('place')} : ${selectedPlace.label}`}</span>
                      <span className='sub-title'>{`${t('latitude')} : ${selectedPlace.coordinates.lat}`}</span>
                      <span className='sub-title'>{`${t('longitude')} : ${selectedPlace.coordinates.lng}`}</span>
                    </div>
                  )}
                </div>
                <div className="overlay-actions">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    borderRadiusType="both"
                    variant="tint"
                    color="#1976D2"
                    tooltip={`${t('select')} ${selectedPlace?.label}`}
                    iconPosition="start"
                    startIcon={<RiMapPin5Fill />}
                    onClick={() => {
                      try {
                        setPrLatitude(selectedPlace?.coordinates.lat);
                        setPrLongitude(selectedPlace?.coordinates.lng);
                        setPrPlaceName(selectedPlace?.label);
                        setPlacesDialogOpen(false);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    disabled={!selectedPlace}
                  >{t('select').toUpperCase()}</CustomLoadingButton>
                </div>
              </div>
            </motion.div>
          )}
          {ratesComparisonDialog && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}  >
              <div className="overlay-wrapper" style={{ display: "flex", flexDirection: "column", width: "700px" }} >
                <div className="overlay-navbar">
                  <span className="main-title">{t('compare')}</span>
                  <CircularButton currentTheme={currentTheme} onClick={() => setRatesComparisonDialog(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <motion.div
                    className="table-content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow" style={{ fontWeight: "bold", }}>
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}  >
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}  >
                              {t('carrier')}
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}  >
                              {t('comm')}
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}  >
                              {t('premium')}
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}  >
                              {t('pick')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {paginatedRates.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedCommRate?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedCommRate(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}  >
                                {comparePage * rowsPerPageCompare + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}  >
                                {row?.ent_name_xx}
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "120px" }}  >
                                {row?.cr_comm_rate}
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "120px" }}  >
                                {row?.cr_prem_rate}
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}  >
                                <CircularButton currentTheme={currentTheme} onClick={() => handlePickCarrierRates(row)} icon={<IoCheckmarkDoneOutline />} width={"35px"} height={"35px"} />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {ratesComparison.length > rowsPerPageCompare &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPageCompare}
                          onRowsPerPageChange={handleCompareRowsPerPage}
                          component="div"
                          count={ratesComparison?.length}
                          rows={ratesComparison}
                          page={comparePage}
                          onPageChange={handleComparePageChange}
                        />}
                    </TableContainer>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          )}
          {/* Confirm Dialog */}
          <ConfirmDialog
            isOpen={isConfirmDialogOpen}
            onClose={() => setIsConfirmDialogOpen(false)}
            onConfirm={handleConfirm}
            dialogTitle={t("confirmation")}
            dialogContent={<p dangerouslySetInnerHTML={{ __html: objectToAction.action_text }} />}
          />
          {/* Dialog to notify user about changes being saved */}
          <Dialog open={isNotifyDialogOpen}
            onClose={() => setIsNotifyDialogOpen(false)}
            PaperProps={{
              sx: {
                backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                color: currentTheme === "dark" ? "#fff" : "#000",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                },
              },
            }}>
            <DialogTitle>{notifyDialogTitle}</DialogTitle>
            <DialogContent>
              <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
            </DialogContent>
            <DialogActions>
              <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
            </DialogActions>
          </Dialog>
          {isProductScOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.5 } }}
              exit={{ opacity: 0, transition: { duration: 0.5 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span className="main-title">{t('subClasses').toUpperCase()}</span>
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => setIsProductScOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <div className="table-content" style={{ width: "600px" }}>
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                              <div className="search-input-wrapper" style={{ width: "90%" }}>
                                <FiSearch className="search-input-icon" />
                                <input
                                  className="search-input"
                                  type="text"
                                  placeholder={t('search')}
                                  value={searchProductSubClass}
                                  onChange={(e) => {
                                    try {
                                      setSearchProductSubClass(e.target.value);
                                      if (e.target.value) {
                                        setProductScPage(0);
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                />
                                {searchProductSubClass.length > 0 && (
                                  <MdClose
                                    onClick={(e) => setSearchProductSubClass("")}
                                    className="search-input-icon"
                                  />
                                )}
                                {searchProductSubClass.length === 0 && (
                                  <span className="search-input-icon" />
                                )}
                              </div>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <span>{t('action').toUpperCase()}</span>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {slicedProductScData?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedProductSubClass?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={async () => setSelectedProductSubClass(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                <span>{productScPage * rowsPerPageProductSc + index + 1}</span>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                                <h1 className="sub-title">{row?.sc_name_xx}</h1>
                                <h1 className="sub-title soft">{`${row?.mc_code_xx} : ${row?.ps_mc_code}`}</h1>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <CircularButton currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {

                                      const res = await newRequest.post(
                                        "/uwPolicySc/add",
                                        {
                                          ps_policy_docid: quoteData?._id,
                                          ps_risk_note_no: quoteData?.pl_risk_note_no,
                                          ps_mc_code: row?.ps_mc_code,
                                          ps_sc_code: row?.ps_sc_code,
                                          ps_end_index: quoteData?.pl_end_index
                                        }
                                      );

                                      if (res.data.msg === "added") {
                                        setPolicySubClasses((prevData) => [...prevData, res.data?.doc]);
                                        showToast(t('added'), "success");
                                      } else if (res.data.msg === "exists") {
                                        showToast(t('alreadyExists', { param1: row?.sc_name_xx }), "warning");
                                      } else {
                                        showToast(`Unable to add sub class`, "error");
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  color="#0ea5a4"
                                  icon={<MdAdd />}
                                  width={"35px"}
                                  height={"35px"} />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {productSubClasses.length > rowsPerPageProductSc &&
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={rowsPerPageProductSc}
                          onRowsPerPageChange={handleProductScChangeRowsPerPage}
                          component="div"
                          count={productSubClasses?.length}
                          page={productScPage}
                          onPageChange={handleProductScChangePage}
                        />}
                    </TableContainer>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
          {isIssueCertOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}>
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <h1 className="main-title">{t('issueCertificate')}</h1>
                  <CircularButton currentTheme={currentTheme} onClick={() => setIsIssueCertOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <div className="cert-issue-dialog">
                    <div className="cert-issue-left">
                      <div className="input-item-with-label">
                        <label htmlFor="insured"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('insured').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{quoteData?.insured_details_xx?.ent_name}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="insuredPhoneNo"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('phoneNo').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{quoteData?.insured_details_xx?.ent_phone_no}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="insuredEmail"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('email').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{quoteData?.insured_details_xx?.ent_email}</span>
                      </div>
                    </div>
                    <div className="cert-issue-right">
                      <div className="input-item-with-label">
                        <label htmlFor="policyNo"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('policyNo').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{quoteData?.pl_no}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="from"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('startDate').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "150px" }}>{moment(selectedPolicyRisk?.pr_fm_date).format("DD-MMM-YYYY")}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="to"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('expiryDate').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "150px" }}>{moment(selectedPolicyRisk?.pr_to_date).format("DD-MMM-YYYY")}</span>
                      </div>
                    </div>
                  </div>
                  <hr className='separator-h' style={{ margin: "1px 0px" }} />
                  <span className='normal-title'>{t('vehicleDetails')}</span>
                  <div className="cert-issue-dialog">
                    <div className="cert-issue-left">
                      <div className="input-item-with-label">
                        <label htmlFor="regnNo"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('regnNo').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{selectedPolicyRisk?.pr_vehicle_regn}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="chassisNo"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('chassisNo').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{selectedPolicyRisk?.pr_vehicle_chassis}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="engineNo"
                          style={{ width: "100px" }}
                          className="form-dropdown-label">
                          {t('engineNo').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "250px" }}>{selectedPolicyRisk?.pr_vehicle_engine}</span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div className="input-item-with-label">
                          <label htmlFor="pax"
                            style={{ width: "100px" }}
                            className="form-dropdown-label">
                            {t('passangers').toUpperCase()}
                          </label>
                          <span className='normal-title' style={{ width: "max-content" }}>{selectedPolicyRisk?.pr_vehicle_passangers}</span>
                        </div>
                        <span className='normal-title' style={{ width: "2px", margin: "0px 10px" }}>|</span>
                        <div className="input-item-with-label">
                          <label htmlFor="yom"
                            style={{ width: "max-content" }}
                            className="form-dropdown-label">
                            {t('yom').toUpperCase()}
                          </label>
                          <span className='normal-title' style={{ width: "max-content" }}>{selectedPolicyRisk?.pr_vehicle_yom}</span>
                        </div>
                      </div>
                    </div>
                    <div className="cert-issue-right">
                      <div className="input-item-with-label">
                        <label htmlFor="bodyType"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('bodyType').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "200px" }}>{selectedPolicyRisk?.pr_vehicle_body}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="vehicleMake"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('vehicleMake').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "200px" }}>{selectedPolicyRisk?.pr_vehicle_make}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="vehicleModel"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {t('vehicleModel').toUpperCase()}
                        </label>
                        <span className='normal-title' style={{ width: "200px" }}>{selectedPolicyRisk?.pr_vehicle_model}</span>
                      </div>
                      <div className="input-item-with-label">
                        <label htmlFor="sumInsured"
                          style={{ width: "max-content" }}
                          className="form-dropdown-label">
                          {`${t('sumInsured').toUpperCase()} [${quoteData?.pl_cur_code}]`}
                        </label>
                        <span className='normal-title' style={{ width: "150px" }}>{vehicleValue}</span>
                      </div>
                    </div>
                  </div>
                  <hr className='separator-h' style={{ margin: "1px 0px" }} />
                  <span className='normal-title'>{t('certificateNote')}</span>
                </div>
                <div className="overlay-actions">
                  <div className="input-item-with-label" style={{ marginRight: "10px" }}>
                    <label htmlFor="certEmail"
                      style={{ width: "max-content" }}
                      className="form-dropdown-label">
                      {t('email').toUpperCase()}
                    </label>
                    <input
                      id="certEmail"
                      name="certEmail"
                      type="email"
                      placeholder={t('email').toUpperCase()}
                      value={certificateEmail}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      onChange={(e) => setCertificateEmail(e.target.value)}
                    />
                  </div>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    onClick={issueCertificate}
                  >{t('issue').toUpperCase()}
                  </CustomLoadingButton>
                </div>
              </div>
            </motion.div>
          )}
          {validationMsgDialog && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-content">
                  <ValidationMessages
                    messageData={validationMessagesResult}
                    onClose={() => setValidationMsgDialog(false)}
                    onFix={(row) => {/* focus field / navigate */ }}
                    onRemind={() => setValidationMsgDialog(false)}
                    onSupport={() => navigate("/support")}
                  />
                </div>
              </div>
            </motion.div>
          )}
          {pdfPreviewDialogOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper pdf">
                <div className="overlay-navbar">
                  <div className="left" style={{ padding: "5px" }}>
                    <h1 className="main-title">{t('preview').toUpperCase()}</h1>
                  </div>
                  <div className="right">
                    {/* <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType='left'
                  endIcon={<MdMarkEmailUnread />}
                  onClick={() => {
                    try {
                      const urlString = pdfUrl.toString().replace("blob:", "");
                      setEmailData({
                        to: quoteData?.insured_details_xx?.ent_email,
                        from: currentUser?.usr_org_name,
                        cc: '',
                        bcc: '',
                        subject: `Certificate No ${quoteData?.pl_risk_note_no}`,
                        show_attach: "N",
                        // attached_urls: [{ id: 1, url: urlString, name: `${quoteData?.pl_type} No ${quoteData?.pl_risk_note_no}`, binary_docid: "" }],
                        binary_docs: [{ doc_id: binaryDocid, doc_name: `${quoteData?.pl_type} No ${quoteData?.pl_risk_note_no}`, doc_type: "pdf", doc_url: "", doc_size_kb: 0 }],
                        doc_no: quoteData?.pl_risk_note_no,
                        doc_type: quoteData?.pl_type,
                        doc_id: quoteData?._id,
                        entity_codes: [quoteData?.insured_details_xx?.ent_code],
                        search_string: quoteData?.insured_details_xx?.ent_name + "," + quoteData?.pl_risk_note_no,
                        ...quoteData
                      });
                      setPdfPreviewDialogOpen(false);
                      setEmailDialogOpen(true);
                    } catch (error) {
                      console.log(error)
                    }
                  }}>
                  {t('email')}
                </CustomLoadingButton> */}
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType='both'
                      height={"36px"}
                      endIcon={<MdDownload />}
                      onClick={() => {
                        try {
                          const link = document.createElement('a');
                          link.href = pdfUrl;
                          link.download = `${selectedPolicyRisk?.pr_certificate_no}.pdf`;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        } catch (error) {
                          console.log(error)
                        }
                      }}>
                      {t('download')}
                    </CustomLoadingButton>
                    <hr className='separator-v' />
                    <CircularButton currentTheme={currentTheme} onClick={() => setPdfPreviewDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                  </div>
                </div>
                <div className="overlay-content-pdf" >
                  <PdfPreview pdfUrl={pdfUrl} />
                </div>
                <div className="overlay-actions">
                </div>
              </div>
            </motion.div>
          )}
          {isProcessing && (
            <motion.div
              className="processing-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="processing-wrapper">
                <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
                <ScaleLoader
                  color="var(--primary)"
                  height={50}
                  radius={8}
                  width={4}
                />
              </div>
            </motion.div>
          )}
          {/* email component */}
          {emailDialogOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <h1 className="main-title">{t('email').toUpperCase()}</h1>
                  <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} fetchEmails={fetchEmails} />
                </div>
              </div>
            </motion.div>
          )}
          {cancelReasonDialog && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}  >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span className="main-title">{`${t('cancelCertificate')} : ${selectedPolicyRisk?.pr_certificate_no}`}</span>
                  <CircularButton currentTheme={currentTheme}
                    onClick={() => {
                      setCancelReasonDialog(false);
                      setSelectedDmvicCancelReason(null);
                    }
                    } icon={<MdClose />}
                    width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <div className="input-item-with-label">
                    <Select
                      id="cancel_reason"
                      name="cancel_reason"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="400px"
                      value={selectedDmvicCancelReason}
                      onChange={(selectedOption) => setSelectedDmvicCancelReason(selectedOption)}
                      options={dmvicCancelReasons}
                      isSearchable={true}
                      placeholder={t('cancellationReason')}
                    />
                  </div>
                  <span className='caution-title'>{t('irreversibleAction')}</span>
                </div>
                <div className="overlay-actions">
                  <CustomLoadingButton onClick={async () => {
                    try {
                      if (!selectedDmvicCancelReason) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please select reason`);
                        setIsNotifyDialogOpen(true);
                        return;
                      }

                      setCancelReasonDialog(false);
                      setIsProcessingTitle(t('cancellingCertificateParam', { param1: selectedPolicyRisk?.pr_certificate_no }));
                      setIsProcessing(true);

                      const res = await newRequest.post("/dmvic/cancelCertificate",
                        {
                          certificateNo: selectedPolicyRisk?.pr_certificate_no,
                          cancelreasonid: selectedDmvicCancelReason?.value,
                          cancelreasontext: selectedDmvicCancelReason?.label,
                          riskDocid: selectedPolicyRisk?._id,
                        }
                      );
                      logData("cancellation", res.data);
                      console.log(`res.data?.result?.success ... ${res.data?.result?.success}`);
                      setIsProcessing(false);
                      if (res.data?.result?.success === true) {
                        resetCertificateFields();
                        showToast(t('certificateCancelled', { param1: selectedPolicyRisk?.pr_certificate_no }), "success");
                      } else {

                        const hasAlreadyCancelledError = Array.isArray(res.data?.result?.Error) &&
                          res.data?.result?.Error.some(err => err?.errorCode === "ER0010");

                        if (hasAlreadyCancelledError) {
                          // showToast(t('certificateAlreadyCancelled', { param1: selectedPolicyRisk?.pr_certificate_no }), "success");
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(t('certificateAlreadyCancelled', { param1: selectedPolicyRisk?.pr_certificate_no }));
                          setIsNotifyDialogOpen(true);
                          return;
                        } else {

                          let errorObject = {
                            result_status: "error",
                            result_msg: `Oops!, sorry ${currentUser?.usr_full_name}, following exceptions occured while cancelling certificate`,
                          };
                          const errors = res.data?.result?.Error?.map((val, index) => ({
                            msg_index: index + 1,
                            msg_no: val?.errorCode,
                            msg_text: val?.errorText,
                            msg_type: "error",
                          })) || [];
                          errorObject.result_msg_list = errors;
                          setValidationMessagesResult(errorObject);
                          setValidationMsgDialog(true);
                          return;
                        }
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}>
                    {t('cancelCertificate')}
                  </CustomLoadingButton>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}
    </>
  );
});

export default UwPolicyRisk;